var CalcEval = function () {};
// import '../layer/layer'
import {
  panelselection
} from './muiltSelectForEditor'
import {
  formulaGonshi
} from './Formula.js' 
let GdpVm = null;

const sendGdpThistoHelper = ( _this )=> {
  GdpVm = _this;
};
let designVm = null;

const sendDesignThistoHelper = ( _this )=> {
  designVm = _this;
};
var app_root = $('#app-root').val() || '/'; // 设置文件上传的路径
//复杂的计算方法（包含括号）
CalcEval.prototype.eval = function (str) {
  if (str == null) {
    return "";
  }
  if (typeof str != "string") { //转化成字符串
    str = str + ""
  }
  str = str.replace(/ /g, ''); //去掉空格
  var multObj = str.match(/\(([^\(\\)]*?)\)/g); //匹配括号
  //不断计算最底层括号的数据
  while (null != multObj) {
    var content = multObj[0] + "";
    var result = this.simpleEval(content.substr(1, content.length - 2));
    str = str.replace(multObj[0], result);
    multObj = str.match(/\(([^\(\\)]*?)\)/g);
  }
  return this.simpleEval(str);
}
//简单的计算方法，只有加减乘除
CalcEval.prototype.simpleEval = function (str) {
  if (str == null) {
    return "";
  }
  if (typeof str != "string") { //转化成字符串
    str = str + ""
  }
  if (str.indexOf('*-') > -1) {
    str = '-' + str.replace('*-', '*');
  }
  if (str.indexOf('/-') > -1) {
    str = '-' + str.replace('/-', '/');
  }
  if (str.indexOf('+-') > -1) {
    str = str.replace('+-', '-');
  }
  if (str.indexOf('--') > -1) {
    str = str.replace('--', '+');
  }

  var valueArray = new Array(); //值的数组
  var markArray = new Array(); //符号的数组
  var tempValue = "";
  var ch = str.split("");
  var isOper = false;
  for (var i = 0; i < ch.length; i++) {
    if (ch[i] == "+" || ch[i] == "-" || ch[i] == "*" || ch[i] == "/") { //符号
      var dv = tempValue * 1;
      if (isOper) {
        var value = valueArray.pop();
        var mark = markArray.pop();
        dv = this.simpleTwoEval(mark, value, dv);
      }
      valueArray.push(dv);
      markArray.push(ch[i]);
      tempValue = "";
      isOper = false;
      if (ch[i] == "*" || ch[i] == "/") {
        isOper = true;
      }
    } else {
      tempValue += ch[i] + "";
      if (i == ch.length - 1) { //最后一位
        var dv = tempValue * 1;
        if (isOper) {
          var dv1 = valueArray.pop();
          var mark = markArray.pop();
          var result = this.simpleTwoEval(mark, dv1, tempValue);
          dv = result;
        }
        valueArray.push(dv);
      }
    }
  }

  valueArray = this.reverseArray(valueArray);
  markArray = this.reverseArray(markArray);
  while (valueArray.length > 1) {
    var v1 = valueArray.pop();
    var v2 = valueArray.pop();
    var mark = markArray.pop();
    valueArray.push(this.simpleTwoEval(mark, v1, v2));
  }
  return valueArray[0];
};

//两个数的加减乘除
CalcEval.prototype.simpleTwoEval = function (mark, value1, value2) {
  if (mark == "+") {
    //return value1 + value2;
    return Number(this.numAdd(value1, value2));
  } else if (mark == "-") {
    //return value1 - value2;
    return Number(this.numSub(value1, value2));
  } else if (mark == "*") {
    //return value1 * value2;
    return Number(this.numMulti(value1, value2));
  } else if (mark == "/") {
    //return value1 / value2;
    return Number(this.numDiv(value1, value2));
  }
  return 0;
};

//反转数组
CalcEval.prototype.reverseArray = function (oldArray) {
  var newArray = new Array();
  var size = oldArray.length;
  for (var i = 0; i < size; i++) {
    newArray.push(oldArray.pop());
  }
  return newArray;

};


/**
 * 加法运算，避免数据相加小数点后产生多位数和计算精度损失。
 *
 * @param num1加数1 | num2加数2
 */
CalcEval.prototype.numAdd = function (num1, num2) {
  var baseNum, baseNum1, baseNum2;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(100, Math.max(baseNum1, baseNum2));
  var n1 = this.numMulti(num1, baseNum);
  var n2 = this.numMulti(num2, baseNum);
  return this.numDiv(Number(n1) + Number(n2), baseNum);;
};
/**
 * 加法运算，避免数据相减小数点后产生多位数和计算精度损失。
 *
 * @param num1被减数  |  num2减数
 */
CalcEval.prototype.numSub = function (num1, num2) {
  var baseNum, baseNum1, baseNum2;
  var precision; // 精度
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(100, Math.max(baseNum1, baseNum2));
  if (baseNum >= 10) {
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  }
  precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
  var n1 = this.numMulti(num1, baseNum);
  var n2 = this.numMulti(num2, baseNum);
  var n3 = this.numDiv(Number(n1) - Number(n2), baseNum);
  return (n3).toFixed(precision);
};
/**
 * 乘法运算，避免数据相乘小数点后产生多位数和计算精度损失。
 *
 * @param num1被乘数 | num2乘数
 */
CalcEval.prototype.numMulti = function (num1, num2) {
  var baseNum = 0;
  try {
    baseNum += num1.toString().split(".")[1].length;
  } catch (e) {}
  try {
    baseNum += num2.toString().split(".")[1].length;
  } catch (e) {}
  //var str = Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(100, baseNum);
  return Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum);
};
/**
 * 除法运算，避免数据相除小数点后产生多位数和计算精度损失。
 *
 * @param num1被除数 | num2除数
 */
CalcEval.prototype.numDiv = function (num1, num2) {
  var baseNum1 = 0,
    baseNum2 = 0;
  var baseNum3, baseNum4;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum3 = Number(num1.toString().replace(".", ""));
  baseNum4 = Number(num2.toString().replace(".", ""));
  return (baseNum3 / baseNum4) * pow(10, baseNum2 - baseNum1);
};

/**
 * 科学记数转为长数字
 * @param  {[type]} n 科学记数1e+30
 */
CalcEval.prototype.toNum = function (n) {
  var nStr = (n + "");
  if (nStr.indexOf(".") > -1)
    nStr = nStr.replace(".", "").replace(/\d+$/, function (m) {
      return --m;
    });
  return nStr.replace(/(\d+)e\+?(\d+)/, function (m, g1, g2) {
    return g1 + new Array(+g2).join("0") + "0";
  })
}

/**
 * 数组下标的含义 style样式  ''、undefined为默认值无样式
 * 索引0   只读       设置 0/1
 * 索引1   加粗       设置1加粗
 * 索引2   倾斜       设置1倾斜
 * 索引3   下划线     ......
 * 索引4   垂直对齐   设置为t=top,m=middle,b=bottom
 * 索引5   水平对齐   设置为l=left,c=center,r=right init
 * 索引6   字号       实际设置的值
 * 索引7   字体       ......
 * 索引8   文本颜色     ......
 * 索引9   背景色     ......
 * 索引10  边框       [border-width|border-style|border-color]
 */

//重新toFixed方法 解决toFixed保留位数出错问题146.575.toFixed(2) chrome
Number.prototype.toFixed = function (d) {
  d = Number(d);
  var s = this + "";
  if (!d) d = 0;
  if (s.indexOf(".") == -1) s += ".";
  s += new Array(d + 1).join("0");
  if (new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (d + 1) + "})?)\\d*$").test(s)) {
    var s = "0" + RegExp.$2,
      pm = RegExp.$1,
      a = RegExp.$3.length,
      b = true;
    if (a == d + 2) {
      a = s.match(/\d/g);
      if (parseInt(a[a.length - 1]) > 4) {
        for (var i = a.length - 2; i >= 0; i--) {
          a[i] = parseInt(a[i]) + 1;
          if (a[i] == 10) {
            a[i] = 0;
            b = i != 1;
          } else break;
        }
      }
      s = a.join("").replace(new RegExp("(\\d+)(\\d{" + d + "})\\d$"), "$1.$2");

    }
    if (b) s = s.substr(1);
    return (pm + s).replace(/\.$/, "");
  }
  return this + "";
};

//IE8 toFixed bug 避免handsontable初始化后 tofixed2还未执行完成
Number.prototype.toFixed2 = function (s) {
  var num = Number(this);
  var pre = '';
  if (num < 0) {
    pre = '-';
    num = Math.abs(num);
  }
  var changenum = (parseInt(num * Math.pow(10, s) + 0.5) / Math.pow(10, s)).toString();
  var index = changenum.indexOf(".");
  if (index < 0 && s > 0) {
    changenum = changenum + ".";
    for (i = 0; i < s; i++) {
      changenum = changenum + "0";
    }
  } else {
    index = changenum.length - index;
    for (i = 0; i < (s - index) + 1; i++) {
      changenum = changenum + "0";
    }
  }
  return pre + changenum;
}
// 对Date的扩展，将 Date 转化为指定格式的String   
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，   
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)   
// 例子：   
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423   
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18   
Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份   
    "d+": this.getDate(), //日   
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒   
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度   
    "S": this.getMilliseconds() //毫秒   
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  return fmt;
}
$(function () {
  //解决IE8 JSON.stringify 中文 unicode编码
  if (typeof JSON !== "object") {
    JSON = {}
  }(function () {
    var rx_one = /^[\],:{}\s]*$/,
      rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,
      rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
      rx_four = /(?:^|:|,)(?:\s*\[)+/g,
      rx_escapable = /[\\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
      rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;

    function f(n) {
      return n < 10 ? "0" + n : n
    }

    function this_value() {
      return this.valueOf()
    }
    if (typeof Date.prototype.toJSON !== "function") {
      Date.prototype.toJSON = function () {
        return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null
      };
      Boolean.prototype.toJSON = this_value;
      Number.prototype.toJSON = this_value;
      String.prototype.toJSON = this_value
    }
    var gap, indent, meta, rep;

    function quote(string) {
      rx_escapable.lastIndex = 0;
      return rx_escapable.test(string) ? '"' + string.replace(rx_escapable, function (a) {
        var c = meta[a];
        return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4)
      }) + '"' : '"' + string + '"'
    }

    function str(key, holder) {
      var i, k, v, length, mind = gap,
        partial, value = holder[key];
      if (value && typeof value === "object" && typeof value.toJSON === "function") {
        value = value.toJSON(key)
      }
      if (typeof rep === "function") {
        value = rep.call(holder, key, value)
      }
      switch (typeof value) {
        case "string":
          return quote(value);
        case "number":
          return isFinite(value) ? String(value) : "null";
        case "boolean":
        case "null":
          return String(value);
        case "object":
          if (!value) {
            return "null"
          }
          gap += indent;
          partial = [];
          if (Object.prototype.toString.apply(value) === "[object Array]") {
            length = value.length;
            for (i = 0; i < length; i += 1) {
              partial[i] = str(i, value) || "null"
            }
            v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
            gap = mind;
            return v
          }
          if (rep && typeof rep === "object") {
            length = rep.length;
            for (i = 0; i < length; i += 1) {
              if (typeof rep[i] === "string") {
                k = rep[i];
                v = str(k, value);
                if (v) {
                  partial.push(quote(k) + (gap ? ": " : ":") + v)
                }
              }
            }
          } else {
            for (k in value) {
              if (Object.prototype.hasOwnProperty.call(value, k)) {
                v = str(k, value);
                if (v) {
                  partial.push(quote(k) + (gap ? ": " : ":") + v)
                }
              }
            }
          }
          v = partial.length === 0 ? "{}" : gap ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" : "{" + partial.join(",") + "}";
          gap = mind;
          return v
      }
    }
    if (typeof JSON.stringify !== "function" || !-[1, ]) {
      meta = {
        "\b": "\\b",
        "\t": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
      };
      JSON.stringify = function (value, replacer, space) {
        var i;
        gap = "";
        indent = "";
        if (typeof space === "number") {
          for (i = 0; i < space; i += 1) {
            indent += " "
          }
        } else {
          if (typeof space === "string") {
            indent = space
          }
        }
        rep = replacer;
        if (replacer && typeof replacer !== "function" && (typeof replacer !== "object" || typeof replacer.length !== "number")) {
          throw new Error("JSON.stringify")
        }
        return str("", {
          "": value
        })
      }
    }
    if (typeof JSON.parse !== "function") {
      JSON.parse = function (text, reviver) {
        var j;

        function walk(holder, key) {
          var k, v, value = holder[key];
          if (value && typeof value === "object") {
            for (k in value) {
              if (Object.prototype.hasOwnProperty.call(value, k)) {
                v = walk(value, k);
                if (v !== undefined) {
                  value[k] = v
                } else {
                  delete value[k]
                }
              }
            }
          }
          return reviver.call(holder, key, value)
        }
        text = String(text);
        rx_dangerous.lastIndex = 0;
        if (rx_dangerous.test(text)) {
          text = text.replace(rx_dangerous, function (a) {
            return "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4)
          })
        }
        if (rx_one.test(text.replace(rx_two, "@").replace(rx_three, "]").replace(rx_four, ""))) {
          j = eval("(" + text + ")");
          return typeof reviver === "function" ? walk({
            "": j
          }, "") : j
        }
        throw new SyntaxError("JSON.parse")
      }
    }
  }());


})
var HChtHelper = {};
(function (HChtHelper) {
  HChtHelper.Core = function (rootElement, settings) {
    var instance = this,
      priv = {},
      view = {},
      colformatVal = [] //保存行/列函数各参数的值
      ,
      defaultSettings = {
        data: [],
        colHeaders: true,
        rowHeaders: true,
        minSpareRows: 1,
        minSpareCols: 1,
        colWidths: [],
        colFormats: [], //行/列函数
        excelDownload: 'common-exportHtmlToExcel.action', //excel下载
        autoWrapRow: true,
        //manualColumnMove: true,
        manualColumnResize: true,
        //persistentState: true,        //缓存？
        currentRowClassName: 'currentRow',
        currentColClassName: 'currentCol',
        contextMenu: {
          items: {
            "row_above": {
              'name': '添加上一行'
            },
            "row_below": {
              'name': '添加下一行'
            },
            "row_above_zbgroup": {
              'name': '添加上一行(指标分组)'
            },
            "hsep1": "---------",
            "col_left": {
              'name': '添加左边列'
            },
            "col_right": {
              'name': '添加右边列'
            },
            "col_left_zbgroup": {
              'name': '添加左边列(指标分组)'
            },
            "hsep2": "---------",
            "remove_row": {
              'name': '删除行'
            },
            'remove_col': {
              'name': '删除列'
            },
            "hsep3": "---------",
            'make_read_only': {},
            'merge': {} //,
            //"hsep4" : "---------",
            //'copy':{},
            //'paste':{},
            //"hsep5" : "---------",
            //"hsep6" : "---------",
            //'redo' : {name:'撤消'},
            //'undo' : {name:'还原'}
          }
        },
        mergeCells: [],
        afterLoadData: function (change, source) {},
        /************** 工具栏 hchthelper *****************/
        toolbar: {
          type: 'all',
          flag: true, //影响工具栏中 公式函数 指标分组  显示及隐藏
          selectedIndex: 1, //选中下标
          menu: [{
              'start': [
                ['save', 'download', 'print']
              ]
            }, //,'import48'
            {
              'basics': ['print', 'clearformat', ['family', 'size', 'weight', 'tilt', 'underlined', 'strike', 'bcolor', 'color', 'border'],
                ['setformat', 'checkformat', 'searchall', 'validitydata' /*,'selector'*/ ],
                ['align', 'vertical', 'merge', 'readonly'],
                ['row', 'col'],
                ['zbgroup', 'tableskin', 'fixed', 'theight', 'stretch', 'calculation', 'columnnum']
              ]
            },
            // {'basics'      : ['print','clearformat', ['family', 'size', 'weight', 'tilt', 'underlined', 'strike', 'bcolor', 'color', 'border'],['setformat','checkformat','searchall', 'validitydata'/*,'selector'*/],['align', 'vertical','merge', 'readonly'],['row', 'col'],['zbgroup', 'tableskin','fixed','theight','stretch', 'calculation', 'columnnum', 'randomtable', 'otherfetching']]},
            //{'chart'       : [['bar','line','pie','bar2','area','scatter','other']]},
            {
              'temp': ['importdata']
            }
          ],
          secondMenu: {
            'zbgroup': ['zb', 'group', 'area2', 'contrast', 'datetime', 'timecode', 'indExplain'], //'qb'
            'setformat': ['number'],
            'checkformat': ['formatlist'],
            //'allformat'    : ['aformatlist'],
            'validitydata': ['dformat', 'func'],
            'autofetching': ['autofzb', 'autoftq', 'autofother'],
            'import': ['impcol'],
            'importdata': ['importdata2'],
            'tableskin': ['tableskin2'],
            'theight': ['theight2'],
            'save': ['save2'],
            // 'selector'     : ['webuploader', 'checkbox', 'radio'/*, 'checkbox', 'radio', 'calendar', 'dropdown', 'dynamicdrop', 'commoncode'*/]
            'selector': ['checkbox', 'radio' /*, 'checkbox', 'radio', 'calendar', 'dropdown', 'dynamicdrop', 'commoncode'*/ ]
          },
          thirdMenu: {
            'number': ['normal', 'decimal', 'money', 'date', 'abs', 'other2', 'tihuan'], //,'selector'
            'dformat': ['any', 'num', 'integer', 'decimal2', 'date2', 'length' /*,'mobile','phone','email','post'*/ ],
            'tableskin2': ['none', 'default', 'hz', 'fixednum']
          },
          miniMenu: ['save', 'download', 'print', 'stretch', 'calculation']
        },
        maxRowNum: 0, //初始化最大行数 默认为0

        /***************** 用户可操作表格权限 hchthelper */
        power: {
          number: 1, //用户操作权限 暂时1为普通用户权限
          coords: [0, 0, 20, 5] //原table的所有坐标 用于 用户权限这块(不可编辑)。
        },
        fixed: true, //菜单栏是否固定在窗口顶端
        //columnSorting : false,      //排序
        hchthelper: instance, // hchthelper对象
        saveTableView: null, //保存事件
        autoCalculation: false, //是否自动计算
        //stretchH : 'last',
        aaa: 1
      },
      miniDefaultSettings = {
        colHeaders: null,
        rowHeaders: null,
        minSpareRows: 0,
        minSpareCols: 0,
        contextMenu: null

      },
      instanceToolbar = null;

    HChtHelper.CE = new CalcEval();

    /****** 私有属性  ******/
    priv = {
      loadExampleDown: function () {},

      /**
       * 获取滚动条的高
       */
      getScrollTop: function () {
        return ('pageYOffset' in window) ? window.pageYOffset : Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      },
      /**
       * 获取元素的坐标值
       * @param {Object} oElement
       * return arr
       */
      findPosition: function (oElement, nodeName) {
        var x2 = 0,
          y2 = 0,
          width = oElement.offsetWidth,
          height = oElement.offsetHeight;
        if (typeof (oElement.offsetParent) != 'undefined') {
          for (var posX = 0, posY = 0; oElement; oElement = oElement.offsetParent) {
            posX += oElement.offsetLeft;
            posY += oElement.offsetTop;
            if (nodeName) {
              var nName = oElement.offsetParent && oElement.offsetParent.nodeName;
              if (nodeName.toUpperCase() == nName) {
                break;
              }
            } else {
              var id = oElement.offsetParent && oElement.offsetParent.id;
              if (id == instance.tid) {
                break;
              };
            }
          }
          x2 = posX + width;
          y2 = posY + height;
          return [posX, posY, x2, y2];
        } else {
          x2 = oElement.x + width;
          y2 = oElement.y + height;
          return [oElement.x, oElement.y, x2, y2];
        }
      },
      /**
       * 获取元素的坐标值
       * @param {Object} oElement
       * return arr
       */
      findPosition2: function (oElement, className) {
        var x2 = 0,
          y2 = 0,
          width = oElement.offsetWidth,
          height = oElement.offsetHeight;
        if (typeof (oElement.offsetParent) != 'undefined') {
          for (var posX = 0, posY = 0; oElement; oElement = oElement.offsetParent) {
            posX += oElement.offsetLeft;
            posY += oElement.offsetTop;
            if (className) {
              var pObj = oElement.offsetParent;
              if (pObj.className.indexOf(className) > -1) {
                break;
              }
            } else {
              var id = oElement.offsetParent && oElement.offsetParent.id;
              if (id == instance.tid) {
                break;
              };
            }
          }
          x2 = posX + width;
          y2 = posY + height;
          return [posX, posY, x2, y2];
        } else {
          x2 = oElement.x + width;
          y2 = oElement.y + height;
          return [oElement.x, oElement.y, x2, y2];
        }
      },
      /**
       * 初始化handsontable
       */
      setHandsontable: function () {
        instance.rootElement.data('handsontable', null);
        instance.rootElement.handsontable(instance.GridSettings);
        instance.handsontable = instance.rootElement.data('handsontable');
        instance.rootElement.append('<div id="hidespecial-' + instance.tid + '" style="display:none"></div>');
        /* hchthelper */
        if (instance.GridSettings.autoCalculation && instance.GridSettings.autoCalculation === true) {
          instance.controller.calculation();
          instance.handsontable.render();
        }
        //instance.handsontable.selectCell(0,4,30,4)
      },

      /**
       * 指定位置显示
       * @ param {Object} _this 当前选择标签对象
       * @ param {Object} obj   指定位置显示的标签对象
       */
      fixedShow: function (_this, obj, type, className, nodeName) {
        var arr = this.findPosition(_this);
        if (className) {
          arr = this.findPosition2(_this, className)
        }
        var x = arr[0],
          y = arr[1],
          offW = _this.offsetWidth,
          offH = _this.offsetHeight,
          $div = $(obj),
          align = $(_this).data('align') || type || '',
          cssText = {},
          dW = $div.outerWidth(),
          dH = $div.outerHeight(),
          target = $(_this).data('target')
        cssText.display = 'block';
        if (target == 'sheetsmenu' && type != 'bottom-center') {
          align = type;
        }
        //文字水平居中显示
        if ((target == 'otherfetching' || target == 'tableskin' || target == 'validitydata') && type) {
          align = type;
        }
        if (align == 'top-right') {
          cssText.top = Math.max(y - dH, 0) + 'px';
          cssText.left = (x + offW - dW) + 'px';
        } else if (align == 'top-left') {
          cssText.top = Math.max(y - dH, 0) + 'px';
          cssText.left = x + 'px';
        } else if (align == 'middle-left') {
          cssText.top = Math.max(y - dH / 2, 0) + 'px';
          cssText.left = (x + offW - dW) + 'px';
        } else if (align == 'middle-center') {
          var winH = $(window).height();
          var winW = $(window).width();
          cssText.top = Math.max((winH - dH) / 2, 0) + 'px';
          cssText.left = Math.max((winW - dW) / 2, 0) + 'px';
        } else if (align == 'middle-right') {
          cssText.top = Math.max(y - dH / 2, 0) + 'px';
          cssText.left = (x + offW) + 'px';
        } else if (align == 'bottom-center') {
          cssText.top = Math.max((y + offH), 0) + 'px';
          cssText.left = Math.max((x + offW - (offW + dW) / 2), 0) + 'px';
        } else if (align == 'bottom-right') {
          cssText.top = Math.max((y + offH), 0) + 'px';
          cssText.left = (x + offW - dW) + 'px';
        } else { //bottom-left
          cssText.top = Math.max((y + offH), 0) + 'px';
          cssText.left = x + 'px';
        }
        $div.css(cssText);
      },
      /**
       * 重新组合table 用于下载 打印 不显示 (注：handsontable可能无法完全加载)
       *
       */
      recombinationTable: function () {
        var arrTable = [];
        var data = instance.GridSettings.data;
        var colWidths = instance.GridSettings.colWidths || '';
        var mergeCells = instance.GridSettings.mergeCells || '';
        arrTable.push('<div class="handsontable hthelper-recombination"><table class="htCore" cellspacing="0" cellpadding="0" border="0" style="width:auto;">');
        if (colWidths) {
          arrTable.push('<colgroup>');
          for (var i = 0, n = colWidths.length; i < n; i++) {
            var w = colWidths[i] || 100;
            arrTable.push('<col style="width:' + w + 'px"/>');
          }
          arrTable.push('</colgroup>');
        }
        arrTable.push('<tbody>');
        var styleData = instance.GridSettings.styleData;
        var ruleData = instance.GridSettings.ruleData;
        for (var i = 0, n = data.length; i < n; i++) {
          var sdata = data[i];
          arrTable.push('<tr>');
          for (var j = 0, y = sdata.length; j < y; j++) {
            var cssText = '',
              value = sdata[j];
            var style = eval(styleData[i][j].style);
            if (style) {
              if (style[1] == '1') {
                cssText += 'font-weight:bold;';
              }
              if (style[2] == '1') {
                cssText += 'font-style:italic;';
              }
              if (style[3] == '1') {
                cssText += 'text-decoration:underline;';
              }
              if (style[4] == 't') {
                cssText += 'vertical-align:top;';
              }
              if (style[4] == 'm') {
                cssText += 'vertical-align:middle;';
              }
              if (style[4] == 'b') {
                cssText += 'vertical-align:bottom;';
              }
              if (style[5] == 'l') {
                cssText += 'text-align:left;';
              }
              if (style[5] == 'c') {
                cssText += 'text-align:center;';
              }
              if (style[5] == 'r') {
                cssText += 'text-align:right;';
              }
              if (style[6] && style[6] != '12') {
                cssText += 'font-size:' + style[6] + 'px;';
              }
              if (style[7] && style[7] != '宋体') {
                cssText += 'font-family:' + style[7] + ';';
              }
              if (style[8]) {
                cssText += 'color:' + style[8] + ';';
              }
              if (style[9]) {
                cssText += 'background-color:' + style[9] + ';';
              }
              /*
              if(style[10]){
              	var border = style[10];
              	cssText += 'border-width:'+border[0]+';border-style:'+border[1]+';border-color:'+border[2]+';';
              }*/
              if (style[10]) {
                cssText += style[10];
              }
              if (style[11]) {
                cssText += 'text-decoration:line-through;';
              }
              if (style[0]) { //只读
                cssText += 'background-color:#ebf9fc';
              }
            }
            if (instance.GridSettings.toolbar) {
              //formula
              if (ruleData) {
                var colRule = ruleData[i];
                if (colRule) {
                  colRule = colRule[j];
                  var rules = colRule.rule;
                  if (rules) {
                    /*
                    //公式
                    var formula = rules.formula;
                    if(formula){ //值没有刷新
                    	try{ this.map.updateFormula(formula); }
                    	catch(e){  }
                    }
                    */
                    //设置格式
                    var setformat = rules.setformat;
                    if (setformat) { //解析设置格式中的数据
                      setformat = setformat.split(',');
                      var target = setformat[0],
                        val = setformat[1],
                        type = setformat[2];
                      switch (target) {
                        case 'decimal': //数值
                          value = Number(value) || value;
                          if (typeof value == 'number')
                            value = value.toFixed(val)
                          break;
                        case 'money': //货币
                          value = Number(value) || value;
                          if (typeof value == 'number')
                            value = '￥' + value.toFixed(val);
                          break;
                        case 'date': //日期
                          value = Number(value) || value;
                          value = this.getDateFormat(value, type);
                          break;
                        case 'abs': //绝对值
                          value = Number(value) || value;
                          if (typeof value == 'number') {
                            value = Math.abs(value);
                          }
                          break;
                        case 'other2': //其它
                          var html = '';
                          html = (type == 1) ? '' + val + value : '' + value + val;
                          value = html;
                          break;
                        case 'tihuan': //替换
                          var html = '';
                          html = (value == val) ? type : value;
                          value = html;
                          break;
                      }
                    }
                  }
                }
              }
            }
            var text = cssText ? ' style="' + cssText + '"' : '';
            arrTable.push('<td' + text + '>' + (value || '') + '</td>');
          }
          arrTable.push('</tr>');
        }
        arrTable.push('</tbody></table></div>');
        var $hidespecial = $('#hidespecial-' + instance.tid);
        $hidespecial.html(arrTable.join(''));
        for (var i = 0, n = mergeCells.length; i < n; i++) {
          var json = mergeCells[i],
            row = json.row,
            col = json.col,
            rowspan = json.rowspan,
            colspan = json.colspan,
            $col = $hidespecial.find('tr').eq(row).find('td').eq(col);
          $col.attr('rowspan', rowspan);
          $col.attr('colspan', colspan);
          for (var j = 0; j < rowspan; j++) {
            for (var k = 0; k < colspan; k++) {
              //不等于合并列左上角单元格
              if (rowspan + j != rowspan || colspan + k != colspan) {
                $hidespecial.find('tr').eq(row + j).find('td').eq(col + k).hide(); //隐藏
              }
            }
          }
        }
        $hidespecial.find('td').each(function (index) {
          var dis = $(this).css('display');
          if (dis == 'none') {
            $(this).remove();
          }
        });

      },
      /**
       * div平滑
       * @param {Object} _this tabs标签对象
       */
      arrowTab: function (_this) {
        var $cont = instanceToolbar.find('div[class*="hthelper-contents"]').children('div.hthelper-cont');
        $cont.each(function (index) {})
      }
    };
    HChtHelper.priv = priv;
    this.atab = function () {
      priv.arrowTab();
    }
    /**
     * 根据 settings.minSpareCol/Row 移除自动添加的行列
     * @param {Number} minSpareRow   自动添加最小行数
     * @param {Number} minSpareCol   自动添加最小列数
     */
    this.removeMinSpareColumns = function (minSpareRow, minSpareCol) {
      instance.GridSettings.data.length -= minSpareRow;
      instance.GridSettings.ruleData.length -= minSpareRow;
      instance.GridSettings.styleData.length -= minSpareRow;
      for (var i = 0, len = instance.GridSettings.data.length; i < len; i++) {
        var json = instance.GridSettings.data[i];
        var ruleJson = instance.GridSettings.ruleData[i];
        var styleJson = instance.GridSettings.styleData[i];
        json.length -= minSpareCol;
        ruleJson.length -= minSpareCol;
        styleJson.length -= minSpareCol;
      }
    }
    /**
     * 设置表头行列全中
     */
    this.setHeaderColumns = function () {
      instance.rootElement.find('.wtHider .wtSpreader').on('click', 'th', function () {
        var rows = instance.GridSettings.data.length - 1 - (instance.GridSettings.minSpareRows || 0),
          cols = instance.GridSettings.data[0].length - 1 - (instance.GridSettings.minSpareCols || 0),
          startCol = 0,
          startRow = 0,
          endRow = rows,
          endCol = cols,
          index = $(this).index();
        if ($(this).closest('thead').length > 0) {
          if (index > 0) {
            --index;
            startCol = endCol = index;
          }
        } else if ($(this).closest('tbody').length > 0) {
          index = Number($(this).text()) - 1;
          startRow = endRow = index;
        }
        instance.handsontable.selection.setRangeStart({
          'row': startRow,
          'col': startCol
        });
        instance.handsontable.selection.setRangeEnd({
          'row': endRow,
          'col': endCol
        }, false);
      })
    }
    /**
     *  导入后重新初始化合并单元格。
     *  @param {JSOn}      userSettings
     *  @parsm {Boolean}   excelFlag    是否excel导入
     */
    this.updateSettings = function (userSettings, excelFlag) {
      if (excelFlag) {
        instance.initRule(userSettings.data, 'styleData');
        instance.initRule(userSettings.data, 'ruleData');
      } else {
        if (!userSettings.styleData) {
          instance.initRule(userSettings.data, 'styleData');
        }
        if (!userSettings.ruleData) {
          instance.initRule(userSettings.data, 'ruleData');
        }
      }
      instance.GridSettings = $.extend(instance.GridSettings, userSettings);

      var hsettings = instance.GridSettings;

      hsettings = $.extend(hsettings, miniDefaultSettings, instance.GridSettings);
      //合并单元格
      instance.handsontable.mergeCells = null;
      instance.handsontable.PluginHooks.run('beforeInit');
      instance.handsontable.updateSettings(instance.GridSettings);
    }
    /**
     * 当表头单元格宽度发生改变时，保存改变后的单元格宽度
     * @return {[type]}
     */
    this.getColWidths = function () {
      var colWidths = [];
      var cols = instance.handsontable.countCols();
      for (var i = 0, n = cols; i < n; i++) {
        colWidths.push(instance.handsontable.getColWidth(i));
      }
      return colWidths;
    }
    /**
     * 保护hchthelper和handsontable的配置参数
     * @param {boolean} flag
     * @return params
     */
    this.saveParams = function (flag) {
      if (flag) {
        instance.removeMinSpareColumns(instance.GridSettings.minSpareRows, instance.GridSettings.minSpareCols);
      }

      var params = $.extend({}, instance.GridSettings);
      delete params.hchthelper;
      delete params.saveTableView;
      delete params.prevDatas;
      delete params.hcOtherZBG;
      //minidefaultsettings
      delete params.contextMenu;
      delete params.colHeaders;
      delete params.rowHeaders;
      delete params.minSpareRows;
      delete params.minSpareCols;
      delete params.afterLoadData;
      //delete params.toolbar;
      params.toolbar = {
        'type': instance.GridSettings.toolbar.type
      };
      delete params.power;
      delete params.autoCalculation;
      delete params.setDataAtCellOther; //自定义修改单元格数据方法
      delete params.showZbGroup;
      delete params.isSelectEdit;
      //if(params.tableskin == 'fixednum'){ delete params.tableskin; }
      params.colWidths = this.getColWidths();
      for (let it in params) {
        if (params[it] instanceof Function) {
          delete params[it];
        }
      }
      return params;
    }
    /**
     * 对每个单元格进行数据分析解析 调用至handsontable的TextRenderer方法中。
     *
     */
    this.descriptionRenderer = function (handsontable, td, row, col, prop, value, cellProperties) {
      value = value || '';
      td.innerHTML = '<span class="hthelper-cell-title">' + value + '</span>';
      //td.innerHTML = '<div class="hthelper-cell-list"><span class="hthelper-cell-title">'+value+'</span></div>';
      //style
      var styleData = instance.GridSettings.styleData;
      var cssText = '';
      if (styleData) {
        if (styleData[row]) {
          var styleCol = styleData[row][col];
          var style = eval(styleCol.style);
          if (style) {
            if (style[1] == '1') {
              cssText += 'font-weight:bold;';
            }
            if (style[2] == '1') {
              cssText += 'font-style:italic;';
            }
            if (style[3] == '1') {
              cssText += 'text-decoration:underline;';
            }
            if (style[4] == 't') {
              cssText += 'vertical-align:top;';
            }
            if (style[4] == 'm') {
              cssText += 'vertical-align:middle;';
            }
            if (style[4] == 'b') {
              cssText += 'vertical-align:bottom;';
            }
            if (style[5] == 'l') {
              cssText += 'text-align:left;';
            }
            if (style[5] == 'c') {
              cssText += 'text-align:center;';
            }
            if (style[5] == 'r') {
              cssText += 'text-align:right;';
            }
            if (style[6] && style[6] != '12') {
              cssText += 'font-size:' + style[6] + 'px;';
            }
            if (style[7] && style[7] != '宋体') {
              cssText += 'font-family:' + style[7] + ';';
            }
            if (style[8]) {
              cssText += 'color:' + style[8] + ';';
            }
            if (style[9]) {
              cssText += 'background-color:' + style[9] + ';';
            }
            /*
            if(style[10]){
            	var border = style[10];
            	cssText += 'border-width:'+border[0]+';border-style:'+border[1]+';border-color:'+border[2]+';';
            }*/
            if (style[10]) {
              cssText += style[10];
            }
            if (style[11]) {
              cssText += 'text-decoration:line-through;';
            }
            cellProperties.readOnly = style[0];
            if (style[0] || style[0] == '0') { //只读
              cssText += style[0] ? 'background-color:#ebf9fc;' : '';
            } else {
              $(td).removeClass('htDimmed');
            }
            td.style.cssText = cssText;
          } else { //取消只读
            $(td).removeClass('htDimmed');
            cellProperties.readOnly = false;
          }
        }
      }
      if (instance.GridSettings.toolbar) {
        var menus = HChtHelper.Config.menus;
        var arrZb = [];
        //zbgroup
        if (instance.GridSettings.toolbar.type == 'all' || instance.GridSettings.showZbGroup === true) {
          var zbgroup = instance.GridSettings.toolbar.secondMenu.zbgroup;
          for (var i = 0, n = zbgroup.length; i < n; i++) {
            var target = zbgroup[i];
            if (target == 'area2') {
              target = 'area';
            }
            var selJson = this.map.getColumnProp(row, col, target);
            if (!selJson) {
              continue;
            }
            if (target == 'indExplain') {
              arrZb.push(menus[zbgroup[i]] + '：' + selJson + '\r\n');
            } else {
              arrZb.push(menus[zbgroup[i]] + '：' + selJson[1].join(',') + ' (' + selJson[0].join(',') + ')' + ' ' + (selJson[3] || []).join(',') + '\r\n');
            }

          }
        }
        var json = instance.controller.setHcOtherZBG(row, col);
        if (json) {
          arrZb.push(json.pname + '：' + json.msg + '\r\n');
        }
        if (arrZb.length > 0) {
          $(td).append('<a href="javascript:;" title="' + arrZb.join('') + '" class="excel-icon e-icon-custom ddz"></a>');
        } else {
          $(td).append('<a class="e-icon-custom2"></a>')
        }
        //gdp合算
        var gongshiJson = this.map.getColumnProp(row, col, 'gongshi');
        if(gongshiJson){
          $(td).append('<a href="javascript:;" title="' + gongshiJson + '" class="excel-icon e-icon-custom3 ddz"></a>');
        }

        //formula
        var ruleData = instance.GridSettings.ruleData;
        if (ruleData) {
          var colRule = ruleData[row];
          if (colRule) {
            colRule = colRule[col];
            //选择器
            var selector = colRule.selector;
            if (selector) { //解析选择器中的数据
              var target = selector.target,
                group = selector.group,
                list = selector.list,
                index = selector.index,
                checked = '',
                subtarget = selector.subtarget || 'minusfulldate';
              switch (target) {
                // case 'webuploader':
                // break;
                case 'checkbox':
                  if (value && value != '0') {
                    checked = 'checked = "true"'
                  };
                  $(td).find('span.hthelper-cell-title').html('<input type="checkbox" class="vam" ' + checked + ' title="多选框" data-toggle="hthelper-selector"/>');
                  break;
                case 'calendar':
                  if (value) {
                    checked = 'value ="' + value + '"'
                  }
                  var formatDate = HChtHelper.Config.icon[subtarget].name;
                  $(td).find('span.hthelper-cell-title').addClass('ht-box-calendar').html('<input type="text" data-format="' + formatDate + '" class="ht-selector ht-calendar" data-toggle="hthelper-selector" ' + checked + '/>');

                  var view2 = 2;
                  switch (formatDate.toLowerCase()) {
                    case 'yyyy-mm':
                      view2 = 3;
                      break;
                    case 'yyyy':
                      view2 = 4;
                      break;
                  }
                  $(td).find('input[data-toggle="hthelper-selector"]').datetimepicker({
                    format: formatDate.toLowerCase(),
                    weekStart: 1,
                    todayBtn: 1,
                    language: 'zh-CN',
                    //todayHighlight : true,
                    startView: view2,
                    minView: view2

                  }).unbind().on('changeDate', function (ev) {
                    var date = ev.date;
                    let coord = instance.GridSettings.data[coord[0]][coord[1]] = date.Format(formatDate);
                  });
                  break;
                case 'radio':
                  if (value) {
                    checked = 'checked = "true"'
                  };
                  $(td).find('span.hthelper-cell-title').addClass('ht-box-calendar').html('<input type="radio" row="' + row + '" col="' + col + '" name="' + group + '" class="vam" data-toggle="hthelper-selector" ' + checked + '/>');
                  break;
                case 'dropdown':
                  var arr = [];
                  arr.push('<select class="ht-selector-dd" data-toggle="hthelper-selector">');
                  for (var i = 0, len = list.length; i < len; i++) {
                    checked = (value == list[i].value) ? 'selected' : '';
                    arr.push('<option value="' + list[i].value + '" ' + checked + '>' + list[i].name + '</option>')
                  }
                  arr.push('</select>');
                  $(td).find('span.hthelper-cell-title').addClass('ht-box-calendar').html(arr.join(''));
                  break;
              }
            }

            var rules = colRule.rule;
            if (rules) {
              //设置格式
              var setformat = rules.setformat;
              if (setformat) { //解析设置格式中的数据
                setformat = setformat.split(',');
                var target = setformat[0],
                  val = setformat[1],
                  type = setformat[2];
                switch (target) {
                  case 'decimal': //数值
                    value = Number(value) || value;
                    if (typeof value == 'number') {
                      $(td).find('span.hthelper-cell-title').html(value.toFixed(val));
                      this.map.filledClearFormat(value.toFixed(val), row, col);
                    }
                    break;
                  case 'money': //货币
                    value = Number(value) || value;
                    if (typeof value == 'number') {
                      $(td).find('span.hthelper-cell-title').html('￥' + value.toFixed(val));
                      this.map.filledClearFormat('￥' + value.toFixed(val), row, col);
                    }
                    break;
                  case 'date': //日期
                    value = Number(value) || value;
                    value = this.getDateFormat(value, type);
                    $(td).find('span.hthelper-cell-title').html(value);
                    this.map.filledClearFormat(value, row, col);
                    break;
                  case 'abs': //绝对值
                    value = Number(value) || value;
                    if (typeof value == 'number') {
                      value = Math.abs(value);
                    }
                    $(td).find('span.hthelper-cell-title').html(value);
                    this.map.filledClearFormat(value, row, col);
                    break;
                  case 'other2': //其它
                    var html = '';
                    html = (type == 1) ? '' + val + value : '' + value + val;
                    $(td).find('span.hthelper-cell-title').html(html);
                    this.map.filledClearFormat(html, row, col);
                    break;
                  case 'tihuan': //替换
                    var html = '';
                    html = (value == val) ? type : value;
                    $(td).find('span.hthelper-cell-title').html(html);
                    this.map.filledClearFormat(html, row, col);
                    break;
                }
              }
              /*
              //数据有效性 设置
              var vdata = rules.vdata;
              if(vdata){
              	var arr = vdata.vdata.split(',')
              	  , empty = arr[0]      //是否为空
              	  , examine = arr[1]    //是否必须为空
              	  , target = arr[2]     //类型
              	  , judge = arr[3]      //比较
              	  , str1 = arr[4]       //值1
              	  , str2 = arr[5];      //值2
              	var json = HChtHelper.Validate.getCommon(value, arr, row, col);
              	HChtHelper.Validate.setTitle(json, td);
              }
              //函数
              var func = rules.func;
              if(func){
              	var len = func.length;
              	var list = [];
              	for(var i = 0; i < len; i++){
              		list.push(HChtHelper.Validate.getFunc(func[i], settings));
              	}
              	if(list.length > 0){
              		HChtHelper.Validate.setFuncTitle(list, td);
              	}
              }
              */
            }
          }
        }
      }

    }
    /**
     * 判断字符串的日期格式为yyyy-mm-dd和正确的日期，如果是Number类型，以日为单位1900/1/1为初始值转成日期格式
     */
    this.getDateFormat = function (strdate, format) {
      /**
       * 计算当前日期+N天后的日期
       *
       */
      function CurrentDateAddDay(n) {
        var t = new Date('1900/1/1');
        t.setDate(t.getDate() + (n - 1));
        return t;
      }
      /**
       * 判断是否闰年
       *
       */
      function isLeapYear(Year) {
        if (((Year % 4) == 0) && ((Year % 100) != 0) || ((Year % 400) == 0)) {
          return true;
        } else {
          return false;
        }
      }
      var reg = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
      var date = strdate;
      if (typeof strdate == 'number') {
        date = CurrentDateAddDay(date);
        date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + (date.getDate());
      }
      if (reg.test(date)) {
        arr = date.split('-');
        var flag = isLeapYear(arr[0]),
          b = false;
        var leap = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        var flat = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (flag) { //闰
          if (leap[(Number(arr[1]) - 1)] >= Number(arr[2])) {
            b = true;
          }
        } else { //平
          if (flat[(Number(arr[1]) - 1)] >= Number(arr[2])) {
            b = true;
          }
        }
      }
      if (b) { //如果是日期格式
        if (format == 'Default') {
          arr = arr.join('/');
        } else if (format == 'Date') {
          arr = arr[0] + '年' + arr[1] + '月' + arr[2] + '日';
        } else if (format == 'YearMonth') {
          arr = arr[0] + '年' + arr[1] + '月';
        }
      } else {
        arr = strdate
      }
      return arr;
    }
    /**
     * 自动成生唯一标识
     * @param {Number} len 长度
     * @param {Number} radix 进制
     * return uuid
     */
    this.guid = function (len, radix) {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
      var uuid = [],
        i;
      radix = radix || chars.length;

      if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
      } else {
        // rfc4122, version 4 form
        var r;

        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | Math.random() * 16;
            uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
          }
        }
      }
      return uuid.join(''); //.toLowerCase();
    }
    /**
     * 初始化配置参数 如果mini模式下则自动合并默认minidefaultsettings start
     * @param  {Object} userSettings
     */
    this.initSettings = function (userSettings) {
      if (userSettings.toolbar) {
        userSettings.toolbar = $.extend({}, defaultSettings.toolbar, userSettings.toolbar);
      }
      var miniSettings = {};
      if ((userSettings.toolbar && userSettings.toolbar.type == 'mini') || userSettings.toolbar === null) {
        miniSettings = miniDefaultSettings;
      }
      userSettings = $.extend({}, defaultSettings, miniSettings, userSettings);
      instance.GridSettings = userSettings;
    }
    /* end */
    this.load = function () {
      this.rootElement = rootElement;
      this.identity = this.guid(8, 16);
      this.tid = rootElement.attr('id') || this.identity;
      this.initSettings(settings);
      if (instance.GridSettings.power) {
        instance.GridSettings.power.obj = new HChtHelper.Power(instance);
      }
      if (instance.GridSettings) {
        var styleData = instance.GridSettings.styleData || [
          []
        ];
        var data = instance.GridSettings.data || [
          []
        ];
        var ruleData = instance.GridSettings.ruleData || [
          []
        ];
        var colWidths = instance.GridSettings.colWidths || [];
        var row = Math.max(styleData.length, data.length, ruleData.length) || 10;
        var col = Math.max(styleData[0].length, data[0].length, ruleData[0].length) || 10;
        if (instance.GridSettings.data[0].length == 0) {
          data = HChtHelper.Common.loadTableData(row, col);
        }
        if (styleData[0].length == 0) {
          this.initRule(data, 'styleData');
        }
        if (ruleData[0].length == 0) {
          this.initRule(data, 'ruleData');
        }
        instance.GridSettings.fixedRowsTop = instance.GridSettings.fixedRowsTop || 0;
        instance.GridSettings.fixedColumnsLeft = instance.GridSettings.fixedColumnsLeft || 0;
      } else {
        instance.GridSettings.data = HChtHelper.Common.loadTableData(10, 10);
        var ruleData = [],
          styleData = [];
        for (var i = 0; i < 10; i++) {
          ruleData.push([]);
          styleData.push([]);
          for (var j = 0; j < 10; j++) {
            ruleData[i][j] = {};
            styleData[i][j] = {};
          }
        }
        instance.GridSettings.ruleData = ruleData;
        instance.GridSettings.styleData = styleData;
      }

      if (instance.GridSettings.tableskin) { //添加表格皮肤
        instance.rootElement.addClass('handsontable-' + instance.GridSettings.tableskin);
      }
      if (instance.GridSettings.theight) { //添加表格皮肤
        instance.rootElement.addClass('handsontable-theight' + instance.GridSettings.theight);
      }
      if (instance.GridSettings.fixedRowsTop || instance.GridSettings.fixedColumnsLeft) { //fixed模式
        //instance.rootElement.css('overflow', 'scroll');
        this.controller.fixedTableskin([1, , , , 'm', 'c'], [1, , , , 'm']);
      }
      //不定长报表
      // if(instance.GridSettings.randomtable){ instance.GridSettings.minSpareRows = 1; }
      priv.setHandsontable();
      if (instance.GridSettings.client != 'ipad') {
        var h = instance.rootElement.find('.ht_master table').outerHeight();
        var w = instance.rootElement.find('.ht_master table').outerWidth();
        //if(w > 1100){ instance.rootElement.css('overflow-x', 'scroll'); }
        //if(h > 550){ instance.rootElement.css('overflow-y', 'scroll'); }
      } else if (instance.GridSettings.client == 'ipad') {
        instance.rootElement.css({
          'max-width': '10000px',
          'max-height': '10000px'
        })
      }
    }
    /**
     * 初始化样式JSON数组 及 公式JSON数据 于表格同步
     */
    this.initRule = function (data, type) {
      var rows = data.length;
      if (rows > 0) {
        var cols = data[0].length;
        var arrs = [];
        for (var i = 0; i < rows; i++) {
          var arr = [];
          for (var j = 0; j < cols; j++) {
            arr.push({});
          }
          arrs.push(arr);
        }
        instance.GridSettings[type] = arrs;
      }
    }
    this.init = function () {
      this.load();
      if (instance.GridSettings.toolbar) {
        if (instance.GridSettings.toolbar.type == 'all') {
          view.createTemplate(instance); //创建模版
          //this.setHeaderColumns(); //绑定表头 选择行列
        } else if (instance.GridSettings.toolbar.type == 'mini') {
          view.createTemplateMini(instance);
        }
        instanceToolbar = $('#' + instance.identity + '-' + instance.tid);
        // 绑定事件
        instanceToolbar.find('select[data-toggle = hthelper]').on('change', function () {
          var cells = $(this).data('cells');
          if (instance.getCells(cells)) {
            instanceToolbar.find('div.hthelper-popup').hide();
            var index = this.selectedIndex;
            $(this)[index > 0 ? 'addClass' : 'removeClass']('active');
            instance.alert(this);
          }
        });
        instanceToolbar.on('mouseenter', 'a[data-toggle="hthelper"]', function (event) {
          var title = $(this).data('title');
          var align = $(this).data('align');
          var className = 'hthelper-tips-arrow';
          var pName = 'hthelper-tips hthelper-tips-top';
          if (align == 'middle-right') {
            className = 'hthelper-tips-arrow-mr';
            pName = 'hthelper-tips hthelper-tips-left';
          }
          var tips = document.getElementById('tips-' + instance.tid);
          if (!tips) {
            instanceToolbar.append('<div class="' + pName + '" id="tips-' + instance.tid + '"><div class="' + className + '"></div><p></p></div>');
          }
          if (title) {
            tips = document.getElementById('tips-' + instance.tid);
            tips.className = pName;
            tips.childNodes[0].className = className;
            tips.childNodes[1].innerHTML = title;
            priv.fixedShow(this, tips, 'bottom-center', 'hthelper-comain');
          }
        }).on('mouseleave', 'a[data-toggle=hthelper]', function () {
          document.getElementById('tips-' + instance.tid).style.display = 'none';

        }).on('click', 'a[data-toggle="hthelper"]', function (event) {
          var cells = $(this).data('cells');
          if (instance.getCells(cells)) {
            //instanceToolbar.find('a[data-toggle=hthelper]').removeClass('active');
            var toggle = $(this).data('target');
            if (toggle == 'zbgroup') {
              instance.ps = new panelselection(designVm);
              instance.ps.init({
                id: 'aaa',
                isInitReset: false,
                isMultiBtn: true,
                isExcelBtn: true,
                getSelectedZbGroup: function () {
                  var coords = instance.handsontable.getSelected();
                  coords = instance.setCellSelectionSort(coords);
                  var json = instance.map.getColumnZbGroup(coords[0], coords[1]);
                  json.coords = coords;
                  json.strCoord = HChtHelper.Common.getExcelArrayToChar(coords);
                  return json;
                }
              });
              instance.ps.outSideCreateHtml({
                isMask: true,
                isTitle: true,
                eventOk: instance.controller.psZbgroup
              });
            } else {
              $(this)[$(this).hasClass('active') ? 'removeClass' : 'addClass']('active').siblings('[data-toggle=hthelper]').removeClass('active');
              instanceToolbar.find('div.hthelper-popup').hide();
              instance.alert(this);
            }
          }
          HChtHelper.Common.stopPropagation(event);

        }).on('click', '.sed', function () { //选中单元格
          let coord = $(this).data('coord');
          if (coord) {
            coord = coord.split(',');
            instance.handsontable.selectCell(Number(coord[0]), Number(coord[1]));
          }
        }).on('click', '.hthelper-submit', function () { //搜索
          var target = this.getAttribute('data-target') || '';
          if (target == 'searchall') {
            var value = $(this).siblings('input').val();
            var arr = [];
            $(this).parents('.hthelper-selector').siblings().find('tbody').html('');
            var data = instance.GridSettings.data;
            var ruleData = instance.GridSettings.ruleData;
            for (var j = 0, slen = data[0].length; j < slen; j++) {
              for (var i = 0, len = data.length; i < len; i++) {
                //var ruleRow =ruleData[i]
                //var ruleCol = ruleRow[j];
                var val = data[i][j];
                //if(ruleCol && ruleCol.zb){
                if (val) {
                  if (val.indexOf(value) < 0) {
                    continue;
                  }
                  //if(ruleCol.zb[1].indexOf(value) < 0){continue;}
                  arr.push('<tr>');
                  arr.push('<td class="alignc vam">' + HChtHelper.Common.getExcelArrayToChar([i, j]) + '</td>');
                  arr.push('<td data-target="fmt-del">' + data[i][j] + '</td>');
                  //arr.push('<td data-target="fmt-del">'+ruleCol.zb+'</td>');
                  arr.push('<td class="alignc vam"><span class="sed" data-coord="' + i + ',' + j + '">' + HChtHelper.Common.getExcelArrayToChar([i, j]) + '</span></td></tr>');
                }
              }
            }
            $(this).parents('.hthelper-selector').siblings().find('tbody').html(arr.join(''));
          }
        }).on('click', '[data-toggle="hchthelper-col-checkformat"]', function (event) {
          HChtHelper.Common.stopPropagation(event);
          var strCoord = $(this).data('coord');
          var type = $(this).data('type');
          var target = $(this).data('target');
          let coord = HChtHelper.Common.getExcelCharToArray(strCoord);
          if (type == 'selected') {
            instance.handsontable.selectCell(Number(coord[0]), Number(coord[1]));
          } else if (type == 'update') {
            if (target == 'func') {
              instance.handsontable.selectCell(Number(coord[0]), Number(coord[1]));
              var $validitydata = instanceToolbar.find('a[data-target="validitydata"][data-toggle="hthelper"]')
              $validitydata.click();
              var ruleCol = instance.map.getColumnProp(Number(coord[0]), Number(coord[1]), 'rule', 'ruleData');
              if (ruleCol) {
                var pid = _this.parent('div').data('id');
                var divId = 'validitydata-' + pid + '-' + instance.tid;
                $('#' + divId).find('a[data-target="func"]').click();
                var contdivId = 'cont-validitydata-' + pid + '-' + instance.tid;

              }
            }
          } else if (type == 'del') {
            if (target == 'func') {
              delete instance.GridSettings.ruleData[Number(coord[0])][Number(coord[1])].rule.func;
            } else if (target == 'formula') {
              delete instance.GridSettings.ruleData[Number(coord[0])][Number(coord[1])].rule.formula;
            }
            $(this).parents('td').html('');
            instance.handsontable.render();
          }
        });

        //取消右键
        $('#' + this.identity + '-' + this.tid).on('contextmenu', function () {
          return false;
        });

        if (instance.GridSettings.toolbar.type == 'all') {
          //公式
          $('#formula-txt-' + instance.tid).on('mousedown keyup', function (event) {
            var cells = $(this).data('cells');
            event = event || window.event;
            if (instance.getCells(cells) || event.type == 'mousedown') {
              if (event.keyCode == 13) {
                //中文字符
                var reg = /[^\x00-\xff]/;
                if (reg.test(this.value) && this.value.toUpperCase().indexOf('IF') === -1) {
                  layer.msg('请勿输入中文字符', {
                    icon: 2
                  });
                } else {
                  instance.map.setFormula(this.value);
                  if (instance.GridSettings.autoCalculation && instance.GridSettings.autoCalculation === true) {
                    instance.alert(this);
                  } else {
                    instance.handsontable.render();
                  }
                }
              }
            } else {
              this.value = '';
            }
            HChtHelper.Common.stopPropagation(event);
          });
          if (instance.GridSettings.fixed) {
            //表头
            $(window).on('scroll', function () {
              var tabs = document.getElementById(instance.identity + '-' + instance.tid);
              var arr = priv.findPosition(tabs);
              var scrTop = priv.getScrollTop(),
                top = arr[1];
              if (scrTop > top) {
                $(tabs).addClass('hthelper-main-fixed');
                var h = $(tabs).height();
                if ($('#mar-' + instance.identity + '-' + instance.tid).length == 0) {
                  $(tabs).before('<div style="height:' + (h + 2) + 'px" id="mar-' + instance.identity + '-' + instance.tid + '"></div>')
                }
              } else {
                $(tabs).removeClass('hthelper-main-fixed');
                $('#mar-' + instance.identity + '-' + instance.tid).remove();
              }
            });
          }
          //点击单元格显示指标分组
          instance.rootElement.on('click', 'div.wtHider div.wtSpreader th', function () { //选择整行/列
            var rows = instance.GridSettings.data.length - 1 - (instance.GridSettings.minSpareRows || 0),
              cols = instance.GridSettings.data[0].length - 1 - (instance.GridSettings.minSpareCols || 0),
              startCol = 0,
              startRow = 0,
              endRow = rows,
              endCol = cols,
              index = $(this).index();
            if ($(this).closest('thead').length > 0) {
              if (index > 0) {
                --index;
                startCol = endCol = index;
              }
            } else if ($(this).closest('tbody').length > 0) {
              index = Number($(this).text()) - 1;
              startRow = endRow = index;
            }
            instance.handsontable.selection.setRangeStart({
              'row': startRow,
              'col': startCol
            });
            instance.handsontable.selection.setRangeEnd({
              'row': endRow,
              'col': endCol
            }, false);
            // layer.tips('<a class="hchthelper-layer-colsformat" href="javascript:;">设置行/列函数</a>', this, {tips: [1, '#f7f7f7'], time: 8000});
          })
        }
        //点击单元格显示指标分组
        instance.rootElement.on('click', 'td a', function (event) {
          let coord = instance.handsontable.getSelected();
          if(event.currentTarget.classList[1] == 'e-icon-custom3'){
            //公式
            instance.popupSelectedGS(coord[0], coord[1], this, event);
          }else{
            //指标
            instance.popupSelectedZbG(coord[0], coord[1], this, event);
          }
          HChtHelper.Common.stopPropagation(event);
        }).on('click', 'td', function () {
          $('#popover-' + instance.tid).hide();
        })

        //监听ctrl+v
        $(document).on('paste', function (text) {
          if (!instance.GridSettings.autoCalculation) {
            return;
          }
          setTimeout(function () {
            instance.controller.calculation();
            //instance.controller.autofetching();
            instance.handsontable.render();
          }, 200);

        })

        $(document).on('click', function (event) {
            var ev = event || window.event;
            var target = ev.target || ev.srcElement;
            if ($(target).parents('.hthelper-popup').length == 0) {
              instanceToolbar.find('.hthelper-popup').hide();
            }
            if ($(target).parents('#' + instance.identity + '-' + instance.tid).length > 0) {
              $('#saves-' + instance.tid).hide();
            }
            if (target.nodeName != 'TD' && $(target).closest('td').length == 0 || $(target).closest('#' + instance.tid).length == 0) {
              $('#popover-' + instance.tid).hide();
            }
          }).on('click', '.hchthelper-layer-colsformat', function () { //设置行/列函数
            var index = layer.tips();
            var ix = $(this).data('index');
            var json = null;
            if (ix != undefined) {
              json = instance.GridSettings.colFormats[ix];
            }

            layer.close(index);
            layer.open({
              title: '设置行/列函数',
              type: 1,
              //skin: 'layui-layer-rim', //加上边框
              area: ['360px', '300px'], //宽高
              content: view.getColumnFormats(json, ix),
              btn: ['确定', '取消'],
              yes: function (index, layero) {
                layer.close(index);
                var type = '';
                type = !colformatVal[2] ? colformatVal[1] || 0 : (colformatVal[1] || 0) + ',' + (colformatVal[2] || 0);
                if (colformatVal[14] != undefined) {
                  instance.GridSettings.colFormats.splice(colformatVal[14], 1, {
                    'func': colformatVal[11].toUpperCase(),
                    'note': (colformatVal[12] || ''),
                    'novalidity': (colformatVal[13] || '').toUpperCase(),
                    'examine': colformatVal[0],
                    'type': type
                  });
                } else {
                  instance.GridSettings.colFormats.push({
                    'func': colformatVal[11].toUpperCase(),
                    'note': (colformatVal[12] || ''),
                    'novalidity': (colformatVal[13] || '').toUpperCase(),
                    'examine': colformatVal[0],
                    'type': type
                  });
                }
                colformatVal = [];
              }
            });
          })
          .on('click', '[data-target="htselector"]', function () {
            var index = $(this).attr('index');
            if (colformatVal[index]) {
              colformatVal[index] = 0;
              $(this).removeClass('current');
            } else {
              colformatVal[index] = 1;
              $(this).addClass('current');
            }
          }).on('blur', '[data-target="httxt"]', function () {
            var index = $(this).attr('index');
            colformatVal[index] = $(this).val();
          });

        /*
        //自定义函数 多表格
        $('html').on('click', '#mytabs-'+instance.tid+' a[data-toggle="tab"]', function(e){
        	e = e || window.event;
        	e.preventDefault();
        	$(this).tab('show');
        })*/
      }
      /* save start  */
      //初始化工具栏保存
      var Tabs = new HChtHelper.Tabs(instance);
      Tabs.toolbar = ['save2'];
      Tabs.Class = 'hthelper-layer _hthelper-tabs _hthelper-layer hthelper-popup hthelper-save';
      Tabs.barClass = 'hthelper-layer-bar _hthelper-layer-bar hthelper-drag';
      Tabs.contClass = 'hthelper-cont hthelper-save-list';
      Tabs.len = 1;
      Tabs.cssText = '';
      Tabs.index = 0;
      Tabs.identity = 'saves';
      Tabs.priv = priv;
      Tabs.tag = '.parent'; //'div.ht_master.before';
      Tabs.saveFlag = false,
        Tabs.target = 'save2',
        Tabs.save = instance.GridSettings.saveTableView
      Tabs.init();
      //拖动
      var Drag = new HChtHelper.Drag(instance);
      Drag.pnode = document.getElementById('saves-' + instance.tid);
      Drag.obj = $(Drag.pnode).children('div.hthelper-drag')[0];
      Drag.init();

      //选中单元格
      $('#saves-' + instance.tid).append('<div id="handle-saves-example" class="hthelper-handle _hthelper-handle"><input data-type="Confirm" value="确 定" class="hthelper-btn hthelper-submit" type="button"><span></span><input data-type="Cancel" value="取 消" class="hthelper-btn hthelper-cancel" type="button"></div>').on('click', '.sed', function () {
        let coord = $(this).data('coord');
        if (coord) {
          coord = coord.split(',');
          instance.handsontable.selectCell(Number(coord[0]), Number(coord[1]));
        }
      });

      $('#handle-saves-' + instance.tid).on('click', 'input.hthelper-btn', function () {
        var type = $(this).data('type');
        if (type == 'Confirm') {
          if (instance.GridSettings.saveTableView instanceof Function) {
            instance.GridSettings.saveTableView();
          }
        }
        $('#saves-' + instance.tid).hide();
      });

      /* save end  */

      //priv.arrowTab();

      //清除editor编辑
      for (var i = 0, len = instance.GridSettings.styleData.length; i < len; i++) {
        var row = instance.GridSettings.styleData[i];
        for (var j = 0, jLen = row.length; j < jLen; j++) {
          var json = row[j];
          delete json.editor;
        }
      }

      //选择器
      rootElement.on('click', '[data-toggle="hthelper-selector"]', function (event) {
        let coord = instance.handsontable.getSelected();
        var type = this.type.toUpperCase();
        var nodeName = this.nodeName.toUpperCase();
        if (type == 'CHECKBOX') {
          instance.GridSettings.data[coord[0]][coord[1]] = this.checked ? '1' : '0';
        } else if (type == 'RADIO') {
          var name = this.name;
          var $radio = rootElement.find('[data-toggle="hthelper-selector"][name="' + name + '"]');
          for (var i = 0, len = $radio.length; i < len; i++) {
            var row = $radio.eq(i).attr('row');
            var col = $radio.eq(i).attr('col');
            instance.GridSettings.data[row][col] = '0';
          }
          instance.GridSettings.data[coord[0]][coord[1]] = '1';
        } else {
          if (nodeName == 'SELECT') {
            instance.GridSettings.data[coord[0]][coord[1]] = this.options[this.selectedIndex].value;
          }
        }
        //HChtHelper.Common.stopPropagation(event);
      });
      //importdata webuploader初始化
      instanceToolbar.find('[data-toggle="hthelper"][data-target="importdata"]').each(function (idx) {
        var WU = new HChtHelper.Uploder(instance);
        WU.init(this);
      });


      //加载完成调用的方法
      if (instance.GridSettings.afterLoadData instanceof Function) {
        instance.GridSettings.afterLoadData(instance);
      }
    }
    //view 视图
    view = {
      /**
       * selector选择器 子内容
       * @param  {Object} sThis html对象
       */
      childSelector: function (sThis) {
        var subtarget = $(sThis).data('subtarget');
        var menus = HChtHelper.Config.menus;
        var arr = [];
        switch (subtarget) {
          case 'checkbox':
            break;
          case 'radio':
            arr.push('<label class="dbk"><span class="ddz htsp-title">组名：</span><input type="text" class="httxt httxt-title"></label>');
            break;
          case 'dropdown':
            arr.push('<input type="button" style="height:24px; line-height:22px; padding:0px 6px; margin-right:20px" class="hthelper-btn hthelper-submit fr" value="添 加"><div class="clearfix hthelper-dropdown-add"><label class="dbk"><span class="ddz htsp-title">属性名：</span><input type="text" class="httxt ht-dropdown-title"><span class="pad0006"></span><span class="ddz htsp-title">属性值：</span><input type="text" class="httxt ht-dropdown-title"></label></div>');
            break;
          case 'calendar':
            arr.push('<label class="dbk"><span class="ddz htsp-title">格式：</span><select class="httxt httxt-title">');
            var list = HChtHelper.Config.icon.calendar.list;
            for (var i = 0, len = list.length; i < len; i++) {
              var json = list[i];
              arr.push('<option value="' + json.target + '">' + menus[json.target] + '</option>');
            }
            arr.push('</select></label>');
            break;
          case 'commoncode':
          case 'dynamicdrop':
            arr.push('<div class="hthelper-selector">');
            arr.push('<label style="padding:0" data-target="hthelper-selector" class="hthelper-selector-lbl">');
            var list = HChtHelper.Config.icon[subtarget].list;
            if (list) {
              for (var i = 0, len = list.length; i < len; i++) {
                arr.push('<input type="radio" name="' + subtarget + '" data-subtarget="' + list[i].target + '" class="htcheck dis-none" title="' + menus[list[i].target].name + '"/>');
              }
            }
            arr.push('</label></div>');
            arr.push('<div class="hthelper-selector-' + subtarget + '"></div>');
            break;
        }
        var $div = $(sThis).closest('.hthelper-selector').siblings('.hthelper-subcont-2').find('div[data-subtarget="' + subtarget + '"]');
        if ($div.html() == '') {
          $div.html(arr.join(''));
          $div.find('input.hthelper-submit').on('click', function () {
            var $dd = $(this).siblings('div.hthelper-dropdown-add');
            $dd.append('<label class="dbk">' + $dd.find('label:last').html() + '</label>');
          });
          var Selector = new HChtHelper.Selector(instance);
          Selector.tag = 'div[data-subtarget="' + subtarget + '"] [data-target="hthelper-selector"]';
          Selector.init();
        }
        $div.show().siblings().hide();
      },
      /**
       * 下拉菜单初始化标签
       * @param {Object}	_this 			js html 对象
       * @param {JSON}	jsons 			数据源
       * @param {String}	target
       * @param {Boolean}	iconFlag		是否加载图标
       * @param {Object} root  JQ html 	对象
       */
      dropdown: function (_this, jsons, target, iconFlag, root) {
        var menus = HChtHelper.Config.icon;
        if (instanceToolbar.find('div[subtarget="' + target + '"]').length == 0) {
          var arr = [];
          arr.push('<div class="hthelper-popup hthelper-clearformat _hthelper-clearformat _hthelper-' + target + '" subtarget="' + target + '">');
          for (var i = 0; i < jsons.length; i++) {
            var starget = jsons[i].target;
            var icon = menus[starget].icon;
            var istit = menus[starget].istit;
            var title = istit === false ? 'data-title="' + menus[starget].name + '"' : '';
            arr.push('<a href="javascript:;" data-cells="' + menus[starget].allowCell + '" data-toggle="hthelper" data-target="' + starget + '"  ' + title + ' data-value="' + menus[starget].name + '">');
            if (iconFlag) {
              arr.push('<span class="ddz excel-icon e-icon-' + starget + '"></span>');
            }
            if (istit !== false) {
              arr.push('<span class="title">' + menus[starget].name + '</span>');
            }
            arr.push('</a>');
          }
          arr.push('</div>');
          if (root) {
            root.append(arr.join(''));
          } else
            $(_this).parent().append(arr.join(''));
        }
        priv.fixedShow(_this, instanceToolbar.find('div[subtarget="' + target + '"]')[0], 'bottom-left', 'hthelper-comain');
      },
      /**
       * 获取设置整行/列函数
       * @param {JSON}	json
       * @param {Number}	index
       */
      getColumnFormats: function (json, index) {
        //{"func":"[4]==[5]","note":"备备备备备备备备","novalidity":"A,B","examine":1,"type":"1,1"}
        colformatVal = [];
        if (json) {
          colformatVal[11] = json.func;
          colformatVal[12] = json.note;
          colformatVal[13] = json.novalidity;
          colformatVal[14] = index;
          colformatVal[0] = parseInt(json.examine || 0);
          if (json.type) {
            if (json.type.toString().indexOf(',') > -1) {
              var arr = json.type.split(',');
              colformatVal[1] = parseInt(arr[0] || 0);
              colformatVal[2] = parseInt(arr[1] || 0);
            } else {
              colformatVal[1] = parseInt(json.type || 0);
              colformatVal[2] = 0;
            }
          }
        } else {
          json = {};
        }
        var arr = [];
        arr.push('<div class="hthelper-subcont clearfix">');
        arr.push('<div class="hthelper-selector">');
        arr.push('<label data-target="hthelper-selector" class="hthelper-selector-lbl"><span type="checkbox" data-target="htselector" index="0" data-guid="90B84E46" class="htcheck hthelper-sr hthelper-srl hthelper-srr ' + (json.examine ? 'current' : '') + '">是否必须审核</span></label>');
        arr.push('<label data-target="hthelper-selector" class="hthelper-selector-lbl"><span data-target="htselector" index="1" type="checkbox" data-guid="9024A7A4" class="htcheck hthelper-sr hthelper-srl ' + (colformatVal[1] ? 'current' : '') + '">审核</span><span data-target="htselector" index="2" type="checkbox" data-guid="1252A94B" class="htcheck hthelper-sr hthelper-srr ' + (colformatVal[2] ? 'current' : '') + '">验收</span></label>');
        arr.push('</div>');
        arr.push('<div class="hthelper-dformat-list _hthelper-dformat-list _hthelper-func-list">');
        arr.push('<label class="dbk"><span class="ddz htsp-title">表达式：</span><input type="text" class="httxt httxt-title" index="11" data-target="httxt" value="' + (json.func || '') + '"></label>');
        arr.push('<label class="dbk"><span class="ddz htsp-title">备注：</span><input type="text" index="12" class="httxt httxt-title" data-target="httxt" value="' + (json.note || '') + '"></label>');
        arr.push('<label class="ddz"><span class="ddz htsp-title">非验证：</span><input type="text" index="13" class="httxt httxt-title" style="width:120px;" data-target="httxt" value="' + (json.novalidity || '') + '"></label>');
        arr.push('&nbsp;1,2,3...&nbsp;|&nbsp;a,b...</div>')
        arr.push('</div>');
        return arr.join('');
      },
      /**
       * 上一数据源
       */
      getPrevDatas: function () {
        var arr = [];
        arr.push('<div class="col-xs-12 pt12">')
        arr.push('<div class="col-xs-6 _hthelper-func-list"><label class="ddz"><span class="ddz htsp-title">表达式：</span><input type="text" class="httxt httxt-title"></label></div>');
        arr.push('<div class="col-xs-6 _hthelper-func-list"><label class="ddz"><span class="ddz htsp-title">备注：</span><input type="text" class="httxt httxt-title"></label></div>');
        arr.push('</div>');
        arr.push('<div class="col-xs-12 pt6">');

        arr.push('<ul id="mytabs-' + instance.tid + '" class="nav nav-tabs ">');
        var arr2 = [];
        var i = 0;
        for (var it in instance.GridSettings.prevDatas) {
          var id = it + '-' + instance.tid;
          var cur = i == 0 ? 'active' : '';
          arr.push('<li class="' + cur + '"><a href="#' + id + '">' + it + '</a></li>');
          arr2.push('<div class="tab-pane ' + cur + '" id="' + id + '">' + id + '</div>');
          i++;
        }
        arr.push('</ul>');

        arr.push('<div class="tab-content hthelper-prevcontent">');
        arr.push(arr2.join(''));
        arr.push('</div>');

        arr.push('</div>');
        return arr.join('');
      },
      /**
       * 生成模版 menu
       * @param {Object} instance hchthelper对象
       *
       */
      createTemplate: function (instance) {
        var menu = instance.GridSettings.toolbar.menu;
        var icon = HChtHelper.Config.icon;
        var arr = [];
        for (var i = 0; i < menu.length; i++) {
          for (var it in menu[i]) {
            arr.push(it);
          }
        }
        //初始化工具栏
        var Tabs = new HChtHelper.Tabs(instance);
        Tabs.toolbar = arr;
        Tabs.Class = 'hthelper-comain hthelper-main _hthelper-main';
        Tabs.barClass = 'hthelper-tabs _hthelper-tabs';
        Tabs.contClass = 'hthelper-contents _hthelper-contents';
        Tabs.len = arr.length;
        Tabs.cssText = '';
        Tabs.index = instance.GridSettings.toolbar.selectedIndex;
        Tabs.identity = instance.identity;
        Tabs.priv = priv;
        Tabs.tag = '.parent'; //'div.ht_master.before';
        Tabs.init();

        for (var i = 0; i < menu.length; i++) {
          var json = menu[i],
            it, submenu = [];
          for (it in json) {
            submenu = json[it];
          }

          for (var j = 0; j < submenu.length; j++) {
            var cells = {};
            var frist = icon[submenu[j]] || {};
            var Temp = new HChtHelper.Template(instance);
            Temp.Class = 'hthelper-box _hthelper-box _hthelper-' + it + '-box ddz';
            Temp.cells = [];
            if (submenu[j] instanceof Array) {
              for (var k = 0; k < submenu[j].length; k++) {
                if (submenu[j][k] == 'family') {
                  this.family(i, Tabs.identity, it);
                  continue;
                }
                if (submenu[j][k] == 'size') {
                  this.size(i, Tabs.identity, it);
                  continue;
                }
                cells = icon[submenu[j][k]];
                cells.target = submenu[j][k];
                Temp.cells.push(cells);
                frist = icon[submenu[j][0]];

              }
            } else {
              cells = frist;
              cells.target = submenu[j];
              Temp.cells.push(cells);
            }

            Temp.tag = 'div[data-id="cont-' + Tabs.identity + '-' + instance.tid + '"]:eq(' + i + ').append';
            //Temp.title = frist.title;
            Temp.init();
          }
        }
        if (instance.GridSettings.toolbar.flag) {
          var arr = [];
          arr.push('<div class="hthelper-formula-fast _hthelper-formula-fast">');
          arr.push('<span id="formula-coords-' + instance.tid + '" class="hthelper-formula-coords ddz"></span><div class="ddz hthelper-formula-subfast"><span class="sheet-icon e-icon-formulas ddz"></span></div><input type="text" data-toggle="" data-cells="many" class="formula-txt" id="formula-txt-' + instance.tid + '"/>');
          //arr.push('<label class="ddz"><a href="javascript:;" class="hthelper-btn hthelper-submit hthelper-manual-calculation" data-cells="one" data-toggle="hthelper" data-target="rank" id="rank-'+instance.tid+'">'+HChtHelper.Config.menus['rank']+'</a></label><span class="pad0006"></span>');
          $('#' + Tabs.identity + '-' + instance.tid).append(arr.join(''));
          //instance.rootElement.find('div.ht_clone_top,div.ht_clone_left,div.ht_clone_corner').css('margin-top','188px');
        } else {
          //instance.rootElement.find('div.ht_clone_top,div.ht_clone_left,div.ht_clone_corner').css('margin-top','142px');
        }
      },
      /**
       * 生成模版 mini
       * @param {Object} instance hchthelper对象
       *
       */
      createTemplateMini: function () {
        var menu = instance.GridSettings.toolbar.miniMenu;
        var icon = HChtHelper.Config.icon;
        //初始化工具栏
        var Mini = new HChtHelper.Mini(instance);
        Mini.Class = 'hthelper-comain hthelper-minimain _hthelper-minimain';
        Mini.contClass = 'hthelper-minicontents _hthelper-minicontents';
        Mini.toolbar = menu;
        Mini.tag = '.parent'; //'div.ht_master.before';
        Mini.init();
      },
      /**
       * 生成字体工具栏
       */
      family: function (i, identity, it) {
        // 字体
        var TFont = new HChtHelper.Template(instance);
        TFont.Class = 'hthelper-box _hthelper-box hthelper-box-family ddz';
        TFont.tag = 'div[data-id="cont-' + identity + '-' + instance.tid + '"]:eq(' + i + ').append';
        TFont.autoTemplate = function () {
          var arr = [];
          arr.push('<div class="hthelper-box-half"><select data-toggle="hthelper" data-target="family" data-cells="many" class="ht-txt ht-box-items hthelper-sel-family">');
          var list = HChtHelper.Config.list;
          for (var i = 0, n = list.family.length; i < n; i++) {
            arr.push('<option value="' + list.family[i] + '">' + list.family[i] + '</option>');
          }
          arr.push('</select></div>');
          return arr.join('');
        }
        //TFont.title = '字体';
        TFont.init();
      },
      size: function (i, identity, it) {
        // 字号
        var TFont = new HChtHelper.Template(instance);
        TFont.Class = 'hthelper-box _hthelper-box hthelper-box-font ddz';
        TFont.tag = 'div[data-id="cont-' + identity + '-' + instance.tid + '"]:eq(' + i + ').append';
        TFont.autoTemplate = function () {
          var arr = [];
          arr.push('<div class="hthelper-box-half"><select data-toggle="hthelper" data-target="font" data-cells="many" class="ht-txt ht-box-items hthelper-sel-font">');
          var list = HChtHelper.Config.list;
          for (var i = 0, n = list.size.length; i < n; i++) {
            arr.push('<option value="' + list.size[i] + '">' + list.size[i] + '</option>');
          }
          arr.push('</select></div>');
          return arr.join('');
        }
        //TFont.title = '字号';
        TFont.init();
      },
      /**
       * 点击工具栏各栏目 所对应的弹出框
       * @param {String} _this  html标签对象
       */
      setSecondMenu: function (_this) {
        var secondMenu = instance.GridSettings.toolbar.secondMenu;
        var target = $(_this).data('target');
        var menus = HChtHelper.Config.menus;
        switch (target) {
          case 'row':
          case 'col':
          case 'vertical':
          case 'align':
          case 'stretch':
          case 'border':
            var jsons = HChtHelper.Config.icon[target].list || HChtHelper.Config.list[target];
            var iconFlag = HChtHelper.Config.icon[target].iconFlag === false ? false : true;
            this.dropdown(_this, jsons, target, iconFlag);
            break;
          case 'zbgroup':
            var arr = secondMenu.zbgroup;
            var Tchb = new HChtHelper.TCHB(instance);
            Tchb.obj = _this;
            Tchb.priv = priv;
            Tchb.Tabs.toolbar = arr;
            Tchb.Tabs.len = arr.length;
            Tchb.init();

            for (var i = 0; i < arr.length; i++) {

              if (arr[i] == 'zb') { //指标
                var MsZb = new HChtHelper.MultiSelect(instance);
                MsZb.tag = 'div[data-id="cont-' + target + '-' + Tchb.identity + '-' + instance.tid + '"]:eq(' + i + ').html';
                MsZb.async = true;
                MsZb.url = 'indiDef-selectZbListForReport.action';
                MsZb.target = arr[i];
                MsZb.save = instance.controller.zbgroup;
                MsZb.init();
              } else if (arr[i] == 'group') { //分组
                var MsGroup = new HChtHelper.MultiSelect(instance);
                MsGroup.tag = 'div[data-id="cont-' + target + '-' + Tchb.identity + '-' + instance.tid + '"]:eq(' + i + ').html';
                MsGroup.async = true;
                MsGroup.url = 'groupDic-selectGroupListForReport.action';
                MsGroup.target = arr[i];
                MsGroup.save = instance.controller.zbgroup;
                MsGroup.init();
              } else if (arr[i] == 'area2') { //区域
                var MsArea = new HChtHelper.MultiSelect(instance);
                MsArea.tag = 'div[data-id="cont-' + target + '-' + Tchb.identity + '-' + instance.tid + '"]:eq(' + i + ').html';
                MsArea.async = true;
                MsArea.url = 'area-selectAreaListForReport.action';
                MsArea.target = arr[i];
                MsArea.rootId = 0;
                MsArea.save = instance.controller.zbgroup;
                MsArea.init();
              } else if (arr[i] == 'contrast') { //对比项
                var MsContrast = new HChtHelper.MultiSelect(instance);
                MsContrast.tag = 'div[data-id="cont-' + target + '-' + Tchb.identity + '-' + instance.tid + '"]:eq(' + i + ').html';
                MsContrast.url = 'indiCalc-selectCalcListForReport.action';
                MsContrast.target = arr[i];
                MsContrast.rootId = 0;
                MsContrast.save = instance.controller.zbgroup;
                MsContrast.init();
              } else if (arr[i] == 'qb') { //期别

              }
            }
            break;
          case 'selector':
            var Tchb = new HChtHelper.TCHB(instance);
            Tchb.obj = _this;
            Tchb.priv = priv;
            Tchb.Tabs.toolbar = [target];
            Tchb.Tabs.len = 1;
            Tchb.Tabs.save = function () {
              instance.controller.selector(_this);
              instance.handsontable.render();
            };

            Tchb.createHtml = function () {
              var arr = [];
              arr.push('<div class="hthelper-subcont clearfix">');
              arr.push('<div class="hthelper-selector">');
              arr.push('<label data-target="hthelper-selector" class="hthelper-selector-lbl">');
              for (var i = 0, len = secondMenu.selector.length; i < len; i++) {
                arr.push('<input type="radio" name="r" data-subtarget="' + secondMenu.selector[i] + '" class="htcheck dis-none" title="' + menus[secondMenu.selector[i]] + '"/>');
              }
              arr.push('</label></div>');
              arr.push('<div class="hthelper-subcont-2 clearfix">');
              for (var i = 0, len = secondMenu.selector.length; i < len; i++) {
                arr.push('<div class="hthelper-dformat-list _hthelper-dformat-list _hthelper-selector-list" data-subtarget="' + secondMenu.selector[i] + '"></div>');
              }
              arr.push('</div>');
              instanceToolbar.find('div[data-id="cont-' + target + '-' + Tchb.identity + '-' + instance.tid + '"]:eq(0)').html(arr.join(''));
            };
            Tchb.afterInit = function () {
              var Selector = new HChtHelper.Selector(instance);
              Selector.tabEvent = view.childSelector;
              Selector.init();
            };
            Tchb.init();
            break;
          case 'clearformat':
            var $cf = $('#clearformat-' + instance.tid);
            if ($cf.length == 0) {
              var arr = [],
                arr2 = [];
              arr.push('<div class="hthelper-popup hthelper-clearformat _hthelper-clearformat" id="clearformat-' + instance.tid + '">');
              var jsons = HChtHelper.Config.list.clearformat;

              for (var i = 0; i < jsons.length; i++) {
                var target = jsons[i].target;
                arr.push('<a href="javascript:;" data-target="' + target + '">' + jsons[i].title + '</a>');

                if (target == 'ZBG') {
                  var subclearformat = HChtHelper.Config.list.subclearformat;
                  arr2.push('<div style="width:90px;" class="hthelper-popup hthelper-subclearformat _hthelper-clearformat">');
                  for (var j = 0, jLen = subclearformat.length; j < jLen; j++) {
                    var starget = subclearformat[j];
                    if (starget == 'area') {
                      starget += 2;
                    }
                    arr2.push('<a href="javascript:;"data-target="' + target + '" data-type="' + starget + '">' + menus[starget] + '</a>');
                  }
                  arr2.push('</div>');
                }
              }
              arr.push('</div>');
              $(_this).parent().append(arr.join(''));
              $(_this).parent().find('a[data-target="ZBG"]').append(arr2.join(''));
            }
            priv.fixedShow(_this, document.getElementById('clearformat-' + instance.tid), 'bottom-left', 'hthelper-comain');
            break;
          case 'checkformat':
            var Tchb = new HChtHelper.TCHB(instance);
            Tchb.obj = _this;
            Tchb.priv = priv;
            Tchb.Tabs.toolbar = secondMenu.checkformat;
            Tchb.Tabs.len = secondMenu.checkformat.length;
            Tchb.createHtml = function () {
              var arr = [];
              arr.push('<div class="hthelper-subcont clearfix">');
              arr.push('<div class="hthelper-selector">');

              arr.push('<label class="hthelper-selector-lbl fr"><input type="text" class="ht-txt"/><a href="javascript:;" class="hthelper-btn hthelper-submit">搜索</a></label>');
              arr.push('<label class="hthelper-selector-lbl"><span class="htcheck hthelper-sr hthelper-srl">选中格式</span><span class="htcheck hthelper-sr hthelper-srr">所有格式</span></label>');
              arr.push('</div><div class="_hthelper-save-vdata hthelper-layer-checkformat">');
              arr.push('<table><colgroup>');
              arr.push('<col style="width: 52px;"/>');
              arr.push('<col style="width: 120px;"/>');
              arr.push('<col style="width: 120px;"/>');
              arr.push('<col style="width: 160px;"/>');
              arr.push('<col style="width: 160px;"/>');
              arr.push('<col style="width: 140px;"/>');
              arr.push('<col style="width: 40px;"/>');
              arr.push('</colgroup><thead><tr>');
              arr.push('<th class="alignc vam">坐标</th>');
              arr.push('<th class="alignc vam">单元格样式</th>');
              arr.push('<th class="alignc vam">设置格式</th>');
              arr.push('<th class="alignc vam">比较函数</th>');
              arr.push('<th class="alignc vam">自定义函数</th>');
              arr.push('<th class="alignc vam">公式</th>');
              arr.push('<th class="alignc vam">操作</th>');
              arr.push('</tr></thead><tbody>');
              var styleData = instance.GridSettings.styleData;
              var ruleData = instance.GridSettings.ruleData;
              var data = instance.GridSettings.data;

              for (var j = 0, slen = data[0].length; j < slen; j++) {
                for (var i = 0, len = data.length; i < len; i++) {
                  var styleRow = styleData[i],
                    ruleRow = ruleData[i],
                    styleCol = styleRow[j].style;

                  var ruleCol = ruleRow[j].rule;
                  if (styleCol || ruleCol) {
                    var strCoord = HChtHelper.Common.getExcelArrayToChar([i, j]);
                    var strStyle = HChtHelper.Common.getStyleName(styleCol);
                    var strFormat = HChtHelper.Common.getFormatName((ruleCol && ruleCol.setformat))
                    var strVdata = HChtHelper.Common.getVdataName((ruleCol && ruleCol.vdata));
                    var strFunc = HChtHelper.Common.getFuncName((ruleCol && ruleCol.func));
                    var strFormula = HChtHelper.Common.getFormulaName((ruleCol && ruleCol.formula));
                    if (strStyle || strFormat || strVdata || strFunc || strFormula) {
                      if (strFunc) {
                        strFunc += '<span class="handle hide pl6 pr6" data-target="func" data-toggle="hchthelper-col-checkformat" data-type="update" data-coord="' + strCoord + '">编辑</span><span class="handle" data-target="func" data-toggle="hchthelper-col-checkformat" data-type="del" data-coord="' + strCoord + '">删除</span>';
                      }
                      if (strFormula) {
                        strFormula += '<span class="handle pl6 pr6" data-target="formula" data-toggle="hchthelper-col-checkformat" data-type="selected" data-coord="' + strCoord + '">选中</span><span class="handle" data-target="formula" data-toggle="hchthelper-col-checkformat" data-type="del" data-coord="' + strCoord + '">删除</span>';
                      }
                      arr.push('<tr>');
                      arr.push('<td class="alignc vam">' + strCoord + '</td>');
                      arr.push('<td data-target="fmt-del">' + strStyle + '</td>');
                      arr.push('<td data-target="fmt-del">' + strFormat + '</td>');
                      arr.push('<td data-target="fmt-del">' + strVdata + '</td>');
                      arr.push('<td data-target="fmt-del">' + strFunc + '</td>');
                      arr.push('<td data-target="fmt-del">' + strFormula + '</td>');
                      arr.push('<td class="alignc vam"><span class="sed" data-coord="' + HChtHelper.Common.getExcelArrayToChar([i, j]) + '">删除</span></td></tr>');
                    }
                  }
                }
              }

              //行/列函数
              var colFormats = instance.GridSettings.colFormats;
              for (var i = 0, len = colFormats.length; i < len; i++) {
                var json = colFormats[i];
                arr.push('<tr>');
                arr.push('<td class="alignc vam">行/列</td>');
                arr.push('<td data-target="fmt-del"></td>');
                arr.push('<td data-target="fmt-del"></td>');
                arr.push('<td data-target="fmt-del"></td>');
                arr.push('<td data-target="fmt-del">' + HChtHelper.Common.getFuncName([json]) + '<span class="hchthelper-layer-colsformat handle" data-toggle="hchthelper-colFormats" data-index="' + i + '">编辑</span></td>');
                arr.push('<td data-target="fmt-del"></td>');
                arr.push('<td class="alignc vam"><span class="sed" data-type="colformat" data-coord="' + json.func + '">删除</span></td></tr>');
              }

              arr.push('</tbody></table>');
              arr.push('</div></div>');
              instanceToolbar.find('div[data-id="cont-' + target + '-' + Tchb.identity + '-' + instance.tid + '"]:eq(0)').html(arr.join(''));
            }
            Tchb.init();
            break;
          case 'searchall':
            var Tchb = new HChtHelper.TCHB(instance);
            Tchb.obj = _this;
            Tchb.priv = priv;
            Tchb.Tabs.toolbar = [target];
            Tchb.Tabs.len = 1;
            Tchb.createHtml = function () {
              var arr = [];
              arr.push('<div class="hthelper-subcont clearfix">');
              arr.push('<div class="hthelper-selector">');

              arr.push('<label class="hthelper-selector-lbl" style="display:block"><input type="text" class="ht-txt ht-txt-searchall" placeholder="请输入值" style="width:80%"/><a href="javascript:;" data-target="' + target + '" class="hthelper-btn hthelper-submit">搜索</a></label>');
              arr.push('</div><div class="_hthelper-save-vdata hthelper-layer-checkformat">');
              arr.push('<table><colgroup>');
              arr.push('<col style="width: 52px;"/>');
              arr.push('<col style="width: 200px;"/>');
              //arr.push('<col style="width: 240px;"/>');
              arr.push('<col style="width: 50px;"/>');
              arr.push('</colgroup><thead><tr>');
              arr.push('<th class="alignc vam">坐标</th>');
              arr.push('<th class="alignc vam">单元格值</th>');
              //arr.push('<th class="alignc vam">指标分组</th>');
              arr.push('<th class="alignc vam">操作</th>');
              arr.push('</tr></thead><tbody>');
              arr.push('</tbody></table>');
              arr.push('</div></div>');
              instanceToolbar.find('div[data-id="cont-' + target + '-' + Tchb.identity + '-' + instance.tid + '"]:eq(0)').html(arr.join(''));
            }
            Tchb.init();
            break;
          case 'allformat':
            var Tchb = new HChtHelper.TCHB(instance);
            Tchb.obj = _this;
            Tchb.priv = priv;
            Tchb.Tabs.toolbar = secondMenu.allformat;
            Tchb.Tabs.len = secondMenu.allformat.length;
            Tchb.init();
            break;

          case 'validitydata':
            var Tchb = new HChtHelper.TCHB(instance);
            Tchb.obj = _this;
            Tchb.priv = priv;
            Tchb.target = target;
            Tchb.Tabs.toolbar = secondMenu.validitydata;
            Tchb.Tabs.len = secondMenu.validitydata.length;
            Tchb.Tabs.save = function () {
              instance.map.vdata(_this);
            }
            Tchb.init();
            var dformat = instance.GridSettings.toolbar.thirdMenu.dformat;
            var validity = HChtHelper.Config.list.validity;
            for (var i = 0; i < secondMenu.validitydata.length; i++) {
              var arr = [];
              arr.push('<div class="hthelper-subcont clearfix">');
              // dformat
              if (secondMenu.validitydata[i] == 'dformat') {
                arr.push('<input type="hidden" id="' + instance.tid + '-txt-' + secondMenu.validitydata[i] + '"/>');
                arr.push('<div class="hthelper-selector">');
                arr.push('<label data-target="hthelper-selector" class="hthelper-selector-lbl">');
                arr.push('<input type="checkbox" class="htcheck dis-none" title="忽略空值"/></label>');
                arr.push('<label data-target="hthelper-selector" class="hthelper-selector-lbl">');
                arr.push('<input type="checkbox" class="htcheck dis-none" title="是否必须审核"/></label>');

                arr.push('<label data-target="hthelper-selector" class="hthelper-selector-lbl">');
                arr.push('<input type="checkbox" class="htcheck dis-none" title="审核"/><input type="checkbox" class="htcheck dis-none" title="验收"/></label>');

                arr.push('</div>');
                arr.push('<div class="hthelper-dformat-list _hthelper-dformat-list">');
                arr.push('<label class="dbk"><span class="ddz htsp-title">类型：</span><select class="htsel htsel-title">');
                for (var j = 0; j < dformat.length; j++) {
                  arr.push('<option value="' + dformat[j] + '">' + menus[dformat[j]] + '</option>');
                }
                arr.push('</select></label>');
                arr.push('<label class="dbk"><span class="ddz htsp-title">比较：</span><select class="htsel htsel-title" disabled>');
                for (var k = 0; k < validity.length; k++) {
                  arr.push('<option value="' + validity[k].target + '">' + validity[k].title + '</option>');
                }
                arr.push('</select></label><div id="dformat-list-' + Tchb.identity + '-' + instance.tid + '"></div></div>');
              } // func
              else if (secondMenu.validitydata[i] == 'func') {
                arr.push('<input type="hidden" id="' + instance.tid + '-txt-' + secondMenu.validitydata[i] + '"/>');
                arr.push('<div class="hthelper-selector">');
                arr.push('<label data-target="hthelper-selector" class="hthelper-selector-lbl">');
                arr.push('<input type="checkbox" class="htcheck dis-none" title="是否必须审核"/>');
                arr.push('</label>');
                arr.push('<label data-target="hthelper-selector" class="hthelper-selector-lbl">');
                arr.push('<input type="checkbox" class="htcheck dis-none" title="审核"/><input type="checkbox" class="htcheck dis-none" title="验收"/></label>');
                arr.push('</div>');
                //arr.push('<div class="pt6 pl12"><a href="javascript:;" class="hthelper-btn hthelper-prevdata hthelper-submit">往期数据</a></div>');
                arr.push('<div class="hthelper-dformat-list _hthelper-dformat-list _hthelper-func-list">');
                arr.push('<label class="dbk"><span class="ddz htsp-title">表达式：</span><input type="text" class="httxt httxt-title"/></label>');
                arr.push('<label class="dbk"><span class="ddz htsp-title">备注：</span><input type="text" class="httxt httxt-title"/></label>');
                //arr.push('<label class="dbk"><span class="ddz htsp-title">错误信息：</span><input type="text" class="httxt httxt-title"/></label>');
                arr.push('</div>');
              }
              arr.push('</div>');
              instanceToolbar.find('div[data-id="cont-' + target + '-' + Tchb.identity + '-' + instance.tid + '"]:eq(' + i + ')').html(arr.join(''));
            }
            break;
          case 'autofetching':
            var Tchb = new HChtHelper.TCHB(instance);
            Tchb.obj = _this;
            Tchb.priv = priv;
            Tchb.Tabs.toolbar = secondMenu.autofetching;
            Tchb.Tabs.len = secondMenu.autofetching.length;
            Tchb.Tabs.save = function () {}
            Tchb.init();
            for (var i = 0; i < secondMenu.autofetching.length; i++) {
              var arr = [];
              arr.push('<div class="hthelper-subcont clearfix">');
              arr.push('<div class="hthelper-dformat-list _hthelper-dformat-list ');
              if (secondMenu.autofetching[i] == 'autofzb') {
                arr.push('<input type="hidden" id="' + instance.tid + '-txt-' + secondMenu.autofetching[i] + '"/>');
                arr.push(' hthelper-autofzb-list _hthelper-autofzb-list">');
                arr.push('<label class="dbk"><span class="htsp-title">报表：</span><select class="htsel htsel-report"></select></label>');
                arr.push('<label class="dbk"><span class="htsp-title">指标：</span><select class="htsel htsel-report"></select></label>');
                arr.push('<label class="dbk"><span class="htsp-title">分组：</span><select class="htsel htsel-report"></select></label>');
                arr.push('<label class="dbk"><span class="htsp-title">期别：</span><select class="htsel htsel-report"></select></label>');
                arr.push('<label class="dbk"><span class="htsp-title">算法：</span><select class="htsel htsel-report"></select></label>');
              } else if (secondMenu.autofetching[i] == 'autoftq') {
                arr.push('<input type="hidden" id="' + instance.tid + '-txt-' + secondMenu.autofetching[i] + '"/>');
                arr.push(' hthelper-autoftq-list _hthelper-autoftq-list">');
                arr.push('<label class="dbk"><select class="htsel htsel-report"></select></labe>');

              } else if (secondMenu.autofetching[i] == 'autofother') {
                arr.push('<input type="hidden" id="' + instance.tid + '-txt-' + secondMenu.autofetching[i] + '"/>');
                arr.push(' hthelper-autofother-list _hthelper-autofother-list">');
                arr.push('<label class="dbk"><textarea class="httxt httxt-area"></textarea></labe>');
              }
              arr.push('</div></div>');
              instanceToolbar.find('div[data-id="cont-' + target + '-' + Tchb.identity + '-' + instance.tid + '"]:eq(' + i + ')').html(arr.join(''));
            }

            break;
          case 'otherfetching':
            var Tchb = new HChtHelper.TCHB(instance);
            Tchb.obj = _this;
            Tchb.priv = priv;
            Tchb.Tabs.toolbar = ['otherfetching'];
            Tchb.Tabs.len = 1;
            Tchb.Tabs.save = function () {
              instance.map.otherfetching(_this);
            };

            Tchb.init();
            var corners = instance.handsontable.getSelected();
            corners = instance.setCellSelectionSort(corners);
            var colRule = instance.GridSettings.ruleData[corners[0]][corners[1]];
            var value = '';
            if (colRule.otherfetching) {
              value = colRule.otherfetching.value;
            }
            var arr = [];
            arr.push('<div class="hthelper-dformat-list _hthelper-dformat-list">');
            arr.push('<div class="hthelper-subcont clearfix">');
            arr.push('<textarea class="ht-txt" style="width: 300px; height: 200px;" >' + value + '</textarea>');
            arr.push('</div></div>');
            instanceToolbar.find('div[data-id="cont-' + target + '-' + Tchb.identity + '-' + instance.tid + '"]:eq(0)').html(arr.join(''));
            break;
          case 'import':
            var Tchb = new HChtHelper.TCHB(instance);
            Tchb.obj = _this;
            Tchb.priv = priv;
            Tchb.Tabs.toolbar = secondMenu['import'];
            Tchb.Tabs.len = secondMenu['import'].length;
            Tchb.Tabs.save = function () {}
            Tchb.init();
            for (var i = 0; i < secondMenu['import'].length; i++) {
              var arr = [];
              arr.push('<div class="hthelper-subcont clearfix">');
              arr.push('<div class="hthelper-dformat-list _hthelper-dformat-list ');
              if (secondMenu['import'][i] == 'impcol') {
                arr.push(' hthelper-impcol-list _hthelper-impcol-list">');
                arr.push('<label class="dbk"><span class="htsp-title">编号：</span><input type="text" class="httxt httxt-num"/></labe>');
              }
              arr.push('</div></div>');
              instanceToolbar.find('div[data-id="cont-' + target + '-' + Tchb.identity + '-' + instance.tid + '"]:eq(' + i + ')').html(arr.join(''));
            }
            break;
          case 'nf':
            var $cf = $('#' + target + '-' + instance.tid);
            if ($cf.length == 0) {
              var arr = [];
              arr.push('<div class="hthelper-popup hthelper-clearformat _hthelper-clearformat _hthelper-nf" id="' + target + '-' + instance.tid + '">');
              var jsons = HChtHelper.Config.list[target];
              for (var i = 0; i < jsons.length; i++) {
                arr.push('<a href="javascript:;" data-target="' + jsons[i].target + '" data-value="' + jsons[i].value + '"><span class="ddz excel-icon e-icon-nf e-icon-' + jsons[i].target + '"></span>' + jsons[i].title + '</a>');
              }
              arr.push('</div>');
              $(_this).parent().append(arr.join(''));
            }
            priv.fixedShow(_this, document.getElementById(target + '-' + instance.tid), 'bottom-center', 'hthelper-comain');
            break;
          case 'stretch':
            var $cf = $('#' + target + '-' + instance.tid);
            if ($cf.length == 0) {
              var arr = [];
              var jsons = HChtHelper.Config.list.stretch;
              arr.push('<div class="hthelper-popup hthelper-clearformat _hthelper-clearformat" id="stretch-' + instance.tid + '">');
              for (var i = 0; i < jsons.length; i++) {
                var subTarget = jsons[i].target;
                //if(subTarget == 'stretch-all'){subTarget = 'all';}
                arr.push('<a href="javascript:;" data-target="' + subTarget + '">' + jsons[i].title + '</a>');
              }
              arr.push('</div>');
              $(_this).parent().append(arr.join(''));
            }
            priv.fixedShow(_this, document.getElementById(target + '-' + instance.tid), 'bottom-left', 'hthelper-comain');
            break;
          case 'importdata':
            /*
            var Tchb = new HChtHelper.TCHB(instance);
            Tchb.obj = _this;
            Tchb.priv = priv;
            Tchb.Tabs.toolbar = secondMenu.importdata;
            Tchb.Tabs.len = secondMenu.importdata.length;
            Tchb.Tabs.save = function(){};
            Tchb.afterInit = function(){
            	
            };
            Tchb.init();
            var arr = [];
            arr.push('<div class="hthelper-subcont"><div class="hthelper-importdata-list">');
            arr.push('<input type="file" class="hthelper-uploadfile" id="uploadify-'+instance.tid+'"/>');
            //arr.push('<a href="javascript:;" class="hthelper-uploadify-save" id="save-uploadify-'+instance.tid+'">开始上传</a>');
            arr.push('<table id="filequeue-'+instance.tid+'" class="uploadify-table"><thead><th>文件名称</th><th>大小</th><th>上传进度</th><th>状态</th><th>操作</th></thead></table>');
            //arr.push('<a href="javascript:;" id="save-uploadFile-'+instance.tid+'">保存文件</a>');
            arr.push('</div></div>');
            instanceToolbar.find('div[data-id="cont-'+target+'-'+Tchb.identity+'-'+instance.tid+'"]:eq(0)').html(arr.join(''));
            */
            break;

          case 'tableskin':
            var Tchb = new HChtHelper.TCHB(instance);
            Tchb.obj = _this;
            Tchb.priv = priv;
            Tchb.Tabs.toolbar = secondMenu.tableskin;
            Tchb.Tabs.len = secondMenu.tableskin.length;
            Tchb.Tabs.save = function () {
              instance.map.tableskin(_this);
              instance.handsontable.render();
            }
            Tchb.init();
            var arr = [];
            arr.push('<div class="hthelper-layer-tableskin _hthelper-layer-tableskin">');
            var tableskin2 = instance.GridSettings.toolbar.thirdMenu.tableskin2;
            for (var i = 0, n = tableskin2.length; i < n; i++) {
              arr.push('<a href="javascript:;" data-value="' + tableskin2[i] + '" class="item ' + tableskin2[i] + '" hidefocus></a>');
            }
            arr.push('</div>');
            instanceToolbar.find('div[data-id="cont-' + target + '-' + Tchb.identity + '-' + instance.tid + '"]:eq(0)').html(arr.join(''));
            break;

          case 'theight':
            var Tchb = new HChtHelper.TCHB(instance);
            Tchb.obj = _this;
            Tchb.priv = priv;
            Tchb.Tabs.toolbar = secondMenu.theight;
            Tchb.Tabs.len = secondMenu.theight.length;
            Tchb.Tabs.save = function () {
              instance.map.theight(_this);
            };
            Tchb.init();
            var arr = [];
            arr.push('<div class="hthelper-dformat-list _hthelper-dformat-list">');
            arr.push('<div class="hthelper-subcont clearfix">');
            arr.push('<label class="dbk"><span class="ddz htsp-title">行高：</span>')
            arr.push('<select class="ht-txt htsel">');
            var list = HChtHelper.Config.list.theight;
            for (var i = 0, n = list.length; i < n; i++) {
              arr.push('<option value="' + list[i] + '">' + list[i] + '</option>');
            }
            arr.push('</select>');
            arr.push('</label></div></div>');
            instanceToolbar.find('div[data-id="cont-' + target + '-' + Tchb.identity + '-' + instance.tid + '"]:eq(0)').html(arr.join(''));
            break;
            /*
            case 'save':
            	var Tchb = new HChtHelper.TCHB(instance);
            	Tchb.obj = _this;
            	Tchb.priv = priv;
            	Tchb.Tabs.toolbar = secondMenu.save;
            	Tchb.Tabs.len = secondMenu.save.length;
            	Tchb.init();
            	var arr = [];
            	arr.push('<div class="hthelper-save-list _hthelper-save-list">');
            	arr.push('<div class="hthelper-subcont clearfix">');

            	arr.push('</div>');
            	instanceToolbar.find('div[data-id="cont-'+target+'-'+Tchb.identity+'-'+instance.tid+'"]:eq(0)').html(arr.join(''));
            break;
            */
        }
      },
      /**
       * 创建颜色选项
       */
      createColor: function (_this) {
        var target = $(_this).data('target');
        var $color = $('#' + target + '-' + instance.tid);
        if ($color.length == 0) {
          var arr = [];
          arr.push('<div id="' + target + '-' + instance.tid + '" class="hthelper-boxcolor hthelper-popup"><div class="hthelper-color _hthelper-color">');
          arr.push('<h3>主题颜色</h3>');
          arr.push('<div class="list">');
          var colors = HChtHelper.Config.list.colors;
          var standardColor = HChtHelper.Config.list.standardColor;
          for (var i = 0, n = colors.length; i < n; i++) {
            arr.push('<a class="item" href="javascript:;" data-color="' + colors[i] + '" style="background-color:' + colors[i] + '"></a>');
          }
          arr.push('</div>');
          arr.push('<h3>标准色</h3>');
          arr.push('<div class="list">');
          for (var i = 0, n = standardColor.length; i < n; i++) {
            arr.push('<a class="item" href="javascript:;" data-color="' + standardColor[i] + '" style="background-color:' + standardColor[i] + '"></a>');
          }
          arr.push('</div>');
          arr.push('<a href="javascript:;" class="item nocolor" data-color="">暂无颜色</a>');
          arr.push('</div>');
          $(_this).parent().append(arr.join(''));
        }
        priv.fixedShow(_this, document.getElementById(target + '-' + instance.tid), 'bottom-left', 'hthelper-comain');
      }
    }

    /**
     * 工具栏事件对象
     * @param {Object} this html标签对象
     */
    this.alert = function (_this) {
      var target = $(_this).data('target');
      var cells = $(_this).data('cells');
      var secondMenu = instance.GridSettings.toolbar.secondMenu;
      var corners = instance.handsontable.getSelected();
      switch (target) {
        case 'download': //下载
          this.controller.download(_this);
          break;
        case 'print': //打印
          this.controller.getPrint(_this);
          break;
        case 'import48': //导入数据
          break;

        case 'family': //字体
          this.controller.setStyleOther(cells, _this.options[_this.selectedIndex].text, 7);
          break;
        case 'font': //字号
          this.controller.setStyleOther(cells, _this.options[_this.selectedIndex].text, 6);
          break;
        case 'weight': //加粗
          this.controller.setStyle(cells, 1, 1);
          break;
        case 'tilt': //倾斜
          this.controller.setStyle(cells, 1, 2);
          break;
        case 'underlined': //下划线
          this.controller.setStyle(cells, 1, 3);
          break;
        case 'bcolor':
        case 'color':
        case 'bordercolor':
          view.createColor(_this);
          this.controller.setColor(_this);
          break;
        case 'top': //顶端对齐
        case 'middle': //垂直居中对齐
        case 'bottom': //底端对齐
          var value = target.substring(0, 1);
          this.controller.setStyleOther(cells, value, 4);
          break;
        case 'left': //左对齐
        case 'center': //水平居中对齐
        case 'right': //右对齐
          var value = target.substring(0, 1);
          this.controller.setStyleOther(cells, value, 5);
          break;
        case 'strike':
          this.controller.setStyle(cells, 1, 11);
          break;
        case 'merge': //合并单元格
          /*
          Handsontable.PluginHooks.run(this.handsontable, 'beforeInit');
          var coords = instance.handsontable.getSelected();
          var cellRange = new WalkontableCellRange({'row':coords[0],'col':coords[1]}, {'row':coords[0],'col':coords[1]}, {'row':coords[2],'col':coords[3]});
          this.handsontable.mergeCells.mergeOrUnmergeSelection(cellRange);
          instance.GridSettings.mergeCells = this.handsontable.mergeCells.mergedCellInfoCollection;
          */
          var coords = instance.handsontable.getSelected();
          coords = instance.setCellSelectionSort(coords);
          var f = false;
          var mCells = $.extend([], instance.GridSettings.mergeCells);
          for (var i = 0, len = mCells.length; i < len; i++) {
            var flag = HChtHelper.Common.getMergeCellBetweenCoords(mCells[i], coords);
            if (flag) {
              f = true;
              instance.map.setHTMerge(flag);
            }
          }
          if (!f) { //选中单元格中无合并单元格
            instance.map.setHTMerge(coords); //合并
          }
          this.handsontable.render();
          break;
        case 'clearformat': //清除格式
          view.setSecondMenu(_this);
          this.controller.clearformat();
          break;
        case 'setformat': //设置格式
          view.setSecondMenu(_this);
          this.controller.setformat();
          break;
        case 'checkformat': //查看格式
          var pid = $(_this).parent().data('id');
          $('#checkformat-' + pid + '-' + instance.tid).remove();
          view.setSecondMenu(_this);
          this.controller.checkformat(_this);

          break;
        case 'validitydata': //数据有效性
          view.setSecondMenu(_this);
          var Selector = new HChtHelper.Selector(instance);
          Selector.init();
          this.controller.validitydata(_this);
          break;

        case 'bbottom':
        case 'btop':
        case 'bleft':
        case 'bright':
        case 'btopbottom':
        case 'bouter':
        case 'bhouter':
        case 'ball':
        case 'bdoublebottom':
        case 'btopdoublebottom':
        case 'bweightbottom':
        case 'btopweightbottom':
        case 'bhorizontal':
        case 'bvertical':
        case 'binside':
        case 'bnone':
          this.controller.setBorders(_this);
          instance.handsontable.render();
          break;

        case 'align': //水平对齐
        case 'vertical': //垂直对齐
        case 'zbgroup': //指标分组
        // case 'gongshi': //公式
        //     this.controller.gongshi()
        //     break
        case 'autofetching': //自动取数
        case 'allformat': //所有格式
        case 'import': //导入设置
        case 'border': //边框
        case 'row': //插入行列
        case 'col': //移除行列
        case 'stretch': //拉抻
        case 'searchall': //搜索
        case 'selector': //选择器
          view.setSecondMenu(_this);
          break;
        case 'nf': //数字格式
          view.setSecondMenu(_this);
          this.controller.setNf();
          break;
        case 'insertleftcol': //插入左边列
        case 'insertrightcol': //插入右边列
        case 'removecol': //移除列
        case 'insertprevrow': //插入上一行
        case 'insertnextrow': //插入一下行
        case 'insertlastrow': //插入一下行
        case 'removerow': //移除行
          this.controller.insertcol(_this);
          break;

        case 'checkbox':
        case 'calendar':
          this.controller.selector(_this);
          instance.handsontable.render();
          break;

        case 'stretch-all':
        case 'hybrid':
        case 'last':
        case 'none':
          this.controller.stretch(_this);
          break;
        case 'readonly': //设置只读
        case 'clearreadonly': //取消只读
          /*
					var contextMenu = instance.handsontable.contextMenu;
					var atLeastOneReadOnly = contextMenu.checkSelectionReadOnlyConsistency(instance.handsontable);
		            instance.handsontable.getSelectedRange().forAll(function (r, c) {
		            	var flag = atLeastOneReadOnly ? 0 : 1;
		            	instance.handsontable.getCellMeta(r, c).readOnly = flag;
		            	instance.map.setReadonly(flag, r, c);
		            });
					instance.handsontable.render();
					*/
          var coords = instance.handsontable.getSelected();
          coords = instance.setCellSelectionSort(coords);
          var styleData = instance.GridSettings.styleData;
          var flag = 1;
          if (styleData[coords[0]][coords[1]].style) {
            flag = styleData[coords[0]][coords[1]].style[0] ? 0 : 1
          };
          for (var i = coords[0], n = coords[2]; i <= n; i++) {
            for (var j = coords[1], y = coords[3]; j <= y; j++) {
              /*
              var flag = 1;
              try{
                if(styleData[i][j].style){
                	flag = styleData[i][j].style[0] ? 0 : 1;
                	instance.handsontable.getCellMeta(i, j).readOnly = flag;
                }
              }catch(e){}
              */
              instance.handsontable.getCellMeta(i, j).readOnly = flag;
              instance.map.setReadonly(flag, i, j);
            }
          }
          instance.handsontable.render();
          break;

        case 'bar': //柱形图
          break;
        case 'line': //折线图
          break;
        case 'pie': //饼图
          break;
        case 'bar2': //条形图
          break;
        case 'area': //面积图
          break;
        case 'scatter': //散点图
          break;
        case 'other': //其它图
          break;

        case 'importdata': //导入模版
          /*
          view.setSecondMenu(_this);
          this.controller.importdata(_this);
          var hid = 'handle-importdata-'+$(_this).parent().data('id')+'-'+instance.tid;
          $('#'+hid).find('input[data-type="Confirm"]').unbind().on('click', function(){
          	 instance.controller.saveImportdata(_this);
          });
          */
          break;
        case 'fixed':
          this.controller.getFixed();
          break;
        case 'tableskin': //表格皮肤
          view.setSecondMenu(_this);
          this.controller.tableskin(_this);
          break;
        case 'theight':
          view.setSecondMenu(_this);
          this.controller.theight(_this);
          break;
        case 'otherfetching':
          view.setSecondMenu(_this);
          //this.controller.otherfetching(_this);
          break;
        case 'save':
          this.controller.save(instance.GridSettings.saveTableView);
          break;
        case 'columnnum':
          instance.GridSettings.colHeaders = instance.GridSettings.colHeaders ? false : true;
          instance.GridSettings.rowHeaders = instance.GridSettings.rowHeaders ? false : true;
          instance.handsontable.updateSettings(instance.GridSettings);
          break;
        case 'tablelist':
          layer.open({
            type: 2,
            title: '模板列表',
            shadeClose: true,
            shade: 0.3,
            maxmin: true, //开启最大化最小化按钮
            area: ['80%', '80%'],
            content: 'templet-selectReport.action',
            btn: ['确定', '取消'],
            yes: function (index, layero) {}
          });
          break;
        case 'calculation':
          this.controller.calculation();
          this.controller.autofetching();
          this.handsontable.render();
          break;

        case 'rank':
          this.controller.rank();
          this.handsontable.render();
          break;

        case 'copy':
          document.select();
          document.execCommand('Copy');
          break;
        case 'paste':
          document.execCommand('Paste');
          break;
          // case 'randomtable':
          // 	instance.GridSettings.randomtable = instance.GridSettings.randomtable ? 0 : 1;
          // 	if(instance.GridSettings.randomtable){
          // 		instance.GridSettings.minSpareRows = 1;
          // 	}
          // 	else{
          // 		//非画模板
          // 		if(instance.GridSettings.toolbar.type != 'all'){
          // 			instance.GridSettings.minSpareRows = 0;
          // 		}
          // 	}
          // 	instance.handsontable.updateSettings(instance.GridSettings);

          // break;

      }
    }
    /**
     * settings填充数据
     */
    this.controller = {
      /**
       * 自定义单元格热点(指标)显示
       */
      setHcOtherZBG: function (row, col) {
        var jsons = instance.GridSettings.hcOtherZBG;
        var json = '';
        if (jsons && jsons.data) {
          var data = jsons.data;
          for (var i = 0, len = data.length; i < len; i++) {
            var item = data[i];
            if (item.row == row && item.col == col) {
              json = item;
              break;
            }
          }
        }
        return json;
      },
      /**
       * 设置指标 panelSelection插件
       * @param {String} identity  zbgroup-guid
       */
      psZbgroup: function (jsonList) {
        var corners = instance.handsontable.getSelected();
        corners = instance.setCellSelectionSort(corners);
        for (var i = 0, n = jsonList.length; i < n; i++) {
          var json = jsonList[i],
            type = json.type //类型
            ,
            data = json.val //值
            ,
            orientation = json.orientation //填充方式
            ,
            flag = json.title //填充标题
            ,
            multi = json.multi //允许多选
            ,
            superposition = json.superposition //叠加
            ,
            len = data.length;
          if (len > 0) {
            if (orientation == 'horizontal') { //横向
              outlook: for (var j = corners[0], x = 0, y = corners[2]; j <= y; j++, x++) { //选中行
                for (var k = corners[1], z = corners[3]; k <= z; k++) { //选中列
                  if (x >= len) {
                    break outlook;
                  }
                  var flag = instance.controller.isStyleProp(j, k, 0);
                  //只读并且类别不等于指标解释
                  if (flag && type != 'indExplain') {
                    continue;
                  }
                  if (type == 'timeoffset') {
                    type = 'datetime';
                  }
                  if (type == 'indicator') { //指标
                    instance.map.setColumnProp(j, k, 'zb', [
                      [data[x].id],
                      [data[x].name],
                      [data[x].unitid],
                      [data[x].unitname]
                    ]);
                  } else if (type == 'group') { //[[id],[name],[groupType]]
                    var arr = [
                      [],
                      [],
                      []
                    ];
                    if (multi && superposition) {
                      var group = instance.map.getColumnProp(j, k, 'group', 'ruleData');
                      if (group) {
                        arr = group;
                      }
                      var index = arr[2].indexOf(data[x].grouptypeid);
                      if (index > -1) {
                        arr[0].splice(index, 1, data[x].id);
                        arr[1].splice(index, 1, data[x].name);
                      } else {
                        if (arr[0].length > 2) {
                          break;
                        }
                        arr[0].push(data[x].id);
                        arr[1].push(data[x].name);
                        arr[2].push(data[x].grouptypeid);
                      }
                    } else if (multi) {
                      for (var s = 0, z = data.length; s < z; s++) {
                        arr[0].push(data[s].id);
                        arr[1].push(data[s].name);
                        arr[2].push(data[s].grouptypeid);
                      }
                    } else {
                      if (arr[0].length > 2) {
                        break;
                      }
                      arr[0].push(data[x].id);
                      arr[1].push(data[x].name);
                      arr[2].push(data[x].grouptypeid);
                    }
                    instance.map.setColumnProp(j, k, 'group', arr);
                  } else if (type == 'area') {
                    instance.map.setColumnProp(j, k, 'area', [
                      [data[x].id],
                      [data[x].name]
                    ]);
                  } else if (type == 'contrast') {
                    instance.map.setColumnProp(j, k, 'contrast', [
                      [data[x].id],
                      [data[x].name]
                    ]);
                  } else if (type == 'datetime') {
                    instance.map.setColumnProp(j, k, 'datetime', [
                      [data[x].id],
                      [data[x].name]
                    ]);
                  } else if (type == 'timecode') {
                    instance.map.setColumnProp(j, k, 'timecode', [
                      [data[x].id],
                      [data[x].name]
                    ]);
                  } else if (type == 'indExplain') {
                    instance.map.setColumnProp(j, k, 'indExplain', data[0].name);
                  }
                }
              }
            }
            else if (orientation == 'vertical') { //竖向
              outlook: for (var k = corners[1], x = 0, z = corners[3]; k <= z; k++, x++) { //选中列
                for (var j = corners[0], y = corners[2]; j <= y; j++) { //
                  if (x >= len) {
                    break outlook;
                  }
                  var flag = instance.controller.isStyleProp(j, k, 0);
                  //只读并且类别不等于指标解释
                  if (flag && type != 'indExplain') {
                    continue;
                  }
                  if (type == 'timeoffset') {
                    type = 'datetime';
                  }
                  if (type == 'indicator') { //指标 [[id],[name],[unitid],[unitname]]
                    instance.map.setColumnProp(j, k, 'zb', [
                      [data[x].id],
                      [data[x].name],
                      [data[x].unitid],
                      [data[x].unitname]
                    ]);
                  } else if (type == 'group') { //[[id],[name],[grouptypeid]]
                    var arr = [
                      [],
                      [],
                      []
                    ];
                    if (multi && superposition) {
                      var group = instance.map.getColumnProp(j, k, 'group', 'ruleData');
                      if (group) {
                        arr = group;
                      }
                      var index = arr[2].indexOf(data[x].grouptypeid);
                      if (index > -1) {
                        arr[0].splice(index, 1, data[x].id);
                        arr[1].splice(index, 1, data[x].name);
                      } else {
                        if (arr[0].length > 2) {
                          break;
                        }
                        arr[0].push(data[x].id);
                        arr[1].push(data[x].name);
                        arr[2].push(data[x].grouptypeid);
                      }
                    } else if (multi) {
                      for (var s = 0, z = data.length; s < z; s++) {
                        arr[0].push(data[s].id);
                        arr[1].push(data[s].name);
                        arr[2].push(data[s].grouptypeid);
                      }
                    } else {
                      if (arr[0].length > 2) {
                        break;
                      }
                      arr[0].push(data[x].id);
                      arr[1].push(data[x].name);
                      arr[2].push(data[x].grouptypeid);
                    }
                    instance.map.setColumnProp(j, k, 'group', arr);
                    //instance.map.setColumnProp(j, k, 'group', [[data[x].id],[data[x].name],[data[x].grouptypeid]]);
                  } else if (type == 'area') {
                    instance.map.setColumnProp(j, k, 'area', [
                      [data[x].id],
                      [data[x].name]
                    ]);
                  } else if (type == 'contrast') {
                    instance.map.setColumnProp(j, k, 'contrast', [
                      [data[x].id],
                      [data[x].name]
                    ]);
                  } else if (type == 'datetime') {
                    instance.map.setColumnProp(j, k, 'datetime', [
                      [data[x].id],
                      [data[x].name]
                    ]);
                  } else if (type == 'timecode') {
                    instance.map.setColumnProp(j, k, 'timecode', [
                      [data[x].id],
                      [data[x].name]
                    ]);
                  } else if (type == 'indExplain') {
                    instance.map.setColumnProp(j, k, 'indExplain', data[0].name);
                  }
                }
              }
            }
            else if (orientation == '') { //横向平铺
              outlook: for (var j = corners[0], x = 0, y = corners[2]; j <= y; j++) { //选中行
                for (var k = corners[1], z = corners[3]; k <= z; k++, x++) { //选中列
                  var flag = instance.controller.isStyleProp(j, k, 0);
                  //只读并且类别不等于指标解释
                  if (flag && type != 'indExplain') {
                    continue;
                  }
                  if (x >= len) {
                    x = 0; //x重新设置为0 继续平铺
                    //break outlook;
                  }
                  if (type == 'timeoffset') {
                    type = 'datetime';
                  }
                  if (type == 'indicator') {
                    instance.map.setColumnProp(j, k, 'zb', [
                      [data[x].id],
                      [data[x].name],
                      [data[x].unitid],
                      [data[x].unitname]
                    ]);
                  } else if (type == 'group') {
                    var arr = [
                      [],
                      [],
                      []
                    ];
                    if (multi && superposition) {
                      var group = instance.map.getColumnProp(j, k, 'group', 'ruleData');

                      if (group) {
                        arr = group;
                      }
                      var index = arr[2].indexOf(data[x].grouptypeid);
                      if (index > -1) {
                        arr[0].splice(index, 1, data[x].id);
                        arr[1].splice(index, 1, data[x].name);
                      } else {
                        if (arr[0].length > 2) {
                          break;
                        }
                        arr[0].push(data[x].id);
                        arr[1].push(data[x].name);
                        arr[2].push(data[x].grouptypeid);
                      }
                    } else if (multi) {
                      for (var s = 0, z = data.length; s < z; s++) {
                        arr[0].push(data[s].id);
                        arr[1].push(data[s].name);
                        arr[2].push(data[s].grouptypeid);
                      }
                    } else {
                      if (arr[0].length > 2) {
                        break;
                      }
                      arr[0].push(data[x].id);
                      arr[1].push(data[x].name);
                      arr[2].push(data[x].grouptypeid);
                    }
                    instance.map.setColumnProp(j, k, 'group', arr);
                  } else if (type == 'area') {
                    instance.map.setColumnProp(j, k, 'area', [
                      [data[x].id],
                      [data[x].name]
                    ]);
                  } else if (type == 'contrast') {
                    instance.map.setColumnProp(j, k, 'contrast', [
                      [data[x].id],
                      [data[x].name]
                    ]);
                  } else if (type == 'datetime') {
                    instance.map.setColumnProp(j, k, 'datetime', [
                      [data[x].id],
                      [data[x].name]
                    ]);
                  } else if (type == 'timecode') {
                    instance.map.setColumnProp(j, k, 'timecode', [
                      [data[x].id],
                      [data[x].name]
                    ]);
                  } else if (type == 'indExplain') {
                    instance.map.setColumnProp(j, k, 'indExplain', data[0].name);
                  }
                }
              }
            }
          }
        }
        //添加行
        if (corners[2] == instance.GridSettings.data.length - 1) {
          var hczbg = document.createElement('a');
          hczbg.setAttribute('data-target', 'insertlastrow');
          instance.controller.insertcol(hczbg);
        }
        //添加列
        if (corners[3] == instance.GridSettings.data[0].length - 1) {
          var hczbg = document.createElement('a');
          hczbg.setAttribute('data-target', 'insertrightcol');
          instance.controller.insertcol(hczbg, corners);
        }
        instance.handsontable.render();
      },
      /**
       * 设置gongshi panelSelection插件
       * @param {String} identity  zbgroup-guid
       */
      setGongshi: function (jsonList) {
        var corners = instance.handsontable.getSelected();
        corners = instance.setCellSelectionSort(corners);
        for (var j = corners[0], x = 0, y = corners[2]; j <= y; j++) { //选中行
          for (var k = corners[1], z = corners[3]; k <= z; k++, x++) { //选中列
            instance.map.setColumnProp(j, k, 'gongshi', jsonList);
          }
        }
        instance.handsontable.render();
      },
      /**
       * 设置指标
       * @param {Object} value     [[id],[name],[unitid]]
       * @param {String} target    类型
       * @param {String} identity  zbgroup-guid
       */
      zbgroup: function (value, target, identity) {
        var corners = instance.handsontable.getSelected();
        corners = instance.setCellSelectionSort(corners);
        var selJson = value;
        var types = ['zb', 'group', 'area2', 'contrast'];
        if (target == 'qb') { //期别
        } else if (types.indexOf(target) > -1) {
          /**
           * arr[0] 表示 横向(h)/竖向(v)填充 空为横向顺序填充
           * arr[1] 表示 false 不填充标题  true填充
           * arr[2] 表示 false 不允许多选  true允许
           */
          var arr = ['', 0, 0];
          var $span = $('#' + identity + '-' + instance.tid).find('div[data-target="' + target + '"]').find('div[class="hthelper-selector"]').find('span[class*="current"]');
          for (var i = 0, n = $span.length; i < n; i++) {
            if ($span.eq(i).text() == '横向') {
              arr[0] = 'h'
            } else if ($span.eq(i).text() == '竖向') {
              arr[0] = 'v'
            } else if ($span.eq(i).text() == '填充标题') {
              arr[1] = '1'
            } else if ($span.eq(i).text() == '允许多选') {
              arr[2] = '1'
            }
          }

          //横向
          if (arr[0] == 'h') {
            for (var i = corners[0], k = 0, n = corners[2]; i <= n; i++, k++) {
              if (k == selJson[0].length) {
                break;
              }
              for (var j = corners[1], y = corners[3]; j <= y; j++) {
                var arrJson = (target == 'zb') ? [
                  [selJson[0][k]],
                  [selJson[1][k]],
                  [selJson[2][k]],
                  [selJson[3][k]]
                ] : [
                  [selJson[0][k]],
                  [selJson[1][k]]
                ];
                instance.map.setColumnProp(i, j, target, arrJson);
              }
            }
          } //竖向
          else if (arr[0] == 'v') {
            for (var i = corners[1], k = 0, n = corners[3]; i <= n; i++, k++) {
              if (k == selJson[0].length) {
                break;
              }
              for (var j = corners[0], y = corners[2]; j <= y; j++) {
                var arrJson = (target == 'zb') ? [
                  [selJson[0][k]],
                  [selJson[1][k]],
                  [selJson[2][k]],
                  [selJson[3][k]]
                ] : [
                  [selJson[0][k]],
                  [selJson[1][k]]
                ];
                instance.map.setColumnProp(j, i, target, arrJson);
              }
            }
          } //横向顺序
          else if (arr[0] == '') {
            lookout: for (var i = corners[0], k = 0, n = corners[2]; i <= n; i++) {
              for (var j = corners[1], y = corners[3]; j <= y; j++, k++) {
                if (k == selJson[0].length) {
                  break lookout;
                }
                var arrJson = (target == 'zb') ? [
                  [selJson[0][k]],
                  [selJson[1][k]],
                  [selJson[2][k]],
                  [selJson[3][k]]
                ] : [
                  [selJson[0][k]],
                  [selJson[1][k]]
                ];
                instance.map.setColumnProp(i, j, target, arrJson);
              }
            }
          }
        }
        instance.handsontable.render();
      },
      /**
       * 设置公式
       * @param {Object} value     [[id],[name],[unitid]]
       * @param {String} target    类型
       * @param {String} identity  zbgroup-guid
       */
      // gongshi: function (value, target, identity) {
      //   var corners = instance.handsontable.getSelected();
      //   corners = instance.setCellSelectionSort(corners);
      //   instance.ps = new formulaGonshi();
      //   instance.ps.init({
      //     id: 'gongshi',
      //     isInitReset: false,
      //     isMultiBtn: true,
      //     isExcelBtn: true,
      //     getSelectedZbGroup: function () {
      //       var coords = instance.handsontable.getSelected();
      //       coords = instance.setCellSelectionSort(coords);
      //       var json = instance.map.getColumnZbGroup(coords[0], coords[1]);
      //       json.coords = coords;
      //       json.strCoord = HChtHelper.Common.getExcelArrayToChar(coords);
      //       return json;
      //     }
      //   });
      //   instance.ps.outSideCreateHtml({
      //     isMask: true,
      //     isTitle: true,
      //     eventOk: instance.controller.setGongshi
      //   });
      //   instance.handsontable.render();
      // },
      /**
       * 选择器
       */
      selector: function (_this) {
        var target = $(_this).data('target');
        var json = {};
        var $list = null,
          $sublist = null;
        if (target == 'selector') {
          var pid = $(_this).parent().data('id');
          $list = $('#' + target + '-' + pid + '-' + instance.tid);
          var $item = $list.find('div.hthelper-selector').find('span.current');
          var subtarget = $item.data('subtarget') || 'checkbox';
          target = subtarget;
          $sublist = $list.find('div[data-subtarget="' + target + '"]');
        }
        json.target = target;
        switch (target) {
          case 'checkbox': //多选框
            break;
          case 'radio': //单选框
            var group = $sublist.find('input').val();
            json.group = group;
            break;
          case 'dropdown': //下拉框
            $label = $sublist.find('label');
            var arr = [];
            for (var i = 0, len = $label.length; i < len; i++) {
              var $txt = $label.eq(i).find('input');
              var txt1 = $txt.eq(0).val();
              var txt2 = $txt.eq(1).val();
              if (txt1 != '' && txt2 != '') {
                arr.push({
                  'name': $txt.eq(0).val(),
                  'value': $txt.eq(1).val()
                });
              }
            }
            json.list = arr;
            break;
          case 'calendar':
            var subtarget = 'minusfulldate';
            if ($sublist) {
              subtarget = $sublist.find('select option:selected').val();
            }
            json.subtarget = subtarget;
            break;
          case 'select2': //select2
            break;
          case 'commoncode': //常用代码
            break;
          case 'dynamicdrop': //动态下拉
            json.type = '';
            break;
        }
        instance.map.setCommonRule(function () {
          instance.map.setColumnProp(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
          instance.map.setReadonly(1, arguments[0], arguments[1]); //只读
          instance.map.setStyleProp(arguments[0], arguments[1], 4, 'm'); //垂直
          instance.map.setStyleProp(arguments[0], arguments[1], 5, 'c'); //水平
        }, json, 'selector');

      },
      /**
       * 设置边框
       *
       */
      setBorders: function (_this) {
        var target = $(_this).data('target') || _this.target,
          cells = $(_this).data('cells') || _this.cells,
          corners = instance.handsontable.getSelected(),
          arrRow = [],
          arrCol = [],
          cssText = [],
          cssBorder = '1px solid #000';
        corners = instance.setCellSelectionSort(corners);
        switch (target) {
          case 'bbottom':
            //最后一行
            arrRow.push(corners[2]);
            for (var j = corners[1], jLen = corners[3]; j <= jLen; j++) {
              arrCol.push(j);
            }
            cssText.push('border-bottom: ' + cssBorder + ';');
            break;
          case 'btop':
            //第一行
            arrRow.push(corners[0]);
            for (var j = corners[1], jLen = corners[3]; j <= jLen; j++) {
              arrCol.push(j);
            }
            cssText.push('border-top: ' + cssBorder + ';');
            break;
          case 'bleft':
            //左边列 第一列
            for (var i = corners[0], len = corners[2]; i <= len; i++) {
              arrRow.push(i);
            }
            arrCol.push(corners[1]);
            cssText.push('border-left: ' + cssBorder + ';');
            break;
          case 'bright':
            //右边列 最后列
            for (var i = corners[0], len = corners[2]; i <= len; i++) {
              arrRow.push(i);
            }
            arrCol.push(corners[3]);
            cssText.push('border-right: ' + cssBorder + ';');
            break;
          case 'btopbottom':
            //上下行 所有列
            arrRow.push(corners[0], corners[2]);
            for (var j = corners[1], jLen = corners[3]; j <= jLen; j++) {
              arrCol.push(j);
            }
            cssText.push('border-top: ' + cssBorder + ';', 'border-bottom: ' + cssBorder + ';');
            break;
          case 'bouter':
            this.setBorders({
              'cells': 'many',
              'target': 'bleft'
            });
            this.setBorders({
              'cells': 'many',
              'target': 'bright'
            });
            this.setBorders({
              'cells': 'many',
              'target': 'btopbottom'
            });
            break;
          case 'bhouter':
            this.setBorders({
              'cells': 'many',
              'target': 'bleft'
            });
            this.setBorders({
              'cells': 'many',
              'target': 'bright'
            });
            this.setBorders({
              'cells': 'many',
              'target': 'bhorizontal'
            });
            break;
          case 'ball':
            //全部
            this.setBorders({
              'cells': 'many',
              'target': 'bhorizontal'
            });
            this.setBorders({
              'cells': 'many',
              'target': 'bvertical'
            });
            break;
          case 'bdoublebottom':
            //最后一行 双下边框
            arrRow.push(corners[2]);
            for (var j = corners[1], jLen = corners[3]; j <= jLen; j++) {
              arrCol.push(j);
            }
            cssText.push('border-bottom:3px double #000;');
            break;
          case 'btopdoublebottom':
            this.setBorders({
              'cells': 'many',
              'target': 'btop'
            });
            this.setBorders({
              'cells': 'many',
              'target': 'bdoublebottom'
            });
            break;
          case 'bweightbottom':
            //最后一行
            arrRow.push(corners[2]);
            for (var j = corners[1], jLen = corners[3]; j <= jLen; j++) {
              arrCol.push(j);
            }
            cssText.push('border-bottom: 2px solid #000;');
            break;
          case 'btopweightbottom':
            this.setBorders({
              'cells': 'many',
              'target': 'btop'
            });
            this.setBorders({
              'cells': 'many',
              'target': 'bweightbottom'
            });
            break;
          case 'bhorizontal':
            //水平
            for (var i = corners[0], len = corners[2]; i <= len; i++) {
              arrRow.push(i);
            }
            for (var j = corners[1], jLen = corners[3]; j <= jLen; j++) {
              arrCol.push(j);
            }
            cssText.push('border-top: ' + cssBorder + ';');
            this.setBorders({
              'cells': 'many',
              'target': 'bbottom'
            });
            break;
          case 'bvertical':
            //垂直
            for (var i = corners[0], len = corners[2]; i <= len; i++) {
              arrRow.push(i);
            }
            for (var j = corners[1], jLen = corners[3]; j <= jLen; j++) {
              arrCol.push(j);
            }
            cssText.push('border-left: ' + cssBorder + ';');
            this.setBorders({
              'cells': 'many',
              'target': 'bright'
            });
            break;
          case 'binside':
            //内边框
            break;
          case 'bnone':
            for (var i = corners[0], len = corners[2]; i <= len; i++) {
              for (var j = corners[1], jLen = corners[3]; j <= jLen; j++) {
                instance.map.setStyleProp(i, j, 10, '');
              }
            }
            break;
        }
        if (arrRow.length > 0) {
          for (var i = 0, len = arrRow.length; i < len; i++) {
            var ctext = cssText[i] || cssText[0];
            for (var j = 0, jLen = arrCol.length; j < jLen; j++) {
              instance.map.setStyleBorderProp(arrRow[i], arrCol[j], 10, ctext);
            }
          }
        }
      },
      /**
       * 判断单元格 style的状态
       * @param {Number} row   行索引
       * @param {Number} col   列索引
       * @param {Number} index 下标
       * @return {Boolean}
       */
      isStyleProp: function (row, col, index) {
        var styleData = instance.GridSettings.styleData;
        var styleCol = styleData[row][col];
        var flag = false;
        if (styleCol) {
          if (styleCol.style) {
            flag = (styleCol.style[index]) ? true : false;
          }
        }
        return flag;
      },
      /**
       * @param {Array} corners 选中坐标
       */
      selectMapData: function (corners) {
        corners = instance.setCellSelectionSort(corners);
        var ruleData = instance.GridSettings.ruleData,
          styleData = instance.GridSettings.styleData,
          data = instance.GridSettings.data,
          mapData = {
            'data': [],
            'ruleData': [],
            'styleData': []
          };
        for (var i = corners[0], len = corners[2]; i <= len; i++) {
          var ruleRow = [],
            styleRow = [],
            dataRow = [];
          for (var j = corners[1], jLen = corners[3]; j <= jLen; j++) {
            ruleRow.push(ruleData[i][j]);
            styleRow.push(styleData[i][j]);
            dataRow.push(data[i][j])
          }
          mapData.ruleData.push(ruleRow);
          mapData.styleData.push(styleRow);
          mapData.data.push(dataRow);
        }
        return mapData;
      },
      /**
       * 获取选中的styleData ruleData 进行填充
       * @param {JSON}  source  数据源
       * @param {Array} corners 坐标
       *
       */
      setSelectMapData: function (source, corners) {
        var mapdata = source;
        var corners = instance.handsontable.getSelected();
        corners = instance.setCellSelectionSort(corners);
        for (var i = corners[0], y = 0, len = corners[2]; i <= len; i++, y++) {
          var dataRow = mapdata.data[y];
          var styleRow = mapdata.styleData[y];
          var ruleRow = mapdata.ruleData[y];
          if (!dataRow) {
            break;
          }
          for (var j = corners[1], z = 0, jLen = corners[3]; j <= jLen; j++, z++) {
            if (!ruleRow[z]) {
              break;
            }
            var dataCol = dataRow[z];
            var styleCol = styleRow[z];
            var ruleCol = ruleRow[z];
            if (styleCol) {
              if (styleCol.style) {
                instance.map.setColumnProp(i, j, 'style', styleCol.style, 'styleData');
              }
            }
            if (ruleCol) {
              if (ruleCol.rule) {
                delete ruleCol.rule.formula;
                delete ruleCol.rule.func;
              }
              var currentCol = instance.GridSettings.ruleData[i][j];
              var newCol = $.extend({}, currentCol, ruleCol);
              instance.GridSettings.ruleData[i][j] = newCol;
            }
          }
        }
      },
      /**
       * 设置Style
       * @param {Object} _this html标签对象
       */
      setStyle: function (cells, value, index) {
        if (instance.getCells(cells)) {
          instance.map.setSelectStyleProp(value, 'style', index);
        }
        instance.handsontable.render();
      },
      setStyleOther: function (cells, value, index) {
        if (instance.getCells(cells)) {
          instance.map.setSelectStyleOtherProp(value, 'style', index);
        }
        instance.handsontable.render();
      },
      /**
       * 样式事件
       */
      setColor: function (_this) {
        var $bordercolor = $('#bordercolor-' + instance.tid);
        var $bcolor = $('#bcolor-' + instance.tid);
        var $color = $('#color-' + instance.tid);
        /* bordercolor */
        var $width = $('#' + instance.tid + '-border-width');
        $bordercolor.find('a.item').on('click', function () {
          var color = $(this).data('color');
          $width.find('input[type="hidden"]').data('color', color);
          $('#' + instance.tid + '-border-color').css('background-color', color);
          $('#' + instance.tid + '-border-table').find('td').css('border-color', color);
          $('#hidden-border-' + instance.tid).data('color', color);
          $bordercolor.hide();
        });
        var cells = $(_this).data('cells');
        //背景
        $bcolor.find('a.item').on('click', function () {
          var color = $(this).data('color');
          instance.controller.setStyleOther(cells, color, 9);
          $bcolor.hide();
        });
        //前景
        $color.find('a.item').on('click', function () {
          var color = $(this).data('color');
          instance.controller.setStyleOther(cells, color, 8);
          $color.hide();
        });
      },
      /**
       * 设置格式绑定事件
       */
      setformat: function (_this) {
        var sel = document.getElementById(instance.tid + '-number-sel');
        var list = document.getElementById(instance.tid + '-number-samplelist');
        var p = document.getElementById(instance.tid + '-number-sample');
        var txt_number = document.getElementById('hidden-number-' + instance.tid);
        var txt_border = document.getElementById('hidden-border-' + instance.tid);
        var target = '';
        var val = '';
        var type = '';
        if (window.navigator.userAgent.indexOf("Chrome") > -1) {
          $(sel).on('click', function (event) {
            $(sel).focus();
            var t = event.target;
            if (t.nodeName == 'OPTION') {
              $(sel).find('option').attr('selected', false);
              $(t).attr('selected', true);
              $(sel).change();
            }
          })
        }
        sel.onchange = function () {
          var value = this.options[this.selectedIndex].value;
          var $div = $(list).children('div[data-type="' + value + '"]')
          $div.show().siblings('div').hide();
          if (value == 'normal') { //常规
            p.innerHTML = 1;
          } else if (value == 'decimal') { //数值
            var number = $div.find('input[type="text"]').val();
            p.innerHTML = Number(1).toFixed(number);
            val = number;
          } else if (value == 'money') { //货币
            var number = $div.find('input[type="text"]').val();
            p.innerHTML = '￥' + Number(1).toFixed(number);
            val = number;
          } else if (value == 'date') { //日期
            p.innerHTML = $div.find('select').find('option:selected').text();
            type = $div.find('select').find('option:selected').val();
          } else if (value == 'abs') {
            p.innerHTML = 1;
            type = $div.find('select').find('option:selected').val();
          } else if (value == 'other2') { //其它
            p.innerHTML = 1;
            type = $div.find('select').find('option:selected').val();
          } else if (value == 'tihuan') { //替换
            p.innerHTML = 1;
            type = $div.find('select').find('option:selected').val();
          }
          target = value;
          txt_number.value = target + ',' + val + ',' + type;
        }

        //数值
        var $decimal = instanceToolbar.find('div.hthelper-n-sl-detail[data-type="decimal"]');
        $decimal.find('a').on('click', function () {
          $input = $(this).siblings('input');
          var value = $input.val();
          if ($(this).hasClass('subtract')) { //减
            if (value > 0) {
              value--;
            }
          } else if ($(this).hasClass('add')) { //加
            if (value >= 0 && value < 9) {
              value++;
            }
          }
          $input.val(value);
          val = value;
          p.innerHTML = Number(1).toFixed(value);
          txt_number.value = target + ',' + val + ',' + type;
        })
        //货币
        var $money = instanceToolbar.find('div.hthelper-n-sl-detail[data-type="money"]');
        $money.find('a').on('click', function () {
          $input = $(this).siblings('input');
          var value = $input.val();
          if ($(this).hasClass('subtract')) { //减
            if (value > 0) {
              value--;
            }
          } else if ($(this).hasClass('add')) { //加
            if (value >= 0 && value < 9) {
              value++;
            }
          }
          $input.val(value);
          val = value;
          p.innerHTML = '￥' + Number(1).toFixed(value);
          txt_number.value = target + ',' + val + ',' + type;
        })
        //日期
        var $date = instanceToolbar.find('div.hthelper-n-sl-detail[data-type="date"]');
        $date.find('select').on('change', function () {
          p.innerHTML = $(this).find('option:selected').text();
          type = $(this).find('option:selected').val();
          txt_number.value = target + ',' + val + ',' + type;
        })
        //其它
        var $other2 = instanceToolbar.find('div.hthelper-n-sl-detail[data-type="other2"]');
        $other2.find('input').on('keyup', function () {
          var $sel = $other2.find('select');
          p.innerHTML = $sel.val() == 1 ? $(this).val() + '1' : '1' + $(this).val();
          val = $(this).val();
          txt_number.value = target + ',' + val + ',' + $sel.val();
        });
        $other2.find('select').on('change', function () {
          var $input = $other2.find('input');
          p.innerHTML = $(this).val() == 1 ? $input.val() + '1' : '1' + $input.val();
          txt_number.value = target + ',' + $input.val() + ',' + $(this).val();
        })

        //替换
        var $tihuan = instanceToolbar.find('div.hthelper-n-sl-detail[data-type="tihuan"]');
        $tihuan.find('input').on('keyup', function () {
          var arrVal = [];
          $tihuan.find('input').each(function () {
            arrVal.push(this.value);
          })
          txt_number.value = target + ',' + arrVal.toString();
        });
      },
      /**
       * 查看格式
       */
      checkformat: function (_this) {
        var pid = $(_this).parent().data('id');
        var $selector = $('#checkformat-' + pid + '-' + instance.tid).find('div.hthelper-selector');
        $('#checkformat-' + pid + '-' + instance.tid).unbind().on('click', '.sed', function (event) {
          HChtHelper.Common.stopPropagation(event);
          let coord = $(this).data('coord');
          var type = $(this).data('type');
          $(this).closest('tr').remove();
          if (type == 'colformat') {
            instance.map.removeColFormats(coord);
            return;
          }
          var arr = HChtHelper.Common.getExcelCharToArray(coord);
          instance.map.removeStyleRule(arr[0], arr[1]);
          instance.handsontable.render();
          instance.handsontable.selectCell(arr[0], arr[1]);
        });
        var corners = instance.handsontable.getSelected();
        corners = instance.setCellSelectionSort(corners);
        //选中格式 所有格式
        $selector.find('span').unbind().on('click', function () {
          var index = $(this).index();
          $(this).addClass('current').siblings().removeClass('current');
          if (index == 1) {
            $('#checkformat-' + pid + '-' + instance.tid).find('table tr').show();
            $selector.find('label:eq(0)').show();
          } else {
            $selector.find('label:eq(0)').hide();
            var arr = [];
            for (var i = corners[0]; i <= corners[2]; i++) {
              for (var j = corners[1]; j <= corners[3]; j++) {
                arr.push(HChtHelper.Common.getExcelArrayToChar([i, j]));
              }
            }
            var $tr = $('#checkformat-' + pid + '-' + instance.tid).find('table tr:gt(0)');
            $tr.each(function () {
              var str = $(this).children('td:eq(0)').html();
              if (arr.indexOf(str) == -1) {
                $(this).hide();
              } else {
                $(this).addClass('current').show();
              }
            })
          }
        });
        //搜索
        $selector.find('a.hthelper-submit').unbind().on('click', function () {
          var str = $selector.find('input.ht-txt').val();
          if ($.trim(str) != '') {
            str = str.toUpperCase();
            var $tr = $('#checkformat-' + pid + '-' + instance.tid).find('table tr:gt(0)');
            $tr.each(function () {
              var text = $(this).text().toUpperCase();
              if (text.indexOf(str) > -1) {
                $(this).show();
              } else {
                $(this).hide();
              }
            })
          }
        })
        $selector.find('span').eq(0).click();
      },
      /**
       * 数据有效性
       *
       */
      validitydata: function (_this) {
        var txt_dformat = document.getElementById('hidden-dformat-' + instance.tid);
        var txt_func = document.getElementById('hidden-func-' + instance.tid);
        /**
         * 0 忽略空值
         * 1 必须审核
         * 2 类型
         * 3 比较
         * 4 值1
         * 5 值2
         */
        var arrFormat = [],
          arrFunc = [];
        var id = $(_this).parent().data('id');
        var $div = $('#validitydata-' + id + '-' + instance.tid);
        /**
        var $dEmpty = $div.find('span.current[type="checkbox"]').eq(0);
        var $dExamine = $div.find('span.current[type="checkbox"]').eq(1);
        arrFormat[0] = $dEmpty.length > 0 ? 1 : 0;
        arrFormat[1] = $dExamine.length > 0 ? 1 : 0;
        */

        //设置
        var $dformat = $div.find('div.hthelper-cont[data-target="dformat"]');
        var $sel = $dformat.find('select').eq(0);
        var $sel1 = $dformat.find('select').eq(1);
        var list = document.getElementById('dformat-list-' + id + '-' + instance.tid);
        arrFormat[2] = $sel.val();
        arrFormat[3] = $sel1.val();
        $sel.unbind().on('change', function () {
          var value = this.options[this.selectedIndex].value;
          if (['any', 'num', 'mobile', 'phone', 'email', 'post'].indexOf(value) > -1) {
            $sel1.attr('disabled', true);
            $sel1[0].selectedIndex = 0;
            list.innerHTML = '';
          } else {
            $sel1.attr('disabled', false);
          }
          arrFormat[2] = value;
          txt_dformat.value = arrFormat.join(',');
        });
        $sel1.unbind().on('change', function () {
          //
          var value = this.options[this.selectedIndex].value;
          switch (value) {
            case 'all':
              list.innerHTML = '';
              break;
            case 'between':
            case 'notbetween':
              list.innerHTML = '<label class="dbk"><span class="ddz htsp-title">最小值：</span><input class="ht-txt" type="text"/></label><label class="dbk"><span class="ddz htsp-title">最大值：</span><input class="ht-txt" type="text"/></label>';
              break;
            case 'equal':
            case 'notequal':
              list.innerHTML = '<label class="dbk"><span class="ddz htsp-title">数值：</span><input class="ht-txt" type="text"/></label></label>';
              break;
            case 'gt':
            case 'gtorequal':
              list.innerHTML = '<label class="dbk"><span class="ddz htsp-title">最小值：</span><input class="ht-txt" type="text"/></label></label>';
              break;
            case 'lt':
            case 'ltorequal':
              list.innerHTML = '<label class="dbk"><span class="ddz htsp-title">最大值：</span><input class="ht-txt" type="text"/></label></label>';
              break;
          }
          arrFormat[3] = value;
          txt_dformat.value = arrFormat.join(',');
          arrFormat[4] = arrFormat[5] = '';
          $(list).find('input').each(function (index) {
            $(this).unbind().on('blur', function () {
              arrFormat[index + 4] = this.value;
              txt_dformat.value = arrFormat.join(',');
            })
          });

        });

        $div.find('a.hthelper-prevdata').unbind().on('click', function () {
          layer.open({
            title: '自定义函数',
            type: 1,
            //skin: 'layui-layer-rim', //加上边框
            area: ['1000px', '535px'], //宽高
            content: view.getPrevDatas(),
            btn: ['确定', '取消'],
            success: function (lay) {
              $('#mytabs-' + instance.tid + ' a').unbind().on('click', function (e) {
                e = e || window.event;
                e.preventDefault();
                //弹出指标分组中 有绑定 data-toggle="tab" 用导致冲突 报错。
                $(this).parent().addClass('active').siblings().removeClass('active');
                var cid = $(this).attr('href');
                $(cid).addClass('active').siblings().removeClass('active');
              });
              $('#mytabs-' + instance.tid + ' a:first').click();
            },
            yes: function (index, layero) {

            }
          });
        });

        //公式函数
        var $func = $div.find('div.hthelper-cont[data-target="func"]');
        var $input = $dformat.find('div.hthelper-dformat-list').find('input');

      },
      /**
       * [插入删除行列]
       * @param  {Object} _this  [A标签对象]
       * @param {Number} column [行/列索]
       */
      insertcol: function (_this, column) {
        var target = $(_this).data('target');
        var corners = instance.handsontable.getSelected() || [0, 0, 0, 0];
        switch (target) {
          case 'insertprevrow':
            instance.handsontable.alter.call(instance.handsontable, 'insert_row', column || Math.min(corners[0], corners[2]));
            break;
          case 'insertnextrow':
            instance.handsontable.alter.call(instance.handsontable, 'insert_row', column || Math.max(corners[0], corners[2]) + 1);
            break;
          case 'insertlastrow':
            corners[0] = instance.GridSettings.data.length;
            instance.handsontable.alter.call(instance.handsontable, 'insert_row', column || Math.max(corners[0], corners[2]) + 1);
            break;
          case 'insertleftcol':
            instance.handsontable.alter.call(instance.handsontable, 'insert_col', column || Math.min(corners[1], corners[3]));
            break;
          case 'insertrightcol':
            instance.handsontable.alter.call(instance.handsontable, 'insert_col', column || Math.max(corners[1], corners[3]) + 1);
            break;
          case 'removerow':
            if (instance.GridSettings.data.length >= 2)
              instance.handsontable.alter.call(instance.handsontable, 'remove_row', column || Math.min(corners[0], corners[2]), column || Math.abs(corners[0] - corners[2]) + 1);
            break;
          case 'removecol':
            if (instance.GridSettings.data[0].length >= 2)
              instance.handsontable.alter.call(instance.handsontable, 'remove_col', column || Math.min(corners[1], corners[3]), column || Math.abs(corners[1] - corners[3]) + 1);
            break;
        }
      },
      /**
       * [数字格式]
       */
      setNf: function () {
        var $nf = $('#nf-' + instance.tid);
        $nf.find('a').on('click', function () {
          var value = $(this).data('value');
          instance.map.setFormat(value);
          instance.handsontable.render();
          $nf.hide();
        })
      },
      /**
       * 固定表头
       */
      getFixed: function () {
        var corners = instance.handsontable.getSelected();
        instance.GridSettings.fixedRowsTop = corners[0];
        instance.GridSettings.fixedColumnsLeft = corners[1];
        this.fixedTableskin([1, , , , 'm', 'c'], [1, , , , 'm']);
        instance.GridSettings.colWidths = instance.getColWidths();
        instance.handsontable.updateSettings(instance.GridSettings);
      },
      /**
       * 设置表格格式 固定表头
       * @param {Array} top
       * @param {Array} left
       * @param {Array} content
       */
      fixedTableskin: function (top, left, content) {
        if (instance.GridSettings.tableskin == 'fixednum' && (instance.GridSettings.fixedRowsTop > 0 || settings.fixedColumnsLeft > 0)) {
          //只读 水平居中 垂直居中
          if (instance.GridSettings.fixedColumnsLeft > 0) {
            for (var j = 0, jLen = instance.GridSettings.fixedColumnsLeft; j < jLen; j++) {
              for (var i = 0, len = instance.GridSettings.styleData.length; i < len; i++) {
                var rowStyle = instance.GridSettings.styleData[i];
                instance.map.setColumnProp(i, j, 'style', left.concat(), 'styleData');
              }
            }
          }
          //只读 水平居中 垂直居中 列居左 行居中 重合居中
          if (instance.GridSettings.fixedRowsTop > 0) {
            for (var i = 0, len = instance.GridSettings.fixedRowsTop; i < len; i++) {
              var rowStyle = instance.GridSettings.styleData[i];
              for (var j = 0, jLen = rowStyle.length; j < jLen; j++) {
                instance.map.setColumnProp(i, j, 'style', top.concat(), 'styleData');
                /*
                instance.map.setReadonly(1, i, j);     //只读
                instance.map.setStyleProp(i, j, 4, 'm'); //垂直
                instance.map.setStyleProp(i, j, 5, 'c'); //水平
                */
              }
            }
          }
        }
      },
      /**
       * [表格皮肤]
       */
      tableskin: function (_this) {
        var id = $(_this).parent().data('id');
        var $div = $('#tableskin-' + id + '-' + instance.tid);
        var $skin = $div.find('div[data-id="cont-tableskin-' + id + '-' + instance.tid + '"]');
        $skin.find('a.item').on('click', function () {
          var value = $(this).data('value');
          $(this).addClass('active').siblings().removeClass('active');
          var tableskin2 = instance.GridSettings.toolbar.thirdMenu.tableskin2;
          for (var i = 0, n = tableskin2.length; i < n; i++) {
            instance.rootElement.removeClass('handsontable-' + tableskin2[i]);
          }
          instance.rootElement.addClass('handsontable-' + value);
        })
      },
      /**
       * 设置表格行高
       * @param  {Object} _this
       */
      theight: function (_this) {
        var id = $(_this).parent().data('id');
        var $div = $('#theight-' + id + '-' + instance.tid);
        var $th = $div.find('div[data-id="cont-theight-' + id + '-' + instance.tid + '"]');
        $th.find('select').unbind().on('change', function () {
          var value = this.options[this.selectedIndex].value;
          $('#hidden-theight-' + id + '-' + instance.tid).val(value);
          var cname = instance.rootElement.attr('class');
          cname = cname.replace(/handsontable-theight\d+/g, '');
          instance.rootElement.attr('class', cname);
          instance.rootElement.addClass('handsontable-theight' + value);
        });
      },
      /**
       * 清除格式绑定事件
       */
      clearformat: function () {
        var $cf = $('#clearformat-' + instance.tid);
        $cf.find('a').unbind().on('click', function (event) {
          var target = $(this).data('target');
          var corners = instance.handsontable.getSelected();
          corners = instance.setCellSelectionSort(corners);
          var ruleData = instance.GridSettings.ruleData;
          var styleData = instance.GridSettings.styleData;
          var data = instance.GridSettings.data;
          for (var j = corners[1]; j <= corners[3]; j++) {
            for (var i = corners[0]; i <= corners[2]; i++) {
              if (target == 'ZBG') { //zb and group
                var type = $(this).data('type');
                switch (type) {
                  case 'zb':
                    delete ruleData[i][j].zb;
                    break;
                  case 'group':
                    delete ruleData[i][j].group;
                    break;
                  case 'area2':
                    delete ruleData[i][j].area;
                    break;
                  case 'contrast':
                    delete ruleData[i][j].contrast;
                    break;
                  case 'datetime':
                    delete ruleData[i][j].datetime;
                    break;
                  case 'timecode':
                    delete ruleData[i][j].timecode;
                    break;
                  case 'indExplain':
                    delete ruleData[i][j].indExplain;
                    break;
                  default:
                    delete ruleData[i][j].zb;
                    delete ruleData[i][j].group;
                    delete ruleData[i][j].area;
                    delete ruleData[i][j].contrast;
                    delete ruleData[i][j].datetime; //时间偏移量
                    delete ruleData[i][j].timecode; //期别
                    delete ruleData[i][j].indExplain; //指标解释
                    break;
                }
                HChtHelper.Common.stopPropagation(event);
              } else if (target == 'S') { //style
                delete styleData[i][j].style;
              } else if (target == 'V') { //value
                data[i][j] = '';
              } else if (target == 'AUTOMATIC') { //自动取数
                delete ruleData[i][j].automatic
              } else if (target == 'RULE') { //规则
                delete ruleData[i][j].rule;
              } else if (target == 'unOTHERFETCHING') { //自定义取数
                delete ruleData[i][j].otherfetching;
              } else if (target == 'ALL') {
                // delete ruleData[i][j].zb;
                // delete ruleData[i][j].group;
                // delete ruleData[i][j].area;
                // delete ruleData[i][j].contrast; //对比项
                // delete ruleData[i][j].datetime;
                // delete ruleData[i][j].timecode; //期别
                // delete ruleData[i][j].indExplain; //指标解释

                // delete styleData[i][j].style;
                // data[i][j] = '';
                // delete ruleData[i][j].automatic
                // delete ruleData[i][j].otherfetching
                // delete ruleData[i][j].rule;

                ruleData[i][j] = {};
                styleData[i][j] = {};
                data[i][j] = '';

                instance.GridSettings.colFormats = []; //删除行/列函数
              }
            }
          }
          instance.handsontable.render();
          $cf.hide();
        }).on('mouseenter', function () {
          $(this).find('div').show().end().siblings('a').find('div').hide();
        });
      },
      /**
       * 下载
       *
       */
      download: function (_this) {
        var arr = [],
          arrTable = [];
        arr.push('<html xmlns="http://www.w3.org/TR/REC-html40" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns:v="urn:schemas-microsoft-com:vml">');
        arr.push('<head><meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>');
        arr.push('<style>');
        arr.push('.handsontable-none .htCore td, .handsontable-none .htCore th{border-width:0;}.handsontable-hz td, .handsontable-hz th{height:72px; line-height:72px; font-size:20px;}.handsontable-hz .htCore td{border-width:0 0 1px 0; border-bottom-color:#e4e5e6; background:#f9fdfe;}.handsontable-hz .wtSpreader .htCore{border:1px solid #e4e5e6}.handsontable-theight20 td{height:20px; line-height:20px;}.handsontable-theight24 td{height:24px; line-height:24px;}.handsontable-theight28 td{height:28px; line-height:28px;}.handsontable-theight32 td{height:32px; line-height:32px;}.handsontable-theight36 td{height:36px; line-height:36px;}.handsontable-theight40 td{height:40px; line-height:40px;}.handsontable-theight44 td{height:44px; line-height:44px;}.handsontable-theight48 td{height:48px; line-height:48px;}.handsontable-theight72 td{height:72px; line-height:72px;}.handsontable-theight102 td{height:102px; line-height:102px;}');
        arr.push('.handsontable td { border: 1px solid #cccccc; height: 22px; empty-cells: show; line-height: 21px; padding: 0 4px 0 4px; background-color: #FFF; vertical-align: top; overflow: hidden; outline-width: 0; white-space: pre-line; }');
        arr.push('.handsontable table.htCore{border-collapse:collapse; border-spacing:0; table-layout:fixed;}');
        arr.push('.handsontable td{height:28px; line-height:28px; border-color:#ccc; padding:0px;}');
        arr.push('.handsontable td{white-space:pre-line; word-wrap:break-word; empty-cells:show; position:relative; background:none;}');
        arr.push('</style></head><body>');
        priv.recombinationTable();
        var $hidespecial = $('#hidespecial-' + instance.tid);
        arr.push($hidespecial.html());
        arr.push('</body></html>');
        if ($('#form-download-' + instance.tid).length == 0) {
          var action = instance.GridSettings.excelDownload || 'common-exportHtmlToExcel.action';
          var _form = '<form id="form-download-' + instance.tid + '" method="post" target="_blank" action="' + action + '">' +
            '<input type="hidden" name="html-download-' + instance.tid + '">' +
            '<input type="hidden" name="filename-' + instance.tid + '">' +
            '<input type="hidden" name="templetsTimeid-' + instance.tid + '">' +
            '</form>';
          $('body').append(_form);
        }
        $('#form-download-' + instance.tid).find('input[name="html-download-' + instance.tid + '"]').val(arr.join(''));
        $('#form-download-' + instance.tid).find('input[name="filename-' + instance.tid + '"]').val($('#templetname').val());
        $('#form-download-' + instance.tid).find('input[name="templetsTimeid-' + instance.tid + '"]').val($('#templetsTimeid').val());

        $('#form-download-' + instance.tid).submit();
        $hidespecial.html('');
      },
      /**
       * 打印
       *
       */
      getPrint: function () {
        var $hidespecial = $('#hidespecial-' + instance.tid);
        priv.recombinationTable();
        $hidespecial.show().children('div').addClass(instance.rootElement.attr('class'));
        $hidespecial.jqprint();
        $hidespecial.hide().html('');
      },
      /**
       * 导入模版
       */
      importdata: function (_this) {
        try {
          //绑定上传按钮事件
          $('#uploadify-' + instance.tid).uploadify({ //初始化函数
            'swf': app_root + '/Matrix-UI/plugin/uploadify/uploadify.swf', //flash文件位置，注意路径
            // 'uploader'        : app_root+'/common-doUpload.action;jsessionid='+sessionid,//后台处理的请求
            'fileObjName': 'fileExcel',
            'formData': {
              'templetsTimeEdit.id': 111
            }, //向后台传的数据
            'cancelImg': app_root + '/Matrix-UI/plugin/uploadify/cancel.png', //取消按钮图片
            //'folder'        : 'uploadfile',
            'queueID': 'filequeue-' + instance.tid, //与下面的上传文件列表id对应
            'queueSizeLimit': 1, //上传文件的数量
            'fileTypeDesc': '请上传EXCEL表格文件', //上传文件类型说明
            'fileTypeExts': '*.xls;*.xlsx', //控制可上传文件的扩展名，启用本项时需同时声明fileDesc

            'fileDesc': 'EXCEL表格文件',
            'method': 'get', //如果向后台传输数据，必须是get
            'fileSizeLimit': 209715200, //文件上传的大小限制，单位是字节 200M
            'simUploadLimit': 1, //同时上传文件的数量，设置了这个参数后，那么你会因设置multi:true和queueSizeLimit：8而可以多选8个文件，但如果一旦你将simUploadLimit也设置了，那么只会上传这个参数指定的文件个数，其它就上传不了
            //'buttonText'      : 'Browse',//浏览按钮
            'multi': false,
            'buttonImage': app_root + '/Matrix-UI/plugin/uploadify/browse.jpg', //浏览按钮图片
            'height': 23, // The height of the flash button
            'width': 82,
            'removeCompleted': false,
            'onUploadSuccess': function (file, data, response) { //当上传完成后的回调函数，ajax方式;
              if (response) {
                var json = JSON.parse(data);
                if (json.data) {
                  var data = HChtHelper.Common.loadTableData(json.totalRows, json.totalCols);
                  var jsonList = json.data;
                  for (var i = 0, n = jsonList.length; i < n; i++) {
                    var arr = jsonList[i];
                    data[arr.end_posi][arr.start_posi] = arr.value;
                  }
                  var settings2 = {
                    'data': data,
                    'mergeCells': json.mergeCells,
                    'colWidths': (json.colWidths || '')
                  };
                  settings2 = $.extend(instance.GridSettings, settings2);
                  instance.handsontable.updateSettings(settings2, true);
                }
                var target = $(_this).data('target');
                var identity = $(_this).parent().data('id');
                $('#' + target + '-' + identity + '-' + instance.tid).hide();
              }
            },
            'onCancel': function (event, queueId, fileObj, data) {

            },
            'onQueueComplete': function (a, b) {

            },
            onSelect: function (event, ID, fileObj) {

            },
            'onUploadError': function (e) {
              alert(e)
            },
            'onUploadStart': function (a, b) {}
          });
        } catch (e) {
          alert(e)
        }
      },
      /**
       * 导入模版
       */
      saveImportdata: function () {
        var $filequeue = $('#filequeue-' + instance.tid);
        if ($filequeue.find('tr').length > 1) {
          $('#uploadify-' + instance.tid).uploadify('upload');
        } else {
          alert('请选择上传文件!');
        }
      },
      /**
       * 验证数据有效性(设置/函数) 保存数据 审核公式
       * 验证结果保存为JSON数据，对JSON进行判断 JSON无数据则直接保存
       * JSON有数据,加载数据 再判断是否必须审核(错误信息) 是 则隐藏确定按钮，否 显示及允许保存
       * @param {Function} 	saveTableView   外部调用的保存方法
       * @param {Number} 		type 			1审核 2验收
       * @param {String} 		html			弹出自定义内容 (必须加上table标签)
       * @param {Boolean} 	submitShow		是否隐藏确认按钮
       */
      save: function (saveTableView, type, html, submitShow) {
        type = type || 1;
        if (1 == 2 && instance.GridSettings.toolbar && instance.GridSettings.toolbar.type == 'all') {
          if (saveTableView instanceof Function) {
            saveTableView();
            return;
          }
        } else {
          this.getRuleValidate(type, html, submitShow);
          var $div = $('#saves-' + instance.tid).find('div[data-id="cont-saves-' + instance.tid + '"]');
          if ($div.find('table').length > 0) {
            $('#saves-' + instance.tid).show();
          } else {
            if (saveTableView instanceof Function) {
              $('#saves-' + instance.tid).hide();
              saveTableView();
              return;
            }
          }
        }
      },
      //查看错误信息
      getValidate: function (type, html, submitShow) {
        this.getRuleValidate(type, html, submitShow);
        var $div = $('#saves-' + instance.tid).find('div[data-id="cont-saves-' + instance.tid + '"]');
        if ($div.find('table').length > 0) {
          $('#saves-' + instance.tid).show();
        } else {
          $('#saves-' + instance.tid).show().find('div[data-id="cont-saves-' + instance.tid + '"]').html('<div class="p8">验证已通过，点击按钮继续操作</div>');
        }
      },
      /**
       * 填数据
       *
       */
      getRuleValidate: function (type, html, submitShow) {
        var jsons = this.setValidate(); //全部数据
        var $div = $('#saves-' + instance.tid).find('div[data-target="save2"]');
        $div.html('');
        var arr = [];
        var isSubmit = 0; //错误信息 是否隐藏确认按钮
        var iIndex = 0;
        if (html) {
          isSubmit = submitShow || 0;
          $('#handle-saves-' + instance.tid).find('input[data-type="Confirm"]')[isSubmit > 0 ? 'hide' : 'show']();
          $div.html(html);
          return;
        }
        if (jsons.vdataflag) {
          /* 数据有效性-设置 */
          arr.push('<div class="hthelper-save-vdata _hthelper-save-vdata">');
          arr.push('<table><colgroup>');
          arr.push('<col style="width: 40px;"/>');
          arr.push('<col  style="min-width:120px"/>');
          arr.push('<col style="width: 60px;"/>');
          arr.push('<col style="width: 60px;"/>');
          arr.push('<col style="width: 40px;"/>');
          arr.push('</colgroup><thead><tr><th colspan="6">数据有效性-比较函数</th></tr><tr>');
          arr.push('<th class="alignc vam">序号</th>');
          arr.push('<th class="alignc vam">错误信息</th>');
          arr.push('<th class="alignc vam">忽略空值</th>');
          arr.push('<th class="alignc vam">必须审核</th>');
          arr.push('<th class="alignc vam">操作</th>');
          arr.push('</tr></thead><tbody>');
          for (var i = 0, len = jsons.vdata.length; i < len; i++) {
            var json = jsons.vdata[i];
            var color = '',
              msg = '',
              empty = json.gs[0],
              examine = json.gs[1],
              stype = json.type;
            var flag = HChtHelper.Validate.getTypeScreening(stype, type);
            if (!flag) {
              continue;
            }
            if (json.flag == 2) {
              color = 'red';
              msg = json.err;
            } else {
              color = 'yellow';
              msg = json.msg;
            }
            arr.push('<tr>');
            arr.push('<td class="alignc vam">' + (i + 1) + '</td>');
            arr.push('<td class="vam">' + msg + '</td>');
            arr.push('<td class="alignc vam">');
            if (empty == 1) {
              arr.push('<span class="red bold">是</span>');
            } else {
              arr.push('<span class="green bold">否</span>');
            }
            arr.push('</td>');
            arr.push('<td class="alignc vam">');
            if (examine == 1) {
              arr.push('<span class="red bold">是</span>');
              ++isSubmit;
            } else {
              arr.push('<span class="green bold">否</span>');
            }
            arr.push('</td>');
            arr.push('<td class="alignc vam"><span class="sed" data-coord="' + json.coord + '">' + HChtHelper.Common.getExcelArrayToChar(json.coord) + '</span></td>');
            arr.push('</tr>');
            iIndex++;
          }
          arr.push('</tbody></table></div>');
          if (iIndex == 0) {
            arr = [];
          }
          $div.append(arr.join(''));
          arr = [];
        }
        if (jsons.funcflag) {
          arr.push('<div class="hthelper-save-vdata _hthelper-save-vdata hthelper-save-func _hthelper-save-func">');
          arr.push('<table><colgroup>');
          arr.push('<col style="width: 40px;"/>');
          arr.push('<col style="min-width:120px"/>');
          arr.push('<col style="width:130px"/>');
          arr.push('<col style="width: 60px;"/>');
          arr.push('<col style="width: 40px;"/>');
          arr.push('</colgroup><thead><tr><th colspan="6">数据有效性-自定义函数</th></tr><tr>');
          arr.push('<th class="alignc vam">序号</th>');
          arr.push('<th class="alignc vam">错误信息</th>');
          arr.push('<th class="alignc vam">备注</th>');
          arr.push('<th class="alignc vam">必须审核</th>');
          arr.push('<th class="alignc vam">操作</th>');
          arr.push('</tr></thead><tbody>');

          for (var i = 0, len = jsons.func.length; i < len; i++) {
            var json = jsons.func[i];
            arr.push('<tr>');
            var msg = examine == 2 ? json.err : json.msg,
              examine = json.flag,
              note = json.note,
              stype = json.type;
            var flag = HChtHelper.Validate.getTypeScreening(stype, type);
            if (!flag) {
              continue;
            }
            arr.push('<td class="alignc vam">' + (i + 1) + '</td>');
            arr.push('<td>' + msg + '</td>');
            arr.push('<td>' + note + '</td>');
            arr.push('<td class="alignc vam">');
            if (examine == 2) {
              arr.push('<span class="red bold">是</span>');
              ++isSubmit;
            } else {
              arr.push('<span class="green bold">否</span>');
            }
            arr.push('</td>');
            arr.push('<td class="alignc vam"><span class="sed" data-coord="' + json.coord + '">' + HChtHelper.Common.getExcelArrayToChar(json.coord) + '</span></td>');
            arr.push('</tr>');
            iIndex++;
          }
          arr.push('</tbody></table></div>');
          if (iIndex == 0) {
            arr = [];
          }
          $div.append(arr.join(''));
          arr = [];
        }
        /* 数据有效性-函数 */
        $('#handle-saves-' + instance.tid).find('input[data-type="Confirm"]')[isSubmit > 0 ? 'hide' : 'show']();
      },
      /**
       * 验证数据有效性
       */
      setValidate: function () {
        var ruleData = instance.GridSettings.ruleData;
        var styleData = instance.GridSettings.styleData;
        var data = instance.GridSettings.data;
        var jsons = {
            'vdataflag': false,
            'funcflag': false
          },
          vdataList = [],
          funcList = [];
        if (ruleData.length > 0) {
          /* ruledata styledata的行列长度不等于data的时候 让它们相等 */
          var dlen = data[0].length;
          if (ruleData.length > data.length) {
            ruleData.length = data.length;
            for (var i = 0, len = ruleData.length; i < len; i++) {
              ruleData[i].length = dlen;
            }
          }
          if (styleData.length > data.length) {
            styleData.length = data.length;
            for (var i = 0, len = styleData.length; i < len; i++) {
              styleData[i].length = dlen;
            }
          }
          /* end */
          for (var i = 0, len = ruleData.length; i < len; i++) {
            var json = ruleData[i];
            for (var j = 0, jLen = json.length; j < jLen; j++) {
              var value = data[i][j];
              var colRule = json[j];
              var rules = colRule.rule;
              if (rules) {
                //数据有效性 设置
                var vdata = rules.vdata;
                if (vdata) {
                  var arr = vdata.vdata.split(','),
                    empty = arr[0] //是否为空
                    ,
                    examine = arr[1] //是否必须为空
                    ,
                    target = arr[2] //类型
                    ,
                    judge = arr[3] //比较
                    ,
                    str1 = arr[4] //值1
                    ,
                    str2 = arr[5] //值2
                    ,
                    type = vdata.type //审核/验证
                    ,
                    rule = HChtHelper.Validate.getCommon(value, arr, i, j, type);

                  if (rule.flag != 1) {
                    vdataList.push(rule);
                  }
                }
                //函数
                var func = rules.func;
                if (func) {
                  var flen = func.length;
                  for (var k = 0; k < flen; k++) {
                    var str = func[k].func.toUpperCase();
                    var func2 = $.extend({}, func[k]);
                    if (str.indexOf(':') > -1) { //循环比较上X期
                      var reg = /\w+:\w+/,
                        r2 = /[A-Za-z]/g,
                        r3 = /[0-9]+/g,
                        r4 = /\w+/g,
                        r5 = /#\d+/,
                        r6 = /\[\S+\]/,
                        r7 = /[A-Za-z]+\d+/g,
                        arr = str.match(reg),
                        strArr = arr[0].match(r4),
                        col_0 = strArr[0].match(r2)[0],
                        col_1 = strArr[1].match(r2)[0],
                        row_0 = strArr[0].match(r3)[0],
                        row_1 = strArr[1].match(r3)[0],
                        prev = (str.match(r5) && str.match(r5)[0]) || 0,
                        column, l, lLen, brackets;

                      if (col_0 != col_1) {
                        l = HChtHelper.Common.getExcelCharToNum(col_0) * 1;
                        lLen = HChtHelper.Common.getExcelCharToNum(col_1) * 1;
                        column = 'col';
                      } else if (row_0 != row_1) {
                        l = row_0 * 1;
                        lLen = row_1 * 1;
                        column = 'row';
                      }
                      for (; l <= lLen; l++) {
                        let coord = '',
                          str2;
                        if (column == 'col') {
                          coord = HChtHelper.Common.getExcelNumToChar(l) + row_0;
                        } else if (column == 'row') {
                          coord = col_0 + l;
                        }
                        str2 = str.replace(arr[0], coord);
                        brackets = str2.match(r6)[0];
                        var braArr = brackets.match(r7);
                        for (var b = 0, bLen = braArr.length; b < bLen; b++) {
                          brackets = brackets.replace(braArr[b], prev + braArr[b]);
                        }
                        str2 = str2.replace(prev, brackets).replace(/\[/g, '').replace(/\]/g, '');

                        func2.func = str2;
                        var rule = HChtHelper.Validate.getFunc(func2, instance.GridSettings, type);
                        if (rule.flag != 1) {
                          funcList.push(rule);
                        }
                      }
                    } else {
                      var rule = HChtHelper.Validate.getFunc(func[k], instance.GridSettings, type);
                      if (rule.flag != 1) {
                        funcList.push(rule);
                      }
                    }
                  }
                }
              }
            }
          }
        }
        //行/列函数
        var colFormats = instance.GridSettings.colFormats;
        for (var i = 0, len = colFormats.length; i < len; i++) {
          var json = colFormats[i];
          var func = json.func;
          var regcol = /\[[A-Za-z]+\]/g;
          var regrow = /\[[0-9]+\]/g;
          var regstr = /\w+/g;
          var colfm = func.match(regcol);
          var rowfm = func.match(regrow);
          var colLen = instance.GridSettings.data[0].length;
          var rowLen = instance.GridSettings.data.length;

          //非验证 start
          var novalidity = json.novalidity || '';
          if (novalidity.indexOf(',') > 0) {
            novalidity = novalidity.split(',');
          } else {
            novalidity = [novalidity];
          }
          //end

          if (colfm && colfm.length > 0) { //列操作
            for (var ii = 0; ii < rowLen; ii++) {
              if (instance.GridSettings.fixedRowsTop > ii) {
                continue;
              }
              if (novalidity.length > 0) {
                if (novalidity.indexOf(String(ii + 1)) > -1) { //判断是否不验证
                  continue;
                }
              }
              var njson = $.extend({}, json);
              for (var j = 0, jLen = colfm.length; j < jLen; j++) {
                var value = colfm[j].match(regstr)[0];
                njson.func = njson.func.replace(colfm[j], value + (ii + 1));
              }
              var rule = HChtHelper.Validate.getFunc(njson, instance.GridSettings, njson.type);
              if (rule.flag != 1) {
                funcList.push(rule);
              }
            }
          } else if (rowfm && rowfm.length > 0) {
            for (var ii = 0; ii < colLen; ii++) {
              if (instance.GridSettings.fixedColumnsLeft > ii) {
                continue;
              }

              var str = HChtHelper.Common.getExcelNumToChar(ii);
              if (novalidity.length > 0) {
                if (novalidity.indexOf(str) > -1) { //判断是否不验证
                  continue;
                }
              }
              var njson = $.extend({}, json);
              for (var j = 0, jLen = rowfm.length; j < jLen; j++) {
                var value = rowfm[j].match(regstr)[0];
                njson.func = njson.func.replace(rowfm[j], str + value);
              }
              var rule = HChtHelper.Validate.getFunc(njson, instance.GridSettings, njson.type);
              if (rule.flag != 1) {
                funcList.push(rule);
              }
            }
          }
        }
        if (vdataList.length > 0) {
          jsons.vdata = vdataList;
          jsons.vdataflag = true;
        }
        if (funcList.length > 0) {
          jsons.func = funcList;
          jsons.funcflag = true;
        }
        return jsons;
      },
      //拉伸
      stretch: function (_this) {
        var target = $(_this).data('target');
        switch (target) {
          case 'stretch-all':
            instance.GridSettings.stretchH = 'all';
            break;
          case 'hybrid':
            instance.GridSettings.stretchH = 'hybrid';
            break;
          case 'last':
            instance.GridSettings.stretchH = 'last';
            break;
          case 'none':
            instance.GridSettings.stretchH = 'none';
            break;

        }
        //instance.handsontable.render();
        instance.handsontable.rootElement.html('');
        priv.setHandsontable();
      },
      //手动计算
      calculation: function () {
        var startTime = new Date();
        instance.map.setManualCalculation();
        var endTime = new Date();
      },
      //计算排行
      rank: function () {
        instance.map.setRank();
      },
      //自动取数
      autofetching: function () {
        var reportContent = JSON.stringify(instance.saveParams());
        if (!$('#pd').val() || !$('#time_code').val()) {
          return;
        }
        $.ajax({
          url: "templetstime-getIndicatorValueAuto.action",
          data: {
            pd: $('#pd').val(),
            time_code: $('#time_code').val(),
            datacontent: reportContent
          },
          type: 'post',
          dataType: 'json',
          beforeSend: function () {
            layert = layer.msg('数据加载中，请稍后...', {
              icon: 16,
              shade: 0.5
            });
          },
          complete: function () {
            layer.close(layert);
          },
          success: function (data) {
            instance.GridSettings = $.extend(instance.GridSettings, data[0].datacontent);
            instance.handsontable.updateSettings(instance.GridSettings);
          }
        })
      }
    };
    /**
     * 增删改查 settings.data settings.styleData settings.ruleData
     *
     */
    this.map = {
        /**
         * 设置表格行高
         * @param  {Object} _this
         */
        otherfetching: function (_this) {
          var id = $(_this).parent().data('id');
          var $div = $('#otherfetching-' + id + '-' + instance.tid);
          var $th = $div.find('div[data-id="cont-otherfetching-' + id + '-' + instance.tid + '"]');
          var value = $th.find('textarea').val();
          var json = {
            'value': value
          };
          //有值
          if (value) {
            instance.map.setCommonRule(function () {
              instance.map.setColumnProp(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);

            }, json, 'otherfetching');
          }
        },
        /**
         * 判断某行中是否出现zb 默认空行数为1 emptyRows = 1
         * 如果ruledata中zb出现 空格为0 添加新行
         * @return {[type]}
         */
        countEmptyRowsZBG: function (row) {
          var ruleRow = instance.GridSettings.ruleData[row];
          if (!ruleRow) {
            return 1;
          }
          var emptyRows = 1;
          for (var i = 0, len = ruleRow.length; i < len; i++) {
            var zb = instance.map.getColumnProp(row, i, 'zb');
            if (zb) {
              emptyRows = 0;
              break;
            }
          }
          return emptyRows;
        },
        /**
         * 判断某整列中是否出现zb
         */
        countEmptyColsZBG: function (col) {
          var ruleData = instance.GridSettings.ruleData;
          var emptyRows = 1;
          for (var i = 0, len = ruleData.length; i < len; i++) {
            var zb = instance.map.getColumnProp(i, col, 'zb');
            if (zb) {
              emptyRows = 0;
              break;
            }
          }
          return emptyRows;
        },
        /**
         * 调用编辑事件
         */
        setDataAtCellOther: function (row, col) {
          instance.map.setColumnProp(row, col, 'editor', 1, 'styleData');
          if (instance.GridSettings.setDataAtCellOther instanceof Function) {
            instance.GridSettings.setDataAtCellOther(row, col);
          }
        },
        /**
         * 通过func参数 匹配删除
         */
        removeColFormats: function (func) {
          var colFormats = instance.GridSettings.colFormats;
          for (var i = 0, len = colFormats.length; i < len; i++) {
            var json = colFormats[i];
            if (json.func == func) {
              colFormats.splice(i, 1);
              break;
            }
          }
        },
        /**
         * 合并单元格
         */
        setHTMerge: function (corners) {
          //Handsontable.PluginHooks.run(instance.handsontable, 'beforeInit');
          var cellRange = new WalkontableCellRange({
            'row': corners[0],
            'col': corners[1]
          }, {
            'row': corners[0],
            'col': corners[1]
          }, {
            'row': corners[2],
            'col': corners[3]
          });
          instance.handsontable.mergeCells.mergeOrUnmergeSelection(cellRange);
          instance.GridSettings.mergeCells = instance.handsontable.mergeCells.mergedCellInfoCollection;
        },
        /**
         * [tableskin ]
         * @param  {String} type  皮肤类型
         * @param  {Number} row   行坐标
         * @param  {Number} col   列坐标
         * @param  {NUmber} value 值
         */
        setTableskinStyle: function (type, row, col, value) {
          type = type || instance.GridSettings.tableskin;
          if (type == 'fixednum') {
            var style = instance.map.getColumnProp(row, col, 'styleData');
            var old = style && style[5] || '';
            if (old) {
              return;
            }
            if (!isNaN(value)) {
              instance.map.setStyleProp(row, col, 5, 'r');
            }
          }
        },
        /**
         * 当行列发生改变时，重置合并单元格 坐标
         * @param  {Array}  coords  坐标
         * @param  {String} columns 行/列 row/col
         * @param  {String} handle  操作 = 添加/删除   add/del
         */
        resetMergeCells: function (coords, columns, handle) {
          var merges = instance.GridSettings.mergeCells;
          var arrIndex = [],
            newMerges = [];
          if (!merges || merges.length < 1) {
            return;
          }

          if (columns == 'row' && handle == 'del') { //删除行
            for (var i = 0, len = merges.length; i < len; i++) {
              var json = merges[i],
                row = merges[i].row,
                col = merges[i].col,
                rowspan = merges[i].rowspan,
                colspan = merges[i].colspan;
              if (row == coords && rowspan == 1) {
                arrIndex.push(i);
              } //1行多列 删除合并单元格
              else if (row + rowspan - 1 == coords || col == coords) { //2行1列 删除合并单元格
                if (colspan > 1) {
                  merges[i].rowspan = Math.max(rowspan - 1, 1);
                  break;
                }
                arrIndex.push(i);
              } else if (row >= coords) { //减少右侧合并单元格行号。
                merges[i].row = Math.max(row - 1, 0);
              } else if (row + rowspan - 1 > coords && rowspan > 2) { //处理中间行 rowspan - 1
                merges[i].rowspan = Math.max(rowspan - 1, 1);
              }
            }
          } else if (columns == 'row' && handle == 'add') { //添加行
            for (var i = 0, len = merges.length; i < len; i++) {
              var json = merges[i],
                row = merges[i].row,
                col = merges[i].col,
                rowspan = merges[i].rowspan,
                colspan = merges[i].colspan;
              /*if(row == coords && rowspan == 1){} //1行多列
              else */
              if (coords > row && coords <= row + rowspan - 1) { //多行1列
                merges[i].rowspan = Math.max(rowspan + 1, 1);
              } else if (row >= coords) { //添加右侧/下侧合并单元格行号。
                merges[i].row = Math.max(row + 1, 0);
              } else if (row + rowspan - 1 > coords && rowspan > 2) { //处理中间行 rowspan + 1
                merges[i].rowspan = Math.max(rowspan + 1, 1);
              }
            }
          } else if (columns == 'col' && handle == 'del') { //删除列
            for (var i = 0, len = merges.length; i < len; i++) {
              var json = merges[i],
                row = merges[i].row,
                col = merges[i].col,
                rowspan = merges[i].rowspan,
                colspan = merges[i].colspan;
              if (col == coords && colspan == 1) {
                arrIndex.push(i);
              } //多行1列 删除合并单元格
              else if (col + colspan - 1 == coords || col == coords) { //1行2列 删除合并单元格
                if (rowspan > 1) {
                  merges[i].colspan = Math.max(colspan - 1, 1);
                  break;
                }
                arrIndex.push(i);
              } else if (col >= coords) { //减少右侧合并单元格行号。
                merges[i].col = Math.max(col - 1, 0);
              } else if (col + colspan - 1 > coords && colspan > 2) { //处理中间列 colspan - 1
                merges[i].colspan = Math.max(colspan - 1, 1);
              }
            }
          } else if (columns == 'col' && handle == 'add') { //添加列
            for (var i = 0, len = merges.length; i < len; i++) {
              var json = merges[i],
                row = merges[i].row,
                col = merges[i].col,
                rowspan = merges[i].rowspan,
                colspan = merges[i].colspan;
              if (col == coords && colspan == 1) {} //多行1列
              else if (coords > col && coords <= col + colspan - 1) { //1行2列
                merges[i].colspan = Math.max(colspan + 1, 1);
              } else if (col >= coords) { //减少右侧合并单元格行号。
                merges[i].col = Math.max(col + 1, 0);
              } else if (col + colspan - 1 > coords && colspan > 2) { //处理中间列 colspan - 1
                merges[i].colspan = Math.max(colspan + 1, 1);
              }
            }
          }
          //避免合并单元格出现NULL情况，对象冲突
          var oldMerges = JSON.parse(JSON.stringify(merges));
          for (var i = 0, len = oldMerges.length; i < len; i++) {
            if (arrIndex.indexOf(i) == -1) {
              if (oldMerges[i]) {
                newMerges.push(oldMerges[i]);
              }
            } else {
              instance.handsontable.mergeCells.mergedCellInfoCollection.removeInfoOther(oldMerges[i]);
            }
          }
          instance.GridSettings.mergeCells = newMerges;
          if (instance.handsontable) {
            instance.map.removeHansontableMergeOfAddMerge(newMerges);
            instance.handsontable.updateSettings(instance.GridSettings);
          }

        },
        /**
         * 删除handsontable中的全部合并单元格，通过合并单元格数组重新添加
         * @return {Array} arrMerge
         */
        removeHansontableMergeOfAddMerge: function (arrMerge) {
          //清除handsontable中所有的合并单元格
          instance.handsontable.mergeCells.mergedCellInfoCollection.removeInfoAll();
          //重新设置handsontable中的合并单元格
          for (var i = 0, len = arrMerge.length; i < len; i++) {
            var json = arrMerge[i],
              row = json.row,
              col = json.col,
              rowspan = json.rowspan,
              colspan = json.colspan,
              cellRange = new WalkontableCellRange({
                'row': row,
                'col': col
              }, {
                'row': row,
                'col': col
              }, {
                'row': row + rowspan - 1,
                'col': col + colspan - 1
              });
            instance.handsontable.mergeCells.mergeOrUnmergeSelection(cellRange);
          }
        },
        /**
         * 移除某个单元格的规则以及样式 指标分组除外
         * @param {Number} row 行坐标
         * @param {Number} col 列坐标
         */
        removeStyleRule: function (row, col, attr) {
          var style = instance.GridSettings.styleData[row][col].style;
          var rule = instance.GridSettings.ruleData[row][col].rule;
          if (style) {
            delete instance.GridSettings.styleData[row][col].style;
          }
          if (rule) {
            delete instance.GridSettings.ruleData[row][col].rule;
          }
        },
        /**
         * 给ruleData styleData赋值 rule.setformat 支持两级结点
         * @param {Function} func  方法
         * @param {String}   value 值
         * @param {String}   prop  结点
         * @param {String}   type  类型
         */
        setCommonRule: function (func, value, prop, type) {
          var corners = instance.handsontable.getSelected();
          corners = instance.setCellSelectionSort(corners);
          for (var i = corners[0], len = corners[2]; i <= len; i++) {
            for (var j = corners[1], jLen = corners[3]; j <= jLen; j++) {
              if (prop.indexOf('.') > -1) {
                var pps = prop.split('.');
                var rule = instance.map.getColumnProp(i, j, pps[0]) || {};
                rule[pps[1]] = value;
                func(i, j, pps[0], rule, type);
              } else {
                func(i, j, prop, value, type);
              }
            }
          }
        },
        /**
         * 设置单元格 style中的属性值
         * @param {Int}       row   行
         * @param {Int}       col   列
         * @param {Int}       index 索引
         * @param {String}    value 设置的值
         */
        setStyleProp: function (row, col, index, value) {
          var styleData = instance.GridSettings.styleData;
          if (styleData) {
            var colStyle = styleData[row][col];
            var style = colStyle.style || [];
            style[index] = value;
            colStyle.style = style;
          }
        },
        /**
         * 设置单元格 style中的属性值
         * @param {Int}       row   行
         * @param {Int}       col   列
         * @param {Int}       index 索引
         * @param {String}    value 设置的值
         */
        setStyleBorderProp: function (row, col, index, value) {
          var styleData = instance.GridSettings.styleData;
          if (styleData) {
            var colStyle = styleData[row][col];
            var style = colStyle.style || [];
            style[index] = (style[index] || '') + value;
            colStyle.style = style;
          }
        },
        /**
         * 获取单元格的值
         * @param {Number} 	row 			行号
         * @param {Number} 	col 			列号
         * @param {String} 	defaultValue	默认值
         * @param {Array}	jsonList		数据源
         * @return {String}     
         */
        getDataAtCell: function (row, col, defaultValue, jsonList) {
          var value = '' || defaultValue;
          var sources = jsonList || instance.GridSettings.data;
          try {
            value = sources[row][col] || defaultValue || 0;
          } catch (e) {
            var rowCount = sources.length;
            var msg = rowCount <= row ? '第' + (row + 1) + '行超出表格下标' : e.message;
            layer.msg(msg, {
              icon: 2
            });
          }
          return value;
        },
        /**
         * 设置单元格的值
         * @param  {Number} row 	行号
         * @param  {Number} col 	列号
         * @param {String} value 	值
         */
        setDataAtCell: function (row, col, value) {
          var rowCount = instance.handsontable.countRows()
          if (rowCount <= row) {
            layer.msg('第' + (row + 1) + '行超出表格下标', {
              icon: 2
            });
          } else {
            instance.GridSettings.data[row][col] = value || 0;
          }
        },
        /**
         * 设置某列的属性值
         * @param {Int}       row   	行
         * @param {Int}       col   	列
         * @param {String}    prop  	属性名称
         * @param {String}    value 	属性值
         * @param {String}    prevProp	样式/规则
         */
        setColumnProp: function (row, col, prop, value, prevProp) {
          prevProp = prevProp || 'ruleData';
          var dataMap = instance.GridSettings[prevProp];
          if (!dataMap[row]) {
            this.addRow(row);
          }
          dataMap[row][col][prop] = value;
        },
        /**
         * 获取某列的属性值
         * @param {Int}    row   行
         * @param {Int}    col   列
         * @param {String} prop  属性名称
         * return
         */
        getColumnProp: function (row, col, prop, prevProp) {
          prevProp = prevProp || 'ruleData';
          var dataMap = instance.GridSettings[prevProp];
          return dataMap[row] && dataMap[row][col] ? dataMap[row][col][prop] : '';
        },
        /**
         * 移除某列的属性值
         * @param {Number} row 行号
         * @param {Number} col 列号
         */
        removeColumnProp: function (row, col, prop, prevProp) {
          prevProp = prevProp || 'ruleData';
          var dataMap = instance.GridSettings[prevProp];
          delete dataMap[row][col][prop];
        },
        /**
         * 添加行
         * @param {Number} row  行索引
         * @param {String} type 类型
         */
        addRow: function (row, type) {
          var colLen = instance.GridSettings.ruleData[0].length;
          var arr = [];
          for (var i = 0; i < colLen; i++) {
            arr.push({});
          }
          var str = JSON.stringify(arr);
          instance.GridSettings.ruleData.splice(row, 0, eval(str));
          instance.GridSettings.styleData.splice(row, 0, eval(str));
          if (type == 'insert_col_zbgroup' && row > 0) {
            var rowRule = instance.GridSettings.ruleData[row - 1];
            var currentRow = instance.GridSettings.ruleData[row];
            for (var j = 0, len = rowRule.length; j < len; j++) {
              var rule = rowRule[j];
              var currentCol = currentRow[j];
              if (rule.zb) {
                currentCol.zb = $.extend(true, [], rule.zb);
              }
              if (rule.group) {
                currentCol.group = $.extend(true, [], rule.group);
              }
              if (rule.area) {
                currentCol.area = $.extend(true, [], rule.area);
              }
              if (rule.contrast) {
                currentCol.contrast = $.extend(true, [], rule.contrast);
              }
              if (rule.datetime) {
                currentCol.datetime = $.extend(true, [], rule.datetime);
              }
              if (rule.timecode) {
                currentCol.timecode = $.extend(true, [], rule.timecode);
              }
            }
          }
          instance.map.resetMergeCells(row, 'row', 'add');
        },
        /**
         * 添加列
         * @param {Number} col  列索引
         * @param {String} type 类型
         */
        addCol: function (col, type) {
          var rowLen = instance.GridSettings.ruleData.length;
          for (var i = 0; i < rowLen; i++) {
            //if(!col && col!=0){col = settings.ruleData[i].length;}
            instance.GridSettings.ruleData[i].splice(col, 0, {});
            instance.GridSettings.styleData[i].splice(col, 0, {});
            if (type == 'insert_col_zbgroup' && col > 0) {
              var colRule = instance.GridSettings.ruleData[i][col - 1];
              var currentCol = instance.GridSettings.ruleData[i][col];
              if (colRule.zb) {
                currentCol.zb = $.extend(true, [], colRule.zb);
              }
              if (colRule.group) {
                currentCol.group = $.extend(true, [], colRule.group);
              }
              if (colRule.area) {
                currentCol.area = $.extend(true, [], colRule.area);
              }
              if (colRule.contrast) {
                currentCol.contrast = $.extend(true, [], colRule.contrast);
              }
              if (colRule.datetime) {
                currentCol.datetime = $.extend(true, [], colRule.datetime);
              }
              if (colRule.timecode) {
                currentCol.timecode = $.extend(true, [], colRule.timecode);
              }
            }
          }
          instance.map.resetMergeCells(col, 'col', 'add');
        },
        /**
         * 删除行
         * @param {Number} row  行索引
         */
        removeRow: function (row) {
          var rowLen = instance.GridSettings.styleData.length;
          if (rowLen > row) {
            instance.GridSettings.ruleData.splice(row, 1);
            instance.GridSettings.styleData.splice(row, 1);
            instance.map.resetMergeCells(row, 'row', 'del');
          }
        },
        /**
         * 删除列
         * @param {Number} col  列索引
         */
        removeCol: function (col) {
          var rowLen = instance.GridSettings.styleData.length;
          for (var i = 0; i < rowLen; i++) {
            instance.GridSettings.ruleData[i].splice(col, 1);
            instance.GridSettings.styleData[i].splice(col, 1);
          }
          instance.map.resetMergeCells(col, 'col', 'del');
        },
        /**
         * 设置选中样式集合 并且刷新整个table表格
         * @param {String} value   值
         * @param {Number} index   下标setCellSelectionState
         * @param {String} prop    属性名称
         */
        setSelectStyleProp: function (value, prop, index) {
          var corners = instance.setCellSelectionSort(instance.handsontable.getSelected());
          corners = instance.setCellSelectionSort(corners);
          for (var i = corners[1]; i <= corners[3]; i++) { //遍历列
            for (var y = corners[0]; y <= corners[2]; y++) { //遍历行
              var json = instance.GridSettings.styleData[y][i];
              var style = json[prop] ? json[prop] : [];
              style[index] = style[index] ? 0 : value;
              json[prop] = style;
            }
          }
        },
        /**
         * 设置选中样式集合 并且刷新整个table表格
         * @param {String} value   值
         * @param {String} prop    属性名称
         * @param {Number} index   下标setCellSelectionState
         */
        setSelectStyleOtherProp: function (value, prop, index) {
          var corners = instance.setCellSelectionSort(instance.handsontable.getSelected());
          corners = instance.setCellSelectionSort(corners);
          for (var i = corners[1]; i <= corners[3]; i++) { //遍历列
            for (var y = corners[0]; y <= corners[2]; y++) { //遍历行
              var json = instance.GridSettings.styleData[y][i];
              var style = json[prop] ? json[prop] : [];
              style[index] = value;
              json[prop] = style;
            }
          }
        },
        /**
         * [设置/取消只读]
         * @param {Number}   value  [值]
         * @param {Number}   row    [行号]
         * @param {Number}   col    [列号]
         */
        setReadonly: function (value, row, col) {
          var json = instance.GridSettings.styleData[row][col];
          var style = json.style ? json.style : [];
          style[0] = value;
          json.style = style;
        },
        /**
         * [获取/取消只读]
         * @param {Number}   row    [行号]
         * @param {Number}   col    [列号]
         */
        getReadonly: function (row, col) {
          var json = instance.GridSettings.styleData[row][col];
          return (json.style && json.style[0]) || 0;
        },
        /**
         * 设置选中样式集合 并且刷新整个table表格
         * @param {String} value   值
         * @param {String} prop    属性名称
         */
        setSelectProp: function (value, prop) {
          var corners = instance.handsontable.getSelected();
          corners = instance.setCellSelectionSort(corners);
          for (var i = corners[1]; i <= corners[3]; i++) { //遍历列
            for (var y = corners[0]; y <= corners[2]; y++) { //遍历行
              var json = instance.GridSettings.styleData[y][i];
              var style = json[prop] ? json[prop] : [];
              this.setColumnProp(y, i, prop, value, 'styleData');
            }
          }
        },
        /**
         * 获取单元格指标分组信息
         * @param  {Number} row 行号
         * @param  {Number} col 列号
         * @return {JSON} 
         */
        getColumnZbGroup: function (row, col) {
          var zbgroup2 = ['zb', 'group', 'area', 'contrast', 'datetime'];
          var json = {};
          for (var i = 0, len = zbgroup2.length; i < len; i++) {
            var item = zbgroup2[i];
            json[item] = instance.map.getColumnProp(row, col, item);
          }
          return json;
        },
        /**
         * 获取报表指标分组 编辑过的数据
         *
         */
        getZbgroupEditor: function () {
          var zbgroup = ['indicator_id', 'member_id', 'area_id', 'cal_id', 'unit1_id', 'groupType', 'datetime_id'];
          var zbgroup2 = ['zb', 'group', 'area2', 'contrast', 'datetime'];
          var arrs = this.getConditionalScreening('editor', zbgroup2, 'ruleData');
          var jsons = {};
          for (var i = 0, k = 0, n = arrs.length; i < n; i++) {
            var arr = arrs[i];
            if (arr[2]) { //指标ID
              jsons['listReportData[' + k + '].row_id'] = arr[0];
              jsons['listReportData[' + k + '].col_id'] = arr[1];
              for (var j = 0, y = zbgroup.length; j < y; j++) {
                jsons['listReportData[' + k + '].' + zbgroup[j]] = arr[j + 2];
              }
              jsons['listReportData[' + k + '].value1'] = instance.GridSettings.data[arr[0]][arr[1]];
              k++;
            }
          }
          return jsons;
        },
        /**
         * arr数组保存的索引 （2指标 3分组  4区域 5对比项 6时间偏移量）
         * 后台数据中保存的 [1对比项， 2地区分组， 3分组类别， 4分组成员 5时间偏移量]
         * @param {Number} index arr的索引
         * return str  前台 对应 后台
         */
        getMappingtype: function (index) {
          var str = '';
          if (index == 3) {
            str = 4;
          }
          if (index == 4) {
            str = 2
          }
          if (index == 5) {
            str = 1;
          }
          if (index == 6) {
            str = 5;
          }
          return str;
        },
        /**
         * 获取报表指标分组 编辑过的数据
         *
         */
        getZbgroupMappingEditor: function () {
          var zbgroup = ['indicator_id', 'member_id', 'area_id', 'cal_id', 'unit1_id', 'groupType', 'datetime_id'];
          var zbgroup2 = ['group', 'area2', 'contrast', 'datetime'];
          var arrs = this.getConditionalScreening('zb', zbgroup2, 'ruleData');
          var jsons = {};
          for (var i = 0, k = 0, n = arrs.length; i < n; i++) {
            var arr = arrs[i];
            if (arr[2]) { //指标ID
              for (var j = 2; j < 6; j++) {
                if (arr[j]) {
                  jsons['indicatorMappingList[' + k + '].row_id'] = arr[0];
                  jsons['indicatorMappingList[' + k + '].col_id'] = arr[1];
                  jsons['indicatorMappingList[' + k + '].indicator_id'] = arr[2];
                  if (j != 2)
                    jsons['indicatorMappingList[' + k + '].mappingtype'] = this.getMappingtype(j);
                  jsons['indicatorMappingList[' + k + '].target_id'] = arr[j];
                  k++;
                }
              }
            }
          }
          //jsons['templet_id'] = '';  //模版ID
          //jsons['isdel']='';         //可否删除
          //jsons['iscompute'] = '';   //[是否可计算 1可0不可]
          return jsons;
        },
        /**
         * 条件筛选
         * @param {String} Condition 条件 目前只允许单条件
         * @param {Array}  data      需要获取的数据集 ['zb', 'group', 'area2', 'contrast']
         * @param {String} prevProp  settings 的属性名称
         */
        getConditionalScreening: function (condition, data, prevProp) {
          prevProp = prevProp || 'ruleData';
          var dataMap = instance.GridSettings[prevProp];
          var styleMap = instance.GridSettings.styleData;
          var arrs = [];
          for (var i = 0, n = dataMap.length; i < n; i++) {
            if (!styleMap[i]) {
              this.addRow(styleMap.length - 1)
            }
            var dataRow = dataMap[i];
            var styleRow = styleMap[i];
            for (var j = 0, y = dataRow.length; j < y; j++) {
              var editData = null;
              if (condition == 'editor') {
                editData = styleRow[j][condition];
              } else {
                editData = dataRow[j][condition];
              }
              if (editData) {
                var arr = [],
                  unitid = '',
                  groupType = '';
                arr.push(i, j);
                for (var k = 0, z = data.length; k < z; k++) {
                  var sel = dataRow[j][data[k]];
                  var id = '';
                  if (sel) { //指标分组...
                    id = sel[0].join(',');
                    if (data[k] == 'zb') unitid = sel[2].join(',');
                    if (data[k] == 'group') groupType = sel[2].join(',');
                  }
                  arr.push(id);
                }
                arr.push(unitid);
                arr.push(groupType);
                arrs.push(arr);
              }
            }
          }
          return arrs;
        },
        /**
         * 设置计算公式
         * @param {String} str 公式
         */
        setFormula: function (str) {
          var corners = instance.handsontable.getSelected();
          if (corners[0] == corners[2] && corners[1] == corners[3]) {
            var ruleData = instance.GridSettings.ruleData;
            var colRule = ruleData[corners[0]][corners[1]];
            var rule = colRule.rule = colRule.rule || {};
            if (str == '') { //del
              delete rule.formula;
            } else { //add
              var val = HChtHelper.Common.getExcelNumToChar(corners[1]) + (corners[0] + 1);
              rule.formula = (val + str);
            }
          }
        },
        /**
         * 自动计算公式的值
         * @param {String} formula 公式
         * return value
         */
        updateFormula: function (formula) {
          var reg = /[A-Za-z]+\d+/g;
          var arr = formula.split('=');
          var pcoord = HChtHelper.Common.getExcelCharToArray(arr[0]);
          var fnext = arr[1].match(reg);
          for (var i = 0, n = fnext.length; i < n; i++) {
            let coord = HChtHelper.Common.getExcelCharToArray(fnext[i]);
            var value = instance.GridSettings.data[coord[0]][coord[1]] || 0;
            arr[1] = arr[1].replace(fnext[i], value);
          }
          var value = eval(arr[1])
          settings.data[pcoord[0]][pcoord[1]] = value;
          return value || '';
        },
        /**
         * 计算排行
         * @param {String} formula 公式
         * return value
         */
        updateRank: function (formula) {
          var value = 'NAN';
          var reg = /(?=\()[\s\S]+(?=\))/;
          var str = formula.match(reg).toString().toUpperCase().replace('(', '');
          if (str.indexOf(':') > -1) { //A1:A8
            var arr = str.split(',');
            var ref = arr[1];
            var arr2 = ref.split(':');
            var s = arr2[0].match(/[A-Za-z]/g).toString();
            var s2 = arr2[0].match(/[A-Za-z]/g).toString();
            var num = Number(arr2[0].match(/\d/g));
            var num2 = Number(arr2[1].match(/\d/g));
            if (s == s2) {
              arr2 = [];
              for (var i = num; i <= num2; i++) {
                arr2.push(s + i);
              }
              ref = '(' + arr2.join(',') + ')';
              str = str.replace(arr[1], ref);
            } else {
              alert('(' + formula + ')公式有误!');
              return;
            }
          }
          if (str.indexOf('(') > -1) { //(A1,A2,A3,A4)
            reg = /[A-Za-z]\d+/g;
            var arr = str.match(reg);
            if (arr.length > 0) {
              for (var i = 0, len = arr.length; i < len; i++) {
                let coord = HChtHelper.Common.getExcelCharToArray(arr[i]);
                var val = instance.GridSettings.data[coord[0]][coord[1]] || 0;
                str = str.replace(arr[i], val);
              }
            }
            reg = /(?=\()[\s\S]+\)/;
            var ref = str.match(reg).toString();
            str = str.replace(ref, '');
            ref = ref.replace('(', '').replace(')', '');
            if (ref.indexOf(',') > -1) {
              ref = ref.split(',');
            } else {
              ref = [ref];
            }
            arr = str.split(',');
            var val = arr[0];
            var asc = arr[2] || 0;
            if (ref.indexOf(val) > -1) {
              if (asc == 0) { //降序
                ref = ref.sort(function (a, b) {
                  return b - a;
                })
              } else if (asc == 1) { //升序
                ref = ref.sort(function (a, b) {
                  return a - b;
                })
              }
              value = ref.indexOf(val) + 1;
            }
          }
          var pcoord = formula.split('=')[0];
          pcoord = HChtHelper.Common.getExcelCharToArray(pcoord);
          instance.GridSettings.data[pcoord[0]][pcoord[1]] = value;
          return value;
        },
        /**
         * 自动计算公式的值  IF计算
         * @param {String} formula 公式
         * return value
         */
        updateIF: function (formula) {
          var reg2 = /IF\(.*?\)/;
          if (reg2.test(formula)) {
            reg = /[A-Za-z]+\d+/g;
            var arr = formula.split('=');
            var pcoord = HChtHelper.Common.getExcelCharToArray(arr[0]);
            var str = arr[1];
            var fnext = str.match(reg);
            for (var i = 0, n = fnext.length; i < n; i++) {
              let coord = HChtHelper.Common.getExcelCharToArray(fnext[i]);
              var value = instance.GridSettings.data[coord[0]][coord[1]] || 0;
              str = str.replace(fnext[i], value);
            }
            str = str.toUpperCase();

            while (str.indexOf('IF') > -1) {
              str = str.replace(/IF/g, '@@');
              var regStr = str.substring(str.lastIndexOf('@@'));
              regStr = regStr.replace('@@', 'IF');
              regStr = regStr.match(reg2)[0];
              var oldStr = regStr.replace('IF', '@@');
              regStr = regStr.substr(0, regStr.length - 1);
              regStr = regStr.replace('IF(', '');
              var arr2 = regStr.split(',');
              var val = eval(arr2[0]) ? eval(arr2[1]) : eval(arr2[2]);
              str = str.replace(oldStr, val);
              str = str.replace(/@@/g, 'IF');
            }
            instance.GridSettings.data[pcoord[0]][pcoord[1]] = str;
            return str || '';
          } else {
            return '#ERROR?';
          }

        },
        /**
         * 设置函数
         * @param {String} str     函数
         * @param {String} msg     提示信息
         * @param {String} error   错误信息
         */
        setFunc: function (str, msg, err) {
          var corners = instance.handsontable.getSelected();
          var ruleData = instance.GridSettings.ruleData;
          var colRule = ruleData[corners[0]][corners[1]];
          var rule = colRule.rule = colRule.rule || {};
          if (str == '') { //del
            delete rule.func;
          } else { //add
            rule.func = {
              'formula': str,
              'msg': (msg || ''),
              'err': (err || '')
            };
          }

        },
        /**
         * 设置数据有效性
         * @param {Object} _this   html对象
         */
        vdata: function (_this) {
          var corners = instance.handsontable.getSelected();
          corners = instance.setCellSelectionSort(corners);
          var txt_dformat = document.getElementById('hidden-dformat-' + instance.tid);
          var txt_func = document.getElementById('hidden-func-' + instance.tid);
          var vdata = txt_dformat.value;
          var ruleData = instance.GridSettings.ruleData;
          var id = $(_this).parent().data('id');
          var $div = $('#validitydata-' + id + '-' + instance.tid);
          var $dformat = $div.find('div.hthelper-cont[data-target="dformat"]');
          var $cbk = $dformat.find('span[type="checkbox"]');
          var type = $cbk.eq(2).hasClass('current') ? 1 : 0;
          type += ',' + ($cbk.eq(3).hasClass('current') ? 1 : 0);
          for (var i = corners[0]; i <= corners[2]; i++) {
            for (var j = corners[1]; j <= corners[3]; j++) {
              var colRule = ruleData[i][j];
              var rule = colRule.rule = colRule.rule || {};
              if (vdata == '') { //del
                delete rule.vdata;
                if (JSON.stringify(colRule.rule) == '{}') {
                  delete colRule.rule;
                }
              } else { //add
                var json = {};
                var arr = vdata.split(',');
                for (var k = 0, n = 2; k < n; k++) {
                  arr[k] = $cbk.eq(k).hasClass('current') ? 1 : 0;
                }
                json.vdata = arr.join(',');
                json.type = type;
                rule.vdata = json;
              }
            }
          }

          //公式函数
          var $func = $div.find('div.hthelper-cont[data-target="func"]');
          var $input = $func.find('div.hthelper-dformat-list').find('input');
          var $cbk = $func.find('div.hthelper-selector').find('span[type="checkbox"]');
          var txt1 = $input.eq(0).val(),
            txt2 = $input.eq(1).val(),
            reg0 = /[A-Za-z]+\d+/g,
            examine = $cbk.eq(0).hasClass('current') ? 1 : 0;
          var type = $cbk.eq(1).hasClass('current') ? 1 : 0;
          type += ',' + ($cbk.eq(2).hasClass('current') ? 1 : 0);
          if ($.trim(txt1) != '') {
            var arr = txt1.match(reg0);
            let coord = HChtHelper.Common.getExcelCharToArray(arr[0]);
            var colRule = ruleData[coord[0]][coord[1]];
            var rule = colRule.rule = colRule.rule || {};
            var func = rule.func || [];
            func.push({
              'func': txt1,
              'note': txt2,
              'examine': examine,
              'type': type
            });
            rule.func = func;
          }
        },
        /**
         * 填充内容后清除格式
         * @param {String} value 填充的值
         * @param {Number} row   行
         * @param {Number} col   列
         */
        filledClearFormat: function (value, row, col) {
          if (instance.GridSettings.filledcformat) {
            instance.GridSettings.data[row][col] = value;
            delete instance.GridSettings.ruleData[row][col].rule.setformat;
          }
        },
        /**
         * 设置格式
         * @param {String} value     (target,val,type)
         */
        setFormat: function () {
          var txt_number = document.getElementById('hidden-number-' + instance.tid);
          var corners = instance.handsontable.getSelected();
          corners = instance.setCellSelectionSort(corners);
          /* number */
          var ruleData = instance.GridSettings.ruleData;
          var target = '',
            val = '',
            type = '',
            value = txt_number.value;
          if (value) {
            var arr = value.split(',');
            target = arr[0], val = arr[1], type = arr[2] || '';
          }
          for (var i = corners[0], n = corners[2]; i <= n; i++) {
            for (var j = corners[1], y = corners[3]; j <= y; j++) {
              var colRule = ruleData[i][j];
              var rule = colRule.rule = colRule.rule || {};
              if (target == '' || target == 'normal' || (target == 'other2' && val == '') || (target == 'tihuan' && type == '')) {
                delete rule.setformat;
              } else {
                rule.setformat = value;
              }
            }
          }
          var $border = $('#hidden-border-' + instance.tid);
          var width = $border.data('width');
          var color = $border.data('color');
          var style = $border.data('style');
          if (width && color && style)
            instance.map.setSelectStyleOtherProp([width, style, color], 'style', 10);
          instance.handsontable.render();
        },
        /**
         * 设置格式 边框
         * @param {String} value     (target,val,type)
         */
        setBorder: function (value) {
          var corners = instance.handsontable.getSelected();
          corners = instance.setCellSelectionSort(corners);
        },
        tableskin: function (_this) {
          var id = $(_this).parent().data('id');
          var $div = $('#tableskin-' + id + '-' + instance.tid);
          var $skin = $div.find('div[data-id="cont-tableskin-' + id + '-' + instance.tid + '"]');
          var value = $skin.find('a.active').data('value');
          instance.GridSettings.tableskin = value;
          instance.controller.fixedTableskin([1, , , , 'm', 'c'], [1, , , , 'm']);
        },
        /**
         * 设置表格行高
         * @param  {Object} _this
         */
        theight: function (_this) {
          var id = $(_this).parent().data('id');
          var dom = document.getElementById('hidden-theight2-' + instance.tid);
          instance.GridSettings.theight = dom.value;
        },
        /**
         * 重新计算公式的值
         */
        setManualCalculation: function () {
          var formulas = [],
            flag = true,
            ruleData = instance.GridSettings.ruleData;

          if (ruleData.length > 0) {
            //循环全表 取出表中所有公式
            var startTime = new Date();
            for (var i = 0, len = ruleData.length; i < len; i++) {
              var rowRule = ruleData[i];
              for (var j = 0, jLen = rowRule.length; j < jLen; j++) {
                var colRule = rowRule[j];
                var rule = colRule.rule;
                if (rule && rule.formula) {
                  formulas.push({
                    'formula': rule.formula,
                    'col': j,
                    'row': i,
                  });
                }
              }
            }
            var endTime = new Date();
            //公式长度
            if (formulas.length > 0) {
              var xxx = 1;
              //正、倒序 循环公式 赋值 判断正、倒序的值 相等跳出循环
              while (flag) {
                var arrAsc = [],
                  arrDesc = [],
                  newFormula;
                var startTime2 = new Date();
                //正序
                for (var i = 0, len = formulas.length; i < len; i++) {
                  var formula = formulas[i].formula.toUpperCase(),
                    col = formulas[i].col,
                    row = formulas[i].row,
                    value = ''
                  try {
                    value = HChtHelper.Common.setFormula(formula, function (coord) {
                      return instance.map.getDataAtCell(coord[0], coord[1], 0, instance.GridSettings.data);
                    });
                  } catch (e) {
                    value = '#error';
                    if (formula.indexOf('#') > -1) {
                      value = '';
                    }
                  }
                  instance.map.setDataAtCell(row, col, value); //赋值
                  //非rep函数进行计算
                  if (formula.indexOf('REP') < 0) {
                    arrAsc.push(value);
                  }
                }
                var endTime2 = new Date();
                //倒序
                for (var j = formulas.length - 1; j >= 0; j--) {
                  var formula = formulas[j].formula.toUpperCase(),
                    col = formulas[j].col,
                    row = formulas[j].row,
                    value = '';
                  try {
                    value = HChtHelper.Common.setFormula(formula, function (coord) {
                      return instance.map.getDataAtCell(coord[0], coord[1], 0, instance.GridSettings.data);
                    });
                  } catch (e) {
                    value = '#error';
                    if (formula.indexOf('#') > -1) {
                      value = '';
                    }
                  }
                  instance.map.setDataAtCell(row, col, value); //赋值
                  if (formula.indexOf('REP') < 0) {
                    arrDesc.unshift(value);
                  }
                }
                if (arrAsc.toString() == arrDesc.toString()) {
                  flag = false;
                  break;
                }
              }
            }
          }
        },
        //计算排行
        setRank: function () {
          var ruleData = instance.GridSettings.ruleData;
          if (ruleData.length > 0) {
            for (var i = 0, len = ruleData.length; i < len; i++) {
              var json = ruleData[i];
              for (var j = 0, jLen = json.length; j < jLen; j++) {
                var colRule = json[j];
                var rules = colRule.rule;
                if (rules) {
                  //公式
                  if (rules.formula) {
                    var formula = rules.formula.toUpperCase();
                    if (formula.indexOf('RANK') > -1) { //值没有刷新
                      try {
                        this.updateRank(formula);
                      } catch (e) {}
                    }
                  }
                }
              }
            }
          }
        },
        /**
         * 拖动单元格时，单元格公式也一并拖动 坐标自动增减
           扫描一次全表，将公式单独保存数组中，(正、倒)序循环数组，
           设置(正、倒)公式所得的值，判断正序 == 倒序的值 结束循环。
           (正、倒序循环 避免单元格公式的值 再计算没有获取到计算后所改变的值。)
         * @param {JSON} start    开始坐标
         * @param {JSON} end      结束坐标
         */
        dragColumnsFormat: function (start, end) {
          /* hchthelper start autofill */
          var formulas = [],
            startCols = start,
            endCols = end,
            arrAsc = [],
            arrDesc = [],
            flag = true,
            arr = [],
            ruleData = instance.GridSettings.ruleData
          //left and right
          if (start[0].row == end[0].row && start[1].row >= end[1].row) {
            arr = (start[0].col > end[0].col) ? [0, -1] : [0, 1]; // right  left
          } // down and up
          else if (start[0].col == end[0].col && start[1].col == end[1].col) {
            arr = (start[0].row >= end[0].row) ? [-1, 0] : [1, 0]; // down up
          }
          if (arr.length == 0) {
            return;
          }
          //循环行列 给拖动的行列 赋公式
          for (var i = end[0].row, index = 0, len = end[1].row; i <= len; i++) {
            var val = 0;
            index += 1;
            //循环列
            for (var j = end[0].col, jLen = end[1].col; j <= jLen; j++) {
              var rule, formula = '',
                func = '',
                pArr = [];
              for (var t in arr) {
                pArr.push(arr[t]);
              }
              if (arr[0] == 0) { //左右
                if (arr[1] == -1) {
                  val = j - jLen + arr[1];
                } //右
                else {
                  val += 1;
                } //左
                pArr[1] = val;
                rule = this.getColumnProp(i, start[0].col, 'rule', 'ruleData');
                if (rule) {
                  formula = rule.formula;
                  func = rule.func;
                }
              } else if (arr[1] == 0) {
                if (arr[0] == -1) {
                  val = i - len + arr[0];
                } //下
                else {
                  val = index;
                } //上
                pArr[0] = val;
                rule = this.getColumnProp(start[0].row, j, 'rule', 'ruleData');
                if (rule) {
                  formula = rule.formula;
                  func = rule.func;
                }
              }
              if (formula) {
                var newFormula = formula;
                var cds = formula.match(/[A-Za-z]+\d+/g);
                for (var k = 0, z = cds.length; k < z; k++) {
                  var value = HChtHelper.Common.getExcelCharColumn(cds[k], pArr[0], pArr[1]);
                  newFormula = newFormula.replace(cds[k], value);
                }
                ruleData[i][j].rule = ruleData[i][j].rule || {};
                ruleData[i][j].rule.formula = newFormula;
              }
              //数据有效性-自定义函数 批量拖动设置 自动增减
              if (func && func.length > 0) {
                var newFunc = JSON.stringify(func);
                newFunc = eval(newFunc);
                for (var l = 0, lLen = func.length; l < lLen; l++) {
                  var vfunc = func[l].func;
                  var cds = vfunc.match(/[A-Za-z]+\d/g);
                  for (var k = 0, z = cds.length; k < z; k++) {
                    var value = HChtHelper.Common.getExcelCharColumn(cds[k], pArr[0], pArr[1]);
                    vfunc = vfunc.replace(cds[k], value);
                  }
                  newFunc[l].func = vfunc;
                }
                ruleData[i][j].rule = ruleData[i][j].rule || {};
                ruleData[i][j].rule.func = newFunc;
              }
            }
          }
          this.setManualCalculation();
          instance.handsontable.render();
        }
      },

      /**
       * 从左上角开始排序被选中单元格
       * @param {Array} corners 选中单元格坐标
       */
      this.setCellSelectionSort = function (corners) {
        //按从小到大重新排列 行和列
        if (corners[0] > corners[2]) {
          corners[0] = (corners[2] + (corners[2] = corners[0]) * 0);
        }
        if (corners[1] > corners[3]) {
          corners[1] = (corners[3] + (corners[3] = corners[1]) * 0);
        }
        return corners;
      }
    /**
     * 设置单元格选中状态 选择多个单元格 只显示左上角被选中单元格
     * @param {Array} corners 选中单元格坐标
     */
    this.setCellSelectionState = function (corners, td) {
      corners = this.setCellSelectionSort(corners);
      if (instance.GridSettings.styleData[corners[0]] === undefined) {
        this.map.addRow(corners[0]);
      }

      if (instance.GridSettings.toolbar.flag) {
        var fc = document.getElementById('formula-coords-' + instance.tid);
        var c = '';
        if (corners[0] == corners[2] && corners[1] == corners[3]) {
          c = HChtHelper.Common.getExcelArrayToChar(corners);
        } else {
          c = HChtHelper.Common.getExcelArrayToChar(corners) + '~' + HChtHelper.Common.getExcelArrayToChar([corners[2], corners[3]]);
        }
        fc.innerHTML = c;
      }
      instanceToolbar.find('a[data-toggle="hthelper"]').removeClass('active');
      //不定长报表
      // if(instance.GridSettings.randomtable){
      // 	instanceToolbar.find('a[data-toggle="hthelper"][data-target="randomtable"]').addClass('active');
      // }
      //固定表头
      if (instance.GridSettings.fixedRowsTop > 0 || instance.GridSettings.fixedColumnsLeft > 0) {
        instanceToolbar.find('a[data-toggle="hthelper"][data-target="fixed"]').addClass('active');
      }
      var ruleData = instance.GridSettings.ruleData;
      var jsonCol = instance.GridSettings.styleData[corners[0]][corners[1]]
      if (jsonCol) {
        var style = jsonCol.style || []
      } else {
        var style = []
      }
      var styleTarget = ['readonly', 'weight', 'tilt', 'underlined', ['top', 'middle', 'bottom'],
        ['left', 'center', 'right'], 'font', 'family', 'color', 'bcolor', 'border', 'strike'
      ];
      for (var i = 0; i < styleTarget.length; i++) {
        var target = styleTarget[i];
        var flag = style[i];
        if (i == 4 || i == 5) { // 数组 多选
          for (var j = 0; j < styleTarget[i].length; j++) {
            target = styleTarget[i][j];
            var $main = instanceToolbar.find('[data-target="' + target + '"]');
            $main[((styleTarget[i][j].substring(0, 1) == style[i]) ? 'addClass' : 'removeClass')]('active');
          }
          continue;
        }
        var $main = instanceToolbar.find('[data-target="' + target + '"]');
        if (i == 6 || i == 7) { //下拉框
          $main[0].selectedIndex = 0;
          if (style[i] && style[i] != '宋体' && style[i] != '12') {
            $main.find('option[value="' + style[i] + '"]').attr('selected', true);
          } else {
            flag = false;
          }
        }
        $main[flag ? 'addClass' : 'removeClass']('active');
      }
      //rule
      var colRule = ruleData[corners[0]][corners[1]];
      if (colRule.rule) {
        var formula = colRule.rule.formula || '';
        if (formula) {
          formula = formula.substring(formula.indexOf('='));
        }
        $('#formula-txt-' + instance.tid).val(formula);
        var setformat = colRule.rule.setformat || '';
      } else {
        $('#formula-txt-' + instance.tid).val('');
      }
      //this.popupSelectedZbG(corners[0], corners[1], td);
    }
    /**
     * 选中单元格 自定义指标解释
     *
     */
    this.popupSelectedIndExplain = function (row, col, td, ev) {
      
      var $popover = $('#popover-' + instance.tid);
      var selJson = this.map.getColumnProp(row, col, 'indExplain');
      var html = [];
      var arr = [];
      var menus = HChtHelper.Config.menus;
      var zbgroup = instance.GridSettings.toolbar.secondMenu.zbgroup;
      html.push('<p class="hthelper-popover-p">' + selJson + '</p>');
      if ($popover.length > 0) {
        $popover.find('div.hthelper-popover-content').html(html.join(''));
      } else {
        var title = '指标解释';
        arr.push('<div class="hthelper-popover" id="popover-' + instance.tid + '"><div class="hthelper-popover-arrow"></div>');
        arr.push('<div class="hthelper-popover-title">' + title + '</div>');
        arr.push('<div class="hthelper-popover-content">');
        arr.push(html.join(''));
        arr.push('</div></div>');
        $('.container-fluid').append(arr.join(''));
        $('#popover-' + instance.tid).on('click', function (event) {
          HChtHelper.Common.stopPropagation(event);
        })
      }
      var event = ev || window.event;
      var tar = event.srcElement || event.target;
      if (event.button == 2 || (tar.nodeName != 'TD' && $(tar).closest('td').length == 0 && $(tar).closest('#popover-' + instance.tid).length == 0 && tar.className != 'hthelper-popover-p')) {
        $('#popover-' + instance.tid).hide();
        return;
      }
      let coord = priv.findPosition(td, 'body');
      if (html.length == 0) {
        $('#popover-' + instance.tid).hide();
      } else {
        $popover = $('#popover-' + instance.tid);
        var h = $popover.height();
        var w = $popover.width();
        var tw = $(td).width();
        $popover.css({
          'position': 'absolute',
          'top': coord[1] - h + 31 + 'px',
          'left': coord[0] - (w - tw) / 2 + 'px'
        }).show();
      }
    }
    /**
     * 选中单元格 公式
     *
     */
    this.popupSelectedGS = function (row, col, td, ev) {
      var arr = [],
        html = [];
      var $popover = $('#popover-' + instance.tid);
      var selJson = this.map.getColumnProp(row, col, 'gongshi');
      var selJsonArr = selJson.split('$');
      var selJsonId = selJsonArr[0].slice(1)
      var reg = new RegExp(selJsonId,'g')
      selJson = selJson.replace(reg,'')
      html.push('<p class="hthelper-popover-p">公式：' + selJson + '</p>');
      var title = '核算公式';
      if ($popover.length > 0) {
        $popover.find('div.hthelper-popover-content').html(html.join(''));
      } else {
        arr.push('<div class="hthelper-popover" id="popover-' + instance.tid + '"><div class="hthelper-popover-arrow"></div>');
        arr.push('<div class="hthelper-popover-title">' + title + '</div>');
        arr.push('<div class="hthelper-popover-content">');
        arr.push(html);
        arr.push('</div></div>');
        $('.container-fluid').append(arr.join(''));
        $('#popover-' + instance.tid).on('click', function (event) {
          HChtHelper.Common.stopPropagation(event);
        })
      }
      var event = ev || window.event;
      var tar = event.srcElement || event.target;
      if (event.button == 2 || (tar.nodeName != 'TD' && $(tar).closest('td').length == 0 && $(tar).closest('#popover-' + instance.tid).length == 0 && tar.className != 'hthelper-popover-p')) {
        $('#popover-' + instance.tid).hide();
        return;
      }
      let coord = priv.findPosition(td, 'body');
      if (html.length == 0) {
        $('#popover-' + instance.tid).hide();
      } else {
        $popover = $('#popover-' + instance.tid);
        var h = $popover.height();
        var w = $popover.width();
        var tw = $(td).width();
        $popover.css({
          'position': 'absolute',
          'top': coord[1] - h + 31 + 'px',
          'left': coord[0] - (w - tw) / 2 + 66 +'px'
        }).show();
      }
    }
    /**
     * 选中单元格 指标分组
     *
     */
    this.popupSelectedZbG = function (row, col, td, ev) {
      var arr = [],
        html = [];
      var menus = HChtHelper.Config.menus;
      //zbgroup
      var zbgroup = instance.GridSettings.toolbar.secondMenu.zbgroup;
      var $popover = $('#popover-' + instance.tid);
      if (instance.GridSettings.toolbar.type == 'all' || instance.GridSettings.showZbGroup === true) {
        for (var i = 0, n = zbgroup.length; i < n; i++) {
          var target = zbgroup[i];
          if (target == 'area2') {
            target = 'area';
          }
          var selJson = this.map.getColumnProp(row, col, target);
          if (!selJson) {
            continue;
          }
          if (target == 'indExplain') {
            html.push('<p class="hthelper-popover-p">' + menus[zbgroup[i]] + '：' + selJson + '</p>');
          } else {
            html.push('<p class="hthelper-popover-p">' + menus[zbgroup[i]] + '：' + selJson[1].join(',') + ' (' + selJson[0].join(',') + ')' + ' ' + (selJson[3] || []).join(',') + '</p>');
          }
        }
      }
      var json = instance.controller.setHcOtherZBG(row, col);
      var title = '指标分组';
      if (json) {
        html.push('<p class="hthelper-popover-p">' + json.pname + '：' + json.msg + '</p>');
        title = instance.GridSettings.hcOtherZBG.title;
      }
      if ($popover.length > 0) {
        $popover.find('div.hthelper-popover-content').html(html.join(''));
      } else {
        arr.push('<div class="hthelper-popover" id="popover-' + instance.tid + '"><div class="hthelper-popover-arrow"></div>');
        arr.push('<div class="hthelper-popover-title">' + title + '</div>');
        arr.push('<div class="hthelper-popover-content">');
        arr.push(html.join(''));
        arr.push('</div></div>');
        $('.container-fluid').append(arr.join(''));
        $('#popover-' + instance.tid).on('click', function (event) {
          HChtHelper.Common.stopPropagation(event);
        })
      }
      var event = ev || window.event;
      var tar = event.srcElement || event.target;
      if (event.button == 2 || (tar.nodeName != 'TD' && $(tar).closest('td').length == 0 && $(tar).closest('#popover-' + instance.tid).length == 0 && tar.className != 'hthelper-popover-p')) {
        $('#popover-' + instance.tid).hide();
        return;
      }
      let coord = priv.findPosition(td, 'body');
      if (html.length == 0) {
        $('#popover-' + instance.tid).hide();
      } else {
        $popover = $('#popover-' + instance.tid);
        var h = $popover.height();
        var w = $popover.width();
        var tw = $(td).width();
        $popover.css({
          'position': 'absolute',
          'top': coord[1] - h + 31 + 'px',
          'left': coord[0] - (w - tw) / 2 + 'px'
        }).show();
      }
    }
    /**
     * 获取table结构的列的属性名称
     * @param {Int} col 列下标
     * return 当前列的属性名称 例如：xxx.name
     */
    this.getProp = function (col) {
      return instance.handsontable.colToProp(col);
    }


    /**
     * 重置下拉框的值。
     *
     */
    this.getOption = function (arr, obj) {
      if (arr) {
        if (arr.indexOf(',') > -1) {
          arr = arr.split(',');
        }
        obj.length = 0;
        for (var i = parseInt(arr[0]); i <= parseInt(arr[1]); i++) {
          obj.options.add(new Option(i, i));
        }
      }
    }

    /**
     * 映射出一个和table行列相同的JSON数组出来，用于存储工具栏里面的所有内容
     *
     */
    this.settings = function () {
      return instance.GridSettings;
    }

    /**
     * 验证是否必须选中单元格 成功返回true
     * @param {String} cells 类型
     */
    this.getCells = function (cells) {
      var flag = true;
      var corners = instance.handsontable.getSelected();
      if (!cells) {
        flag = false;
        alert('选择单元格分类有误！');
      }
      if (cells == 'many') {
        if (corners == undefined) {
          flag = false;
          alert('未选择单元格');
        };
      } else if (cells == 'one') {
        if (corners == undefined) {
          flag = false;
          alert('未选择单元格');
          return flag;
        };
        if (corners[0] != corners[2] || corners[1] != corners[3]) {
          flag = false;
          alert('无法查看多个单元格格式，请选择单个单元格！');
        }
      }
      return flag;
    }
  }
  /**
   * 生成tabs 创建html 绑定事件
   * @param {Object} instance hchthelper对象
   */
  HChtHelper.TCHB = function (instance) {
    this.Tabs = new HChtHelper.Tabs(instance);
    this.priv = null;
    this.obj = null;
    this.identity = null;
    this.target = null;
    this.pid = null;
    this.createHtml = null;
    this.init = function () {
      var target = $(this.obj).data('target') || this.target;
      var pid = $(this.obj).parent().data('id') || this.pid;
      this.identity = pid;
      if (document.getElementById(target + '-' + pid + '-' + instance.tid) == null) {
        this.Tabs.Class = 'hthelper-layer _hthelper-tabs _hthelper-layer hthelper-popup';
        this.Tabs.barClass = 'hthelper-layer-bar _hthelper-layer-bar hthelper-drag';
        this.Tabs.contClass = 'hthelper-layer-cont _hthelper-layer-cont';
        this.Tabs.identity = target + '-' + pid;
        this.Tabs.tag = 'div[data-id="' + pid + '"].append';
        this.Tabs.target = target;
        this.Tabs.priv = this.priv;
        this.Tabs.init();
        this.bind(); //拖动
        this.createHtml && this.createHtml();
        this.afterInit && this.afterInit();
      }
      this.priv.fixedShow(this.obj, document.getElementById(target + '-' + pid + '-' + instance.tid));
      if (this.target == 'validitydata') {
        var corners = instance.handsontable.getSelected();
        if (corners[0] == corners[2] && corners[1] == corners[3]) {
          this.tabShow('show', target + '-' + pid);
        } else {
          this.tabShow('hide', target + '-' + pid);
        }
      }
    }

    /**
     * 绑定事件
     *
     */
    this.bind = function () {
      //拖动
      var Drag = new HChtHelper.Drag(instance);
      Drag.pnode = document.getElementById(this.Tabs.target + '-' + this.identity + '-' + instance.tid);
      Drag.obj = $(Drag.pnode).children('div.hthelper-drag')[0];
      Drag.init();
    }
    this.tabShow = function (type, identity) {
      if (type == 'show') {
        $('[data-id="tabs-' + identity + '-' + instance.tid + '"]').eq(0).click().end().eq(1).show();
      } else {
        $('[data-id="tabs-' + identity + '-' + instance.tid + '"]').eq(0).click().end().eq(1).hide();
      }
    }
  }
  /**
   * 小图标菜单栏目
   * @param {[type]} instance
   */
  HChtHelper.Mini = function (instance) {
    var obj = this;
    this.align = 'left'; //对齐方式
    this.Class = '';
    this.toolbar = [];
    this.identity = null;
    this.modal = function () {
      var instanceToolbar = $('#' + instance.identity + '-' + instance.tid);
      var flag = true;
      var strObj = this.tag.substring(0, this.tag.lastIndexOf('.'));
      var insert = this.tag.substring(this.tag.lastIndexOf('.'));
      var $tagObj = instanceToolbar.find(strObj);
      if (insert == '.before') {
        $tagObj.before(this.createHtml());
      } else if (insert == '.append') {
        $tagObj.append(this.createHtml());
      } else if (insert == '.html') {
        $tagObj.html(this.createHtml());
      } else if (insert == '.parent') {
        instance.rootElement.before(this.createHtml());
      } else {
        flag = false;
      }
      return flag;
    }
    this.init = function () {
      this.modal();
      var instanceToolbar = $('#' + instance.identity + '-' + instance.tid);
      if (instanceToolbar.find('.hthelper-minicontents').html() == '') {
        var miniMenu = instance.GridSettings.toolbar.miniMenu;
        var arr = [];
        if (miniMenu) {
          var icon = HChtHelper.Config.icon;
          var menus = HChtHelper.Config.menu;
          var Temp = new HChtHelper.Template(instance);
          Temp.Class = 'hthelper-box-mini _hthelper-box-mini ddz';
          Temp.cells = miniMenu;
          Temp.tag = 'div.hthelper-minicontents.append';
          Temp.autoTemplate = function () {
            var arr = [];
            var menus = HChtHelper.Config.menus;
            for (var i = 0, n = this.cells.length; i < n; i++) {
              var value = this.cells[i];
              arr.push('<a href="javascript:;" data-toggle="hthelper" data-title="' + menus[value] + '" data-target="' + this.cells[i] + '" data-cells="' + icon[value].allowCell + '" data-align="' + (icon[value].align || '') + '" class="ddz ht-box-items ht-box-' + value + '">');
              arr.push('<span class="ddz excel-icon e-icon-add e-icon-' + value + '"></span>');
              arr.push('</a>');
            }
            return arr.join('');
          }
          Temp.init();


          /*
          for(var i = 0, len = miniMenu.length; i < len; i++){
          	arr.push('<a class="title" data-target="'+this.toolbar[i]+'" href="javascript:;" hidefocus data-id="tabs-'+this.toolbar[i]+'-'+instance.tid+'">');

          	arr.push('<a href="javascript:;" data-toggle="hthelper" data-target="'+this.cells[i].target+'" data-cells="'+this.cells[i].allowCell+'" data-align="'+(this.cells[i].align||'')+'" class="ddz ht-box-items ht-box-'+this.cells[i].target+'">');
          	arr.push('<span class="ddz excel-icon e-icon-add e-icon-'+this.cells[i].target+'"></span></a>');
          }
          */
        }
      }
    }
    /**
     * 创建HTML
     */
    this.createHtml = function () {
      var arr = [],
        bar = [],
        cont = [],
        menus = HChtHelper.Config.menus;
      bar.push('<div data-type="tabs" class="' + this.Class + '" id="' + instance.identity + '-' + instance.tid + '">');

      cont.push('<div class="' + this.contClass + '" >');
      //cont.push('<div class="hthelper-contabs">');
      for (var i = 0, n = this.len; i < n; i++) {
        cont.push('<input type="hidden" data-subtarget="' + this.target + '" id="hidden-' + this.toolbar[i] + '-' + instance.tid + '"/>');
        cont.push('<div class="hthelper-cont" data-target="' + this.toolbar[i] + '" data-id="cont-' + this.identity + '-' + instance.tid + '"></div>');
      }
      //cont.push('</div>');
      cont.push('</div>');
      arr.push(bar.join(''));
      arr.push(cont.join(''));
      if (this.save && this.saveFlag) {
        arr.push('<div id="handle-' + this.identity + '-' + instance.tid + '" class="hthelper-handle _hthelper-handle">');
        arr.push('<input data-type="Confirm" value="确 定" class="hthelper-btn hthelper-submit" type="button"/>');
        arr.push('<span></span>');
        arr.push('<input data-type="Cancel" value="取 消" class="hthelper-btn hthelper-cancel" type="button"/>');
        arr.push('</div>');
      }
      return arr.join('');
    }
  }
  /**
   * tab切换代码 自动生成标签页及内容框
   * @param {Object} instance  hchthelper对象
   */
  HChtHelper.Tabs = function (instance) {
    var obj = this;
    this.toolbar = [];
    this.Class = '';
    this.barClass = '';
    this.contClass = '';
    this.len = this.toolbar.length;
    this.identity = null;
    this.objFlag = false;
    this.cssText = '';
    this.index = 0;
    this.tag = null;
    this.target = null;
    this.eventName = 'click';
    this.priv = null;
    this.saveFlag = true;
    this.save = null;
    this.drag = null;
    this.arrowTab = null;
    this.modal = function () {
      var instanceToolbar = $('#' + instance.identity + '-' + instance.tid);
      var flag = true;
      var strObj = this.tag.substring(0, this.tag.lastIndexOf('.'));
      var insert = this.tag.substring(this.tag.lastIndexOf('.'));
      var $tagObj = instanceToolbar.find(strObj);
      if (insert == '.before') {
        $tagObj.before(this.createHtml());
      } else if (insert == '.append') {
        $tagObj.append(this.createHtml());
      } else if (insert == '.html') {
        $tagObj.html(this.createHtml());
      } else if (insert == '.parent') {
        instance.rootElement.before(this.createHtml());
      } else {
        flag = false;
      }
      return flag;
    }
    this.init = function () {
      if (!this.objFlag) {
        if (!this.modal()) {
          return;
        };
        this.selected();
        this.bind();
        //保存/取消
        $('#handle-' + this.identity + '-' + instance.tid).children('input').on('click', function () {
          var type = $(this).data('type');
          if (type == 'Confirm')
            obj.save(this.identity);
          $('#' + obj.identity + '-' + instance.tid).hide();
        });
      } else {
        this.setDisplay();
      }
      this.objFlag = true;
    }
    /**
     * 创建HTML
     */
    this.createHtml = function () {
      var arr = [],
        bar = [],
        cont = [],
        menus = HChtHelper.Config.menus;
      bar.push('<div data-type="tabs" class="' + this.Class + '" id="' + this.identity + '-' + instance.tid + '">');
      bar.push('<div class="' + this.barClass + '" >');
      cont.push('<div class="' + this.contClass + '" >');
      //cont.push('<div class="hthelper-contabs">');
      for (var i = 0, n = this.len; i < n; i++) {
        bar.push('<a class="title" data-target="' + this.toolbar[i] + '" href="javascript:;" hidefocus data-id="tabs-' + this.identity + '-' + instance.tid + '">');
        bar.push(menus[this.toolbar[i]] + '</a>');
        if (this.toolbar[i] == 'save2') {
          bar.push('<span class="ddz fr hthelper--layerm e-icon-layermin"></span>');
        }
        cont.push('<input type="hidden" data-subtarget="' + this.target + '" id="hidden-' + this.toolbar[i] + '-' + instance.tid + '"/>');
        cont.push('<div class="hthelper-cont" data-target="' + this.toolbar[i] + '" data-id="cont-' + this.identity + '-' + instance.tid + '"></div>');
      }
      bar.push('</div>');
      //cont.push('</div>');
      cont.push('</div>');
      arr.push(bar.join(''));
      arr.push(cont.join(''));
      if (this.save && this.saveFlag) {
        arr.push('<div id="handle-' + this.identity + '-' + instance.tid + '" class="hthelper-handle _hthelper-handle">');
        arr.push('<input data-type="Confirm" value="确 定" class="hthelper-btn hthelper-submit" type="button"/>');
        arr.push('<span></span>');
        arr.push('<input data-type="Cancel" value="取 消" class="hthelper-btn hthelper-cancel" type="button"/>');
        arr.push('</div>');
      }
      return arr.join('');
    }
    this.selected = function () {
      $('[data-id="tabs-' + this.identity + '-' + instance.tid + '"]').removeClass('current').eq(this.index).addClass('current');
      $('[data-id="cont-' + this.identity + '-' + instance.tid + '"]').hide().eq(this.index).show();
      if (this.arrowTab instanceof Function) {
        this.arrowTab();
      }
    }
    this.bind = function () {
      //阻止冒泡
      $('[data-id="tabs-' + this.identity + '-' + instance.tid + '"]').on('mousedown', function (event) {
        HChtHelper.Common.stopPropagation(event);
      });
      $('[data-id="tabs-' + this.identity + '-' + instance.tid + '"]').on(this.eventName, function (event) {
        obj.index = $(this).index();
        obj.selected();
      });
      $('#saves-' + instance.tid).find('.hthelper--layerm').unbind().on('mousedown', function (event) {
        HChtHelper.Common.stopPropagation(event);
        if ($(this).hasClass('e-icon-layermin')) {
          $(this).removeClass('e-icon-layermin').addClass('e-icon-layermax');
          $('#saves-' + instance.tid).animate({
            height: "36px"
          }, 200);
        } else {
          $(this).removeClass('e-icon-layermax').addClass('e-icon-layermin');
          $('#saves-' + instance.tid).removeAttr('style').show()
        }
      })
    }
    this.setDisplay = function () {
      $('#tabs-' + this.identity + '-' + instance.tid).show();
    }

  }

  /**
   * 拖动代码
   * @param {Object} instance
   */
  HChtHelper.Drag = function (instance) {
    var userSelect = null;
    this.obj = null;
    this.pnode = null;
    this.init = function () {
      userSelect = getStyleName('user-select');
      drag(this.obj, this.pnode);
    }
    //拖拽功能
    function drag(o, pnode) {
      if (typeof o == 'string') {
        o = document.getElementById(o);
      }
      var active, startX, startY;
      o.onmousedown = function (e) {
        active = true;
        //this.style.cursor = 'move';
        $(this).addClass('hthelper-drag-active');
        var d = document;
        if (!e) e = window.event;
        onUnselect();
        startX = e.clientX - pnode.offsetLeft;
        startY = e.clientY - pnode.offsetTop;
        d.ondragstart = 'return false;';
        d.onselectstart = 'return false;';
        d.onselect = 'document.selection.empty();';

        if (o.setCapture) {
          o.setCapture();
        } else if (window.captureEvents) {
          window.captureEvents(Event.MOUSEMOVE | Event.MOUSEUP);
        }

        d.onmousemove = function (e) {
          if (!e) e = window.event;
          if (active) {
            var iL = e.clientX - startX;
            var iT = e.clientY - startY;
            var maxL = document.documentElement.clientWidth - pnode.offsetWidth;
            var maxT = document.documentElement.clientHeight - pnode.offsetHeight;
            iL = iL < 0 ? 0 : iL;
            iL = iL > maxL ? maxL : iL;
            iT = iT < 0 ? 0 : iT;
            iT = iT > maxT ? maxT : iT;
            pnode.style.left = iL + 'px';
            pnode.style.top = iT + 'px';
            pnode.style.right = 'auto';
            pnode.style.bottom = 'auto';
          }
        }

        d.onmouseup = function () {
          if (o.releaseCapture) {
            o.releaseCapture();
          } else if (window.captureEvents) {
            window.captureEvents(Event.MOUSEMOVE | Event.MOUSEUP);
          }
          d.onmousemove = null;
          d.onmouseup = null;
          d.ondragstart = null;
          d.onselectstart = null;
          d.onselect = null;
          //pnode.style.cursor = 'normal';
          $(o).removeClass('hthelper-drag-active');
          offUnselect();
          active = false;
        }
      }
    }
    //防止拖动时内容被选中
    var getStyleName = (function () {
      var prefixes = ['', '-ms-', '-moz-', '-webkit-', '-khtml-', '-o-'];
      var reg_cap = /-([a-z])/g;

      function getStyleName(css, el) {
        el = el || document.documentElement;
        var style = el.style,
          test;
        for (var i = 0, l = prefixes.length; i < l; i++) {
          test = (prefixes[i] + css).replace(reg_cap, function ($0, $1) {
            return $1.toUpperCase();
          });
          if (test in style) {
            return test;
          }
        }
        return null;
      }
      return getStyleName;
    })()

    function onUnselect() {
      if (typeof userSelect === 'string') {
        return document.documentElement.style[userSelect] = 'none';
      }
      document.unselectable = 'on';
      document.selectstart = function () {
        return false;
      }
    }

    function offUnselect() {
      if (typeof userSelect === 'string') {
        return document.documentElement.style[userSelect] = 'text';
      }
      document.unselectable = 'off';
      document.selectstart = null;
    }
  }
  /**
   * 多选组件
   * @param {Object} instance
   */
  HChtHelper.MultiSelect = function (instance) {
    this.tag = null;
    this.async = false;
    this.url = '';
    this.target = '';
    this.data = [];
    this.rootId = 1; //根结点
    this.dirNode = [];
    this.infoNode = [];
    this.cIndex = 0;
    this.timer = null;
    this.selJson = [
      [],
      [],
      [],
      []
    ]; //[[id],[title],[unitid],[unitName]]
    this.save = null;
    this.init = function () {
      var instanceToolbar = $('#' + instance.identity + '-' + instance.tid);
      var strObj = this.tag.substring(0, this.tag.lastIndexOf('.'));
      var insert = this.tag.substring(this.tag.lastIndexOf('.'));
      var $tagObj = instanceToolbar.find(strObj);
      if ($tagObj.html() == '') {
        this.identity = $tagObj.data('id').split('-').splice(1, 2).join('-');
        if (insert == '.before') {
          $tagObj.before(this.createHtml());
        } else if (insert == '.append') {
          $tagObj.append(this.createHtml());
        } else if (insert == '.html') {
          $tagObj.html(this.createHtml());
        }
        this.loadData({
          'id': this.rootId
        }); //加载初始化数据
        this.addDropDown(); //添加下拉菜单
        this.bind(); //绑定事件
      }
    }
    /**
     * 加载初始化数据列表
     */
    this.loadData = function (json) {
      //判断是否异步
      if (this.async) {
        this.data = this.ajaxReturnJsonList(this.url, json);
        this.addAsyncList(this.rootId, document.getElementById(instance.tid + '-' + this.target + '-ms-data'));
      } else {
        this.data = this.ajaxReturnJsonList(this.url, {});
        for (var i = 0; i < this.data.length; i++) {
          var json = this.data[i];
          if (json.isDir == '1') {
            this.dirNode.push(json);
          } else {
            this.infoNode.push(json);
          }
        }
        this.addDirectory(this.rootId); //加载目录
      }
    }
    /**
     * 添加目录
     */
    this.addDirectory = function (pid) {
      $('#' + instance.tid + '-' + this.target + '-ms-data').append(this.addList(pid));
    }

    /**
     * 添加列表
     */
    this.addList = function (pid) {
      var jsonList = this.data;
      var arr = [];
      var arr1 = this.selJson[0];
      for (var i = 0, n = jsonList.length; i < n; i++) {
        var json = jsonList[i];
        if (json.parentID == pid && arr1.indexOf(json.id) == -1) {
          arr.push('<li>');
          if (json.isDir == '1') {
            arr.push('<h3 data-id="' + json.id + '" data-pid="' + json.parentID + '"><i class="excel-icon e-icon-arrow-right ddz"></i><span>' + json.title + '</span></h3>');
            arr.push('<ul data-id="' + json.id + '">');
            arr.push(this.addList(json.id));
            arr.push('</ul>');
          } else {
            arr.push('<a href="javascript:;" data-unitid="' + json.unitId + '" data-unitName="' + json.unitName + '" data-dir="' + json.isDir + '" data-id="' + json.id + '" data-pid="' + json.parentID + '">' + json.title + '</a>');
          }
          arr.push('</li>');
        }
      }
      return arr.join('');
    }
    /**
     * 异步加载
     * @param {String} pid
     * @param {Object} _this   ul对象
     */
    this.addAsyncList = function (pid, _this) {
      if ($(_this).html() != '') {
        return;
      }
      var jsonList = this.rootId == pid ? this.data : this.ajaxReturnJsonList(this.url, {
        'id': pid
      });
      var arr = [];
      var arr1 = this.selJson[0];
      for (var i = 0, n = jsonList.length; i < n; i++) {
        var json = jsonList[i];
        if (json.parentID == pid && arr1.indexOf(json.id) == -1) {
          arr.push('<li>');
          if (json.isDir == '1') {
            arr.push('<h3 data-id="' + json.id + '" data-pid="' + json.parentID + '"><i class="excel-icon e-icon-arrow-right ddz"></i><span>' + json.title + '</span></h3>');
            arr.push('<ul data-id="' + json.id + '"></ul>');
          } else {
            arr.push('<a href="javascript:;" data-unitid="' + json.unitId + '" data-unitName="' + json.unitName + '" data-dir="' + json.isDir + '" data-id="' + json.id + '" data-pid="' + json.parentID + '">' + json.title + '</a>');
          }
          arr.push('</li>');
        }
      }
      $(_this).html(arr.join(''));
    }
    /**
     * 设置指标单位
     *
     */
    this.getZbUnit = function () {
      if (this.target == 'zb') {
        var arr = [];
        arr.push('<i class="excel-icon ddz e-icon-arrow-bottom fr hthelper-unit"></i>');
        $('#' + instance.tid + '-' + this.target + '-ms-seldata').find('a:last').append(arr.join(''));
      }
    }
    /**
     * 添加下拉菜单
     */
    this.addDropDown = function () {
      var jsonList = (this.async) ? this.data : this.dirNode;
      var obj = this;
      var dom_sel = document.getElementById(instance.tid + '-' + this.target + '-ms-select');
      dom_sel.options.add(new Option('显示全部', this.rootId));
      for (var i = 0, n = jsonList.length; i < n; i++) {
        if (jsonList[i].isDir == '1') {
          if (jsonList[i].parentID == this.rootId) {
            dom_sel.options.add(new Option(jsonList[i].title, jsonList[i].id))
            for (var j = 0; j < jsonList.length; j++) {
              if (jsonList[i].id == jsonList[j].parentID && jsonList[j].isDir == 1) {
                dom_sel.options.add(new Option('--' + jsonList[j].title, jsonList[j].id));
              }
            }
          }

        }
      }
    }
    /**
     * 绑定下拉菜单事件
     */
    this.createHtmlDropDown = function () {
      var dom_sel = document.getElementById(instance.tid + '-' + this.target + '-ms-select');
      var value = dom_sel.options[dom_sel.selectedIndex].value;
      if (this.async) {
        var ul = document.getElementById(instance.tid + '-' + this.target + '-ms-data');
        ul.innerHTML = '';
        this.addAsyncList(value, ul);
      } else {
        $('#' + instance.tid + '-' + this.target + '-ms-data').html(this.addList(value), []);
      }
    }
    /**
     * 返回ajax数据
     * @param  {String} url
     */
    this.ajaxReturnJsonList = function (url, data) {
      var json = "";
      $.ajax({
        url: url,
        type: "post",
        dataType: "json",
        data: data,
        async: false,
        success: function (result) {
          json = result;
        }
      });
      return json;
    }
    /**
     * 创建列表
     */
    this.createHtml = function () {
      var arr = [];
      arr.push('<div class="hthelper-subcont clearfix">');
      arr.push('<div class="hthelper-selector"><label for="1" data-target="hthelper-selector" class="hthelper-selector-lbl"><input type="radio" class="htcheck dis-none" name="r" title="横向" /><input type="radio" class="htcheck dis-none" name="r" title="竖向"/></label><label data-target="hthelper-selector" class="hthelper-selector-lbl"><input type="checkbox" class="htcheck dis-none" title="填充标题" /></label>');
      if (this.target != 'zb')
        arr.push('<label data-target="hthelper-selector" class="hthelper-selector-lbl"><input type="checkbox" title="允许多选" class="htcheck dis-none"/></label>');
      arr.push('</div>');
      arr.push('<div class="hthelper-ms _hthelper-ms clearfix">');
      arr.push('<div class="hthelper-ms-list _hthelper-ms-list">');
      arr.push('<div class="hthelper-ms-header"><input id="' + instance.tid + '-' + this.target + '-key" type="text" placeholder="请输入关键字"/></div>');
      arr.push('<div class="hthelper-ms-main">');
      arr.push('<div class="hthelper-ms-type">选择分类：<select id="' + instance.tid + '-' + this.target + '-ms-select" class="hthelper-ms-txt hthelper-ms-select"></select><a href="javascript:;" id="' + instance.tid + '-' + this.target + '-ms-all" class="hthelper-ms-all">全选</a></div>');
      arr.push('<ul id="' + instance.tid + '-' + this.target + '-ms-data" class="hthelper-ms-data _hthelper-ms-data"></ul>');
      arr.push('</div>');
      arr.push('</div>');
      arr.push('<div class="hthelper-ms-list hthelper-ms-sel _hthelper-ms-sel">');
      arr.push('<div class="hthelper-ms-header"><a href="javascript:;" id="' + instance.tid + '-' + this.target + '-ms-clearall" class="hthelper-ms-all fr">全部清空</a>已选择（单击清空）</div>');
      arr.push('<ul class="hthelper-ms-seldata _hthelper-ms-seldata _hthelper-ms-data" id="' + instance.tid + '-' + this.target + '-ms-seldata"></ul>');
      arr.push('</div>');
      arr.push('</div>');
      arr.push('<div id="handle-' + this.identity + '-' + instance.tid + '" class="hthelper-handle _hthelper-handle"><input data-type="Confirm" value="确 定" class="hthelper-btn hthelper-submit" type="button"><span></span><input data-type="Cancel" value="取 消" class="hthelper-btn hthelper-cancel" type="button"></div>');
      arr.push('</div>');
      return arr.join('');
    }
    /**
     * 设置选中项的值
     * return String
     */
    this.setSelectData = function (jsonList) {
      var arr = [];
      for (var i = 0; i < jsonList.length; i++) {
        var json = jsonList[i];
        arr.push('<li><a class="' + (i % 2 == 1 ? 'odd' : '') + '" href="javascript:;" data-id="' + json.id + '" data-pid="' + json.parentID + '" data-unitid="' + json.unitId + '" data-unitName="' + json.unitName + '" data-isDir="' + json.isDir + '"><span class="title ddz">' + json.title + '</span></a></li>');
        this.set(json.id, json.title, json.unitId, json.unitName); //设置选中项的值
      }
      return arr.join('');
    }

    /**
     * 移除选中项的值
     * return String
     */
    this.removeSelectData = function (jsonList) {
      var arr = [];
      for (var i = 0; i < jsonList.length; i++) {
        var json = jsonList[i];
        arr.push('<li><a class="' + (i % 2 == 1 ? 'odd' : '') + '" href="javascript:;" data-id="' + json.id + '" data-pid="' + json.parentID + '" data-unitid="' + json.unitId + '" data-unitName="' + json.unitName + '" data-isDir="' + json.isDir + '">' + json.title + '</a></li>');
        this.remove(json.id); //设置选中项的值
      }
      return arr.join('');
    }
    /**
     * 保存选中项的值
     * @param {Number} id
     * @param {String} title
     */
    this.set = function (id, title, unitid, unitName) {
      var arr1 = this.selJson[0];
      var arr2 = this.selJson[1];
      arr1.push(id);
      arr2.push(title);
      if (this.target == 'zb') {
        this.selJson[2].push(unitid);
        this.selJson[3].push(unitName);
      }
    }
    /**
     * 判断是否已选中
     *
     */
    this.get = function (id) {
      var arr1 = this.selJson[0];
      return arr1.indexOf(id);
    }
    /**
     * 移除选中项的值
     */
    this.remove = function (id) {
      var arr1 = this.selJson[0];
      var arr2 = this.selJson[1];
      var index = arr1.indexOf(id);
      if (index > -1) {
        arr1.splice(index, 1);
        arr2.splice(index, 1);
        if (this.target == 'zb') {
          this.selJson[2].splice(index, 1);
          this.selJson[3].splice(index, 1);
        }
      }
    }

    /**
     * 列表目录单双击事件
     */
    this.listDirClick = function (_this) {
      var $ul = $(_this).siblings('ul');
      if (this.cIndex > 1) {
        $ul.find('a').click();
      } else {
        if ($ul.is(':hidden')) {
          $ul.show();
          $(_this).children('i').addClass('e-icon-arrow-bottom').removeClass('e-icon-arrow-right');
          if (this.async) {
            var pid = $(_this).data('id');
            this.addAsyncList(pid, $ul[0]);
          }
        } else {
          $ul.hide();
          $(_this).children('i').removeClass('e-icon-arrow-bottom').addClass('e-icon-arrow-right');
        }
      }
      this.cIndex = 0;
    }
    /**
     * 列表搜索
     */
    this.keyupSearch = function (_this) {
      var value = _this.value;
      this.loadData({
        'name': value
      });
    }
    /**
     * 绑定事件
     *
     */
    this.bind = function () {
      var obj = this;
      $('input.hthelper-sr').on('click', function () {
        var type = $(this).attr('type');
        if (type == 'checkbox') {
          if ($(this).hasClass('current')) {
            $(this).removeClass('current');
          } else {
            $(this).addClass('current');
          }
        } else if (type == 'radio') {
          var index = $(this).parent().find(this).index();
        }
      })

      var Selector = new HChtHelper.Selector(instance);
      Selector.init(); //美化选择器
      //搜索
      $('#' + instance.tid + '-' + this.target + '-key').on('keyup', function () {
        obj.keyupSearch(this);
      });
      //下拉事件
      $('#' + instance.tid + '-' + this.target + '-ms-select').on('change', function () {
        obj.createHtmlDropDown();
      })

      //全选
      $('#' + instance.tid + '-' + this.target + '-ms-all').on('click', function () {
        var arr = [];
        $('#' + instance.tid + '-' + obj.target + '-ms-data').find('a').click();
      })

      //列表目录单双击事件
      $('#' + instance.tid + '-' + this.target + '-ms-data').on('click', 'h3', function () {
        obj.cIndex += 1;
        if (obj.timer) {
          clearTimeout(obj.timer);
        }
        var _this = this;
        obj.timer = setTimeout(function () {
          obj.listDirClick(_this);
        }, 200);
      });

      //列表点击事件
      $('#' + instance.tid + '-' + this.target + '-ms-data').on('click', 'a', function () {
        var data = $(this).data();
        if (obj.get(data.id) == -1) {
          data.title = $(this).html();
          data.parentID = data.pid;
          data.unitId = data.unitid;
          data.unitName = data.unitname;
          $('#' + instance.tid + '-' + obj.target + '-ms-seldata').append(obj.setSelectData([data]));
          if (obj.target == 'zb') {
            obj.getZbUnit();
          }
          $(this).parent().remove();
        }
      });

      //已选点击事件
      $('#' + instance.tid + '-' + this.target + '-ms-seldata').on('click', 'a', function () {
        var data = $(this).data();
        data.parentID = data.pid;
        data.title = $(this).children('span').text();
        data.unitId = data.unitid;
        data.unitName = data.unitname;
        var $list = $('#' + instance.tid + '-' + obj.target + '-ms-data');
        if ($list.find('ul[data-id="' + data.pid + '"]').length > 0) {
          $list.find('ul[data-id="' + data.pid + '"]').append(obj.removeSelectData([data]));
        } else {
          $list.append(obj.removeSelectData([data]));
        }
        $(this).parent().remove();
      });

      //全部清空
      $('#' + instance.tid + '-' + this.target + '-ms-clearall').on('click', function () {
        $('#' + instance.tid + '-' + obj.target + '-ms-seldata').find('a').click();
      })

      //保存/取消
      if (this.save) {
        $('#' + obj.identity + '-' + instance.tid).on('click', 'input[type="button"]', function () {
          var type = $(this).data('type');
          if (type == 'Confirm')
            obj.save(obj.selJson, obj.target, obj.identity);
          $('#' + obj.identity + '-' + instance.tid).hide();

        })
      }

      if (obj.target == 'zb') {
        //隐藏单位弹出
        $('#' + instance.tid + '-' + this.target + '-ms-seldata').on('click', function () {
          $(this).find('div.hthelper-ms-unitlist').hide();
        });
        $('#' + instance.tid + '-' + this.target + '-ms-seldata').on('click', '.hthelper-unit', function (event) {
          if ($(this).siblings('div.hthelper-ms-unitlist').length == 0) {
            var unitid = $(this).parent().data('unitid');
            var unitList = obj.ajaxReturnJsonList('unit-selectForReport.action', {
              'id': unitid
            });
            var arr = [];
            if (unitList.data) {
              arr.push('<div class="hthelper-ms-unitlist _hthelper-ms-unitlist">');
              for (var i = 0, n = unitList.data.length; i < n; i++) {
                var json = unitList.data[i];
                arr.push('<p data-unitid="' + json.unitId + '">' + json.unitName + '</p>');
              }
              arr.push('</div>');
              $(this).parent().append(arr.join(''));
            }
          } else {
            $(this).siblings('div.hthelper-ms-unitlist').show();
          }
          HChtHelper.Common.stopPropagation(event);
        });

        //单位点击事件。
        $('#' + instance.tid + '-' + this.target + '-ms-seldata').on('click', 'div.hthelper-ms-unitlist p', function (event) {
          var uid = $(this).parent().hide().end().data('unitid');
          var uname = $(this).parent().hide().end().html();
          var index = $('#' + instance.tid + '-' + obj.target + '-ms-seldata').find('a').index($(this).parent().parent());
          obj.selJson[2][index] = uid;
          obj.selJson[3][index] = uname;
          HChtHelper.Common.stopPropagation(event);
        });
      }
    }
  }
  /**
   * 美化选择器
   *
   */
  HChtHelper.Selector = function (instance) {
    this.tag = '[data-target="hthelper-selector"]';
    this.init = function () {
      this.selector();
      this.bind();
    }
    /**
     * 选择器样式改变 label中不能同时出现单选或者多选 单选不同组请用多个label分开
     *
     */
    this.selector = function () {
      var instanceToolbar = $('#' + instance.identity + '-' + instance.tid);
      instanceToolbar.find(this.tag).each(function () {
        var $radio = $(this).find('input[type="radio"]');
        $radio.siblings('span[type="radio"]').remove();
        for (var i = 0; i < $radio.length; i++) {
          var $cradio = $radio.eq(i);
          var className = 'htcheck hthelper-sr';
          var guid = instance.guid(16, 8);
          var subtarget = $cradio.data('subtarget');
          if (i == 0) {
            className += ' hthelper-srl';
          }
          if (i == $radio.length - 1) {
            className += ' hthelper-srr';
          }
          $cradio.attr('data-guid', guid).hide();
          $cradio.parent().append('<span type="radio" data-subtarget="' + subtarget + '" data-guid="' + guid + '" name="' + $radio.eq(i).attr('name') + '" class="' + className + '">' + $radio.eq(i).attr('title') + '</span>')
        }

        var $cbk = $(this).find('input[type="checkbox"]');
        $cbk.siblings('span[type="checkbox"]').remove();
        for (var i = 0; i < $cbk.length; i++) {
          var className = 'htcheck hthelper-sr';
          var guid = instance.guid(8, 16);
          if (i == 0) {
            className += ' hthelper-srl';
          }
          if (i == $cbk.length - 1) {
            className += ' hthelper-srr';
          }
          $cbk.eq(i).attr('data-guid', guid).hide();
          $cbk.eq(i).parent().append('<span type="checkbox" data-guid="' + guid + '" class="' + className + '">' + $cbk.eq(i).attr('title') + '</span>');
        }
      })
    }
    /**
     * 绑定事件
     */
    this.bind = function () {
      var _this = this;
      var instanceToolbar = $('#' + instance.identity + '-' + instance.tid);
      instanceToolbar.find(this.tag).find('span.htcheck').on('click', function () {
        var type = this.getAttribute('type');
        var guid = $(this).data('guid');
        if (type == 'radio') {
          var name = this.getAttribute('name');
          $(this).siblings('input[type="radio"][name="' + name + '"]').prop('checked', false);
          $(this).siblings('input[type="radio"][data-guid="' + guid + '"]').prop('checked', true);
          $(this).siblings('span.htcheck[type="radio"][name="' + name + '"]').removeClass('current');
          $(this).addClass('current');
        } else if (type == 'checkbox') {
          $(this)[$(this).hasClass('current') ? 'removeClass' : 'addClass']('current');
        }

        if (_this.tabEvent instanceof Function) {
          _this.tabEvent(this);
        }
      })
    }
  }
  /**
   * 上传组件 input_hidden_type = 1 上报  = 2 表样管理
   * @param {[type]} instance 
   */
  HChtHelper.Uploder = function (instance) {
    this.uploader = null;
    this.layerer = null;
    this.init = function (_this) {
      var _self = this;
      if (this.uploader) {
        this.uploader.destroy()
      }
      var ih_id = $('#input_hidden_id').val() || '';
      var ih_type = $('#input_hidden_type').val() || '';
      if (typeof (app_root) == 'undefined') {
        app_root = '';
      }
      // this.uploader = WebUploader.create({
      //     // 选完文件后，是否自动上传。
      //     auto: true,
      //     // swf文件路径
      //     swf: app_root + '/Matrix-UI/plugin/webuploader/Uploader.swf',

      //     // 文件接收服务端。
      //     server: app_root+'/common-doUpload.action;jsessionid='+sessionid,
      //     formData:{'ih_id': ih_id,'ih_type': ih_type,"persist":false,"savepath":"/fileExcel"},
      //     // 选择文件的按钮。可选。
      //     // 内部根据当前运行是创建，可能是input元素，也可能是flash.
      //     pick: _this,
      //     fileNumLimit: 1, 
      //     // 只允许EXCEL表格文件。
      //     accept: {
      //         title: '',
      //         extensions: 'xls,xlsx',
      //         mimeTypes: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'//'*/*'
      //     },
      //     duplicate :true //允许重复上传
      // });

      // 当有文件添加进来的时候
      // this.uploader.on('fileQueued', function(file) {
      // 	this.layerer = layer.msg('数据上传中，请稍后...', {icon: 16, shade: 0.5});
      // 	/*
      //     var $li = $(
      //             '<div id="' + file.id + '" class="file-item thumbnail">' +
      //                 '<img>' +
      //                 '<div class="info">' + file.name + '</div>' +
      //             '</div>'
      //             ),
      //         $img = $li.find('img');


      //     // $list为容器jQuery实例
      //     $("#fileList").html('');
      //     $("#fileList").append( $li );

      //     // 创建缩略图
      //     // 如果为非图片文件，可以不用调用此方法。
      //     // thumbnailWidth x thumbnailHeight 为 100 x 100
      //     _self.uploader.makeThumb( file, function( error, src ) {
      //         if ( error ) {
      //             $img.replaceWith('<span>不能预览</span>');
      //             return;
      //         }
      //         $img.attr( 'src', src );
      //     }, 100, 100 );
      //     */
      // });

      // 文件上传过程中创建进度条实时显示。
      // this.uploader.on( 'uploadProgress', function( file, percentage ) {
      //     var $li = $( '#'+file.id ),
      //         $percent = $li.find('.progress span');

      //     // 避免重复创建
      //     if ( !$percent.length ) {
      //         $percent = $('<p class="progress"><span></span></p>')
      //                 .appendTo( $li )
      //                 .find('span');
      //     }

      //     $percent.css( 'width', percentage * 100 + '%' );
      // });

      // 文件上传成功，给item添加成功class, 用样式标记上传成功。
      // this.uploader.on( 'uploadSuccess', function( file,response  ) {
      // 	if(response.flag){
      //     		var json = response;
      //     		if(json.data){
      // 			/*
      // 			instance.initSettings(settings2);
      // 			instance.handsontable.mergeCells = null;
      // 			instance.handsontable.mergeCells = new Handsontable.MergeCells(json.mergeCells, instance.handsontable);
      // 			instance.handsontable.updateSettings(instance.GridSettings, true);
      // 			instance.handsontable.render();
      // 			*/
      // 			var jsonList = json.data;
      // 			if(ih_type == 1){
      // 				for(var i = 0, n = jsonList.length; i < n; i++){
      // 					var arr = jsonList[i];
      // 					var read = instance.map.getReadonly(arr.end_posi, arr.start_posi);
      // 					if(!eval(read)){
      // 						instance.map.setDataAtCell(arr.end_posi, arr.start_posi, arr.value);
      // 					}
      // 				}
      // 				instance.handsontable.render();
      // 			}
      // 			else if(ih_type == 2){
      // 				var data = HChtHelper.Common.loadTableData(json.totalRows,json.totalCols);
      // 				instance.initRule(data, 'styleData');
      // 				instance.initRule(data, 'ruleData');
      // 				for(var i = 0, n = jsonList.length; i < n; i++){
      // 					var arr = jsonList[i];
      // 					data[arr.end_posi][arr.start_posi] = arr.value;
      // 				}
      // 				var settings2 = {
      // 					'data'        : data,
      // 			    	'mergeCells'  : json.mergeCells,
      // 			    	'colWidths'   : (json.colWidth || ''),
      // 			    	'ruleData'	  : instance.GridSettings.ruleData,
      // 			    	'styleData'	  : instance.GridSettings.styleData,
      // 			    	'toolbar' 	  : instance.GridSettings.toolbar
      // 				};
      // 				instance.initSettings(settings2);
      // 				var tid = instance.tid;
      // 				var GSettings = JSON.stringify(instance.saveParams());
      // 				$(document).unbind();
      // 				//删除指标分组弹出框
      // 				if(instance.ps){
      // 					$('#'+instance.ps.config.id).parent().remove();
      // 				}
      // 				instance.rootElement.unbind().html('').data('hchthelper', null).data('handsontbale', null).siblings('div[data-type="tabs"]').remove();
      // 				$('#'+tid).HChtHelper(JSON.parse(GSettings));
      // 			}
      // 			layer.msg('上传成功', {icon:1});
      //     		}
      // 	}
      // 	else
      // 		layer.msg(response.msg, {icon:2})
      //     _self.uploader.removeFile(file);
      // });

      // 文件上传失败，显示上传出错。
      // this.uploader.on( 'uploadError', function( file ) {
      // 	layer.msg('上传失败', {icon:2});
      // });

      // 完成上传完了，成功或者失败，先删除进度条。
      // this.uploader.on( 'uploadComplete', function( file ) {
      // 	layer.close(this.layerer);
      //     //$( '#'+file.id ).find('.progress').remove();
      // });
    }
  }
  /**
   * 表单验证
   */
  HChtHelper.Validate = {
    /**
     * 筛选一部分数据出来 审核/验收 type = 1审核数据  type = 2 验收数据
     * @param  {String} stype	公式
     * @param  {Number} type	公式
     * @return {JSON}        	筛选出来的数据
     */
    getTypeScreening: function (stype, type) {
      var flag = false;
      if (stype === undefined && type == 1) { //审核
        flag = true;
      } else if ((stype == '0,0' || stype == '1,0' || stype == '1,1' || stype == '1') && type == 1) { //审核
        flag = true;
      } else if ((stype == '0,1' || stype == '1,1') && type == 2) { //验收
        flag = true;
      }
      return flag;
    },
    /**
     * 通用
     * @param {String}	value
     * @param {Array}	vdata
     * @param {Number}	row
     * @param {Number}	col
     * @param {String}	type
     * @param {String}	msg
     * @return JSON
     */
    getCommon: function (value, vdata, row, col, type, msg) {
      var json = {
          flag: 1,
          'gs': vdata,
          'coord': [row, col],
          'type': type
        },
        empty = eval(vdata[0]),
        examine = eval(vdata[1]),
        target = vdata[2],
        judge = vdata[3],
        str1 = eval(vdata[4]),
        str2 = eval(vdata[5]),
        value = Number(value) || value;
      if (target.toUpperCase() == 'ANY') {
        return json;
      }
      var flag = HChtHelper.Config.reg[target].test(value);
      if (!empty) { //是否忽略空值
        if ($.trim(value) == '' || value == 'undefined') {
          json.flag = 0;
          json.msg = json.err = HChtHelper.Config.menus[target] + '不能为空';
          if (examine) {
            json.flag = 2;
          }
          return json;
        }
      }
      if (target == 'length') { //判断文本长度
        if (empty && !value) { //忽略空值
          json.flag = 1;
        } else if (!flag) { //格式不对
          json.flag = 0;
          json.msg = json.err = msg || ('请输入' + HChtHelper.Config.menus[target]);
        } else if (judge != 'all') {
          value = value.toString();
          switch (judge) {
            case 'between': //介于
              if (str1 > value.length || str2 < value.length) {
                json.flag = 0;
                json.msg = json.err = msg || ('请输入介于(' + str1 + '~' + str2 + ')之间的' + HChtHelper.Config.menus[target]);
              }
              break;
            case 'notbetween': //未介于
              if (str1 < value.length || str2 > value.length) {
                json.flag = 0;
                json.msg = json.err = msg || ('请输入未介于(' + str1 + '~' + str2 + ')之间的' + HChtHelper.Config.menus[target]);

              }
              break;
            case 'equal': //等于
              if (value.length != str1) {
                json.flag = 0;
                json.msg = json.err = msg || (HChtHelper.Config.menus[target] + '等于(' + str1 + ')');
              }
              break;
            case 'notequal': //不等于
              if (value.length == str1) {
                json.flag = 0;
                json.msg = json.err = msg || (HChtHelper.Config.menus[target] + '不等于(' + str1 + ')');
              }
              break;
            case 'gt': //大于
              if (value.length <= str1) {
                json.flag = 0;
                json.msg = json.err = msg || (HChtHelper.Config.menus[target] + '大于(' + str1 + ')');
              }
              break;
            case 'lt': //小于
              if (value.length >= str1) {
                json.flag = 0;
                json.msg = json.err = msg || (HChtHelper.Config.menus[target] + '小于(' + str1 + ')');
              }
              break;
            case 'gtorequal': //大于或等于
              if (value.length < str1) {
                json.flag = 0;
                json.msg = json.err = msg || (HChtHelper.Config.menus[target] + '大于或等于(' + str1 + ')');
              }
              break;
            case 'ltorequal': //小于或等于
              if (value.length > str1) {
                json.flag = 0;
                json.msg = json.err = msg || (HChtHelper.Config.menus[target] + '小于或等于(' + str1 + ')');
              }
              break;
            default:
              json.flag = 0;
              json.msg = json.err = '未知错误，请刷新重试！';
              break;
          }
        } else {
          json.flag = 1;
        }
      } else {
        if (empty && !value) { //忽略空值
          json.flag = 1;
        } else if (!flag) { //格式不对
          json.flag = 0;
          json.msg = json.err = msg || ('请输入' + HChtHelper.Config.menus[target]);
        } else if (judge != 'all') {
          switch (judge) {
            case 'between': //介于
              if (str1 > value || str2 < value) {
                json.flag = 0;
                json.msg = json.err = msg || ('请输入介于(' + str1 + '~' + str2 + ')之间的' + HChtHelper.Config.menus[target]);

              }
              break;
            case 'notbetween': //未介于
              if (str1 < value || str2 > value) {
                json.flag = 0;
                json.msg = json.err = msg || ('请输入未介于(' + str1 + '~' + str2 + ')之间的' + HChtHelper.Config.menus[target]);

              }
              break;
            case 'equal': //等于
              if (value != str1) {
                json.flag = 0;
                json.msg = json.err = msg || (HChtHelper.Config.menus[target] + '等于(' + str1 + ')');
              }
              break;
            case 'notequal': //不等于
              if (value == str1) {
                json.flag = 0;
                json.msg = json.err = msg || (HChtHelper.Config.menus[target] + '不等于(' + str1 + ')');
              }
              break;
            case 'gt': //大于
              if (value <= str1) {
                json.flag = 0;
                json.msg = json.err = msg || (HChtHelper.Config.menus[target] + '大于(' + str1 + ')');
              }
              break;
            case 'lt': //小于
              if (value >= str1) {
                json.flag = 0;
                json.msg = json.err = msg || (HChtHelper.Config.menus[target] + '小于(' + str1 + ')');
              }
              break;
            case 'gtorequal': //大于或等于
              if (value < str1) {
                json.flag = 0;
                json.msg = json.err = msg || (HChtHelper.Config.menus[target] + '大于或等于(' + str1 + ')');
              }
              break;
            case 'ltorequal': //小于或等于
              if (value > str1) {
                json.flag = 0;
                json.msg = json.err = msg || (HChtHelper.Config.menus[target] + '小于或等于(' + str1 + ')');
              }
              break;
            default:
              json.flag = 0;
              json.msg = json.err = '未知错误，请刷新重试！';
              break;
          }
        } else {
          json.flag = 1;
        }
      }
      /**
       * flag = 0 表示 有错误        td背景 黄色 警告
         flag = 1 表示 审核通过      td无背景
         flag = 2 表示 必须审核      td背景 红色 审核不通过
       */
      if (examine && json.flag != 1) { //是否必须审核
        json.flag = 2;
      }
      return json;
    },
    /**
     * 自定义比较 函数
     */
    getFunc: function (json, settings) {
      function test2($1) {
        return eval($1).toFixed(6);
      }
      var func = json.func,
        cltFunc = json.func,
        calculation = func,
        note = json.note,
        examine = json.examine,
        reg = /[A-Za-z]+\d+/g,
        msgJson = {
          'flag': 1
        },
        coord = [];
      //老表中 可能没有type属性 没有type属性 默认是 审核公式
      if (json.type) {
        msgJson.type = json.type;
      }
      //跨表格计算
      if (func.indexOf('#') > -1) {
        var r = /#[A-z0-9]+/g;
        var r2 = /#[0-9]+/g;
        var arr2 = func.match(r);
        for (var i = 0, len = arr2.length; i < len; i++) {
          var it = arr2[i];
          var it2 = it.match(r2)[0];
          var it3 = it.replace(it2, '');
          var prev = it2.replace('#', 'prev');
          if (settings.prevDatas && settings.prevDatas[prev]) {
            var jsons = settings.prevDatas[prev].data;
            let coord = HChtHelper.Common.getExcelCharToArray(it3);
            //var value = jsons[coord[0]][coord[1]] || 0;
            var value = HChtHelper.Common.getDataAtCell(coord[0], coord[1], 0, jsons);
            func = func.replace(it, value);
            cltFunc = func.replace(it, value);
            calculation = func;
          } else {
            msgJson.msg = msgJson.err = '报表缺失，无法找到' + it2 + '报表数据';
            msgJson.flag = examine ? 2 : 0;
            msgJson.coord = HChtHelper.Common.getExcelCharToArray(it3);
            msgJson.note = json.note;
            return msgJson;
          }
        }
      }

      var arrs = func.match(reg);
      for (var i = 0, len = arrs.length; i < len; i++) {
        var arr = HChtHelper.Common.getExcelCharToArray(arrs[i]);
        if (i == 0) {
          coord = arr;
        }
        //var value = settings.data[arr[0]][arr[1]] || 0;
        var value = HChtHelper.Common.getDataAtCell(arr[0], arr[1], 0, settings.data);
        //value = HChtHelper.Common.setNumbertoFixed2(value);
        if (isNaN(value)) {
          cltFunc = cltFunc.replace(arrs[i], (value || 0));
          msgJson.coord = arr;
          msgJson.note = json.note;
          msgJson.msg = msgJson.err = '(' + json.func + ') 语法错误<br/>(' + cltFunc + ')';
          msgJson.flag = examine ? 2 : 0;
          break;
        }
        calculation = calculation.replace(arrs[i], eval((value || 0)));
        cltFunc = cltFunc.replace(arrs[i], eval((value || 0)));
      }
      if (i != arrs.length) {
        return msgJson;
      }
      try {
        calculation = calculation.replace(/--/g, '+'); //处理减去负数
        //函数两边出现四则运算, 把两边进行运算替换出运算结果再进行比较
        //防止运算JS计算结果出现.9999999999 .00000000001这种情况
        //必须先计算出括号出的集合 r4 避免while死循环,让它最多循环100次跳出
        var r4 = /\([\d.\d\+\-\*\/\%\\d.\d]+\)/g; //计算出括号中的集合
        var r4count = 0;
        var r4Arr = calculation.match(r4) || 0;

        while (r4Arr && r4Arr.length > 0 && r4count < 100) {
          for (var i = 0, len = r4Arr.length; i < len; i++) {
            var value = HChtHelper.CE.eval(r4Arr[i]);
            calculation = calculation.replace(r4Arr[i], value);
          }
          r4count++;
          r4Arr = calculation.match(r4) || 0;
        }
        var r5 = /[\d.\d\+\-\*\/\%\\d.\d]+/g;
        //calculation = calculation.replace(r5, test2);
        calculation = HChtHelper.Common.evalCalculation(calculation);
        if (!eval(calculation)) {
          msgJson.msg = msgJson.err = '(' + json.func + ') 函数未通过审核<br/>(' + cltFunc + ')';
          msgJson.flag = examine ? 2 : 0;
        }
      } catch (e) {
        msgJson.msg = msgJson.err = '(' + json.func + ') 语法错误<br/>(' + cltFunc + ')';
        msgJson.flag = examine ? 2 : 0;
      }
      msgJson.coord = coord;
      msgJson.note = json.note;
      return msgJson;
    },
    /**
     * 日期
     *
     */
    getDate2: function () {

    },
    /**
     * 文本长度
     *
     */
    getLength: function () {

    },
    /**
     * 电子邮箱
     *
     */
    getEmail: function () {

    },
    /**
     * 是否允许空值
     * @param {Boolean}
     */
    empty: function (empty) {
      var json = {};
      json.empty = empty ? 1 : 0;
      return json;
    },
    /**
     * 是否必须审核
     * @param {Boolean}  examine
     */
    examine: function (examine) {
      var json = {};
      json.examine = examine ? 1 : 0;
      return json;
    },
    emptyAndExamine: function (empty, examine) {
      return $.extend({}, this.empty(empty), this.examine(examine));
    },
    /**
     * 设置TD的title 显示错误信息
     * @param {JSON}     json  错误信息
     * @param {Object}   td    HTML JS对象
     */
    setTitle: function (json, td) {
      // flag = 0 警告  1 通过审核  2 错误
      if (json.flag == 0) {
        var msg = ''
        msg = '警告：' + json.msg + '\r\n';
        if (json.note) {
          msg += '备注：' + json.note + '\r\n';
        }
        td.title = msg;
        td.style.background = 'yellow';
      } else if (json.flag == 2) {
        var msg = '错误：' + json.err + '\r\n';
        if (json.note) {
          msg += '备注：' + json.note + '\r\n';
        }
        td.title = msg;
        td.style.background = 'red';
      } else {
        td.title = '';
      }
    },
    /**
     * 设置TD的title 显示错误信息
     */
    setFuncTitle: function (list, td) {
      // flag = 0 警告  1 通过审核  2 错误
      var msg = '',
        color = '';
      for (var i = 0, len = list.length; i < len; i++) {
        var json = list[i];
        if (json.flag == 0) {
          msg += '警告：' + json.msg + '\r\n';
          if (json.note) {
            msg += '备注：' + json.note + '\r\n';
          }
          color = 'yellow';
        } else if (json.flag == 2) {
          msg += '错误：' + json.msg + '\r\n';
          if (json.note) {
            msg += '备注：' + json.note + '\r\n';
          }
          color = 'red';
        } else {
          msg += '';
        }
      }
      td.style.backgroundColor = color;
      td.title = msg;
    },
    /**
     * 获取弹出验证规则错误信息 保存
     *
     */
    getValidateErrPopup: function () {}
  }

  /**
   * 用户权限
   * @param {Object} instance   hchthelper.core对象
   */
  HChtHelper.Power = function (instance) {
    /**
     * @param {Object} type
     */
    this.isUserPower = function (type) {
      var settings = instance.GridSettings;
      var corners = settings.power.coords || [-1, -1, -1, -1];
      var editCorners = instance.handsontable.getSelected();

      var flag = false;
      if (editCorners) {
        //按从小到大重新排列 行和列
        if (editCorners[0] > editCorners[2]) {
          editCorners[0] = (editCorners[2] + (editCorners[2] = editCorners[0]) * 0);
        }
        if (editCorners[1] > editCorners[3]) {
          editCorners[1] = (editCorners[3] + (editCorners[3] = editCorners[1]) * 0);
        }
        var power = settings.power || '';
        if (corners[2] >= editCorners[0] && type == "remove_row") {
          flag = true;
        } else if (corners[3] >= editCorners[1] && type == "remove_col") {
          flag = true;
        } else if (corners[2] >= editCorners[0] && corners[0] <= editCorners[0] && corners[3] >= editCorners[1] && corners[0] <= editCorners[1]) {
          flag = true;
        }
      }
      return flag;
    }
    this.msg = function (corners) {
      var start = HChtHelper.Common.getExcelNumToChar(corners[1] + 1);
      var end = HChtHelper.Common.getExcelNumToChar(corners[3] + 1);
      alert('对不起，您无权编辑坐标单元格' + start + (corners[0] + 1) + '~' + end + (corners[2]));
    }
  }
  /**
   * 自动生成工具栏所对应的模版
   * @param {Object} instance   hchthelper.core对象
   */
  HChtHelper.Template = function (instance) {
    //allowCell 是否允许单元格被选中 many one none
    this.cells = [];
    this.identity = instance.guid(8, 16);
    this.title = '';
    this.tag = null;
    this.load = null;
    this.Class = '';
    this.modal = function () {
      var flag = true;
      var strObj = this.tag.substring(0, this.tag.lastIndexOf('.'));
      var insert = this.tag.substring(this.tag.lastIndexOf('.'));
      var $tagObj = $('#' + instance.identity + '-' + instance.tid).find(strObj);
      if (insert == '.before') {
        $tagObj.before(this.createHtml());
      } else if (insert == '.append') {
        $tagObj.append(this.createHtml());
      } else if (insert == '.html') {
        $tagObj.html(this.createHtml());
      } else {
        flag = false;
      }
      return flag;
    }
    this.init = function () {
      this.modal();
    }
    this.createHtml = function () {
      var arr = [];
      arr.push('<div class="' + this.Class + '">'); //example-fun example-handle ddz fl clearfix
      arr.push('<div class="ddz hthelper-box-m" data-id="' + this.identity + '">' + this.autoTemplate() + '</div>');
      if (this.title) {
        arr.push('<p class="toolbar-title">' + this.title + '</p>');
      }
      arr.push('</div>');
      return arr.join('');
    }
    /**
     * 常用模版选择 重写则显示自定义方法
     *
     */
    this.autoTemplate = function () {
      var arr = [];
      var menus = HChtHelper.Config.menus;
      for (var i = 0, n = this.cells.length; i < n; i++) {
        var name = menus[this.cells[i].target];
        arr.push('<a href="javascript:;" data-title="' + name + '" data-toggle="hthelper" data-target="' + this.cells[i].target + '" data-cells="' + this.cells[i].allowCell + '" data-align="' + (this.cells[i].align || '') + '" class="ddz ht-box-items ht-box-' + this.cells[i].target + '">');
        arr.push('<span class="ddz excel-icon e-icon-' + this.cells[i].target + '"></span>');
        if (this.cells[i].istit !== false) {
          arr.push('<span class="title">' + name + '</span>');
        }
        if (this.cells[i].dropdown) {
          arr.push('<span class="ddz excel-icon e-icon-downarrow"></span>');
        }
        arr.push('</a>');
      }
      return arr.join('');
    }
  }
  /**
   * 通用方法
   */
  HChtHelper.Common = {
    /**
     * 比较计算用eval计算出来的结果不能保证准备
     * @return {[type]} [description]
     */
    evalCalculation: function (calculation) {
      var reg = /[+\-*/0-9\.]+/g;
      var arr = calculation.match(reg);
      var len = arr && arr.length || 0;
      var cal = calculation;
      for (var i = 0; i < len; i++) {
        var item = arr[i];
        var sum = HChtHelper.CE.eval(item);
        cal = cal.replace(item, sum);
      }
      return cal;
    },
    /**
     * 获取单元格的值
     * @param {Number} 	row 			行号
     * @param {Number} 	col 			列号
     * @param {String} 	defaultValue	默认值
     * @param {Array}	jsonList		数据源
     * @return {String}     
     */
    getDataAtCell: function (row, col, defaultValue, jsonList) {
      var value = '' || defaultValue;
      var sources = jsonList;
      try {
        value = sources[row][col] || defaultValue || 0;
      } catch (e) {
        var rowCount = sources.length;
        var msg = rowCount <= row ? '第' + (row + 1) + '行超出表格下标' : e.message;
        layer.msg(msg, {
          icon: 2
        });
      }
      return value;
    },
    /**
     * 合并单元格 转成 坐标
     * @param  {JSON} mergeCell 合并单元格  {row:1,col:1, rowspan:2, colspan:2}
     * @return {Array} [0,0,0,0]
     */
    getMergeCellToCoord: function (mergeCell) {
      let coord = null;
      if (mergeCell) {
        coord = [];
        coord[0] = mergeCell.row;
        coord[1] = mergeCell.col;
        coord[2] = coord[0] + (mergeCell.rowspan || 1) - 1;
        coord[3] = coord[1] + (mergeCell.colspan || 1) - 1;
      }
      return coord;
    },
    /**
     * 判断合并单元格 是否 包含在 选中单元格内
     * @param  {Array} mergeCell 	合并单元格中的项 {row:1,col:1, rowspan:2, colspan:2}
     * @param  {Array} coords 		选中单元格
     */
    getMergeCellBetweenCoords: function (mergeCell, coords) {
      var flag = null;
      let coord = this.getMergeCellToCoord(mergeCell);
      if (!coord) {
        return flag;
      }
      if (coords[0] <= coord[0] && coords[1] <= coord[1] && coords[2] >= coord[2] && coords[3] >= coord[3]) {
        flag = coord;
      }
      return flag;
    },
    /**
     * 阻止浏览器默认行为
     * @param {Object} e
     */
    stopPropagation: function (e) {
      e = e || window.event;
      if (e && e.stopPropagation) {
        e.stopPropagation();
      } else {
        e.cancelBubble = true;
      }
    },
    /**
     * 初始化table
     */
    loadTableData: function (row, col) {
      var arr = [];
      for (var i = 0; i < row; i++) {
        arr.push(new Array(col));
      }
      return arr;
    },
    /**
     * 生成table
     * @param {Object} settings
     */
    createTable: function (settings) {
      var arr = [],
        data = settings.data,
        styleData = settings.styleData,
        colWidths = settings.colWidths = [],
        mergeCells = settings.mergeCells || [];

      arr.push('<table class="ht-handsontable">');
      arr.push('<colgroup>');
      for (var i = 0, n = data[0].length; i < n; i++) {
        var width = colWidths[i] || 100;
        arr.push('<col style="width:' + width + 'px"/>');
      }
      arr.push('</colgroup>');
      arr.push('<tbody>');
      for (var i = 0, n = data.length; i < n; i++) {
        arr.push('<tr>');
        var json = data[i];
        for (var j = 0, y = json.length; j < y; j++) {
          arr.push('<td>' + (json[j] || '') + '</td>');
        }
        arr.push('</tr>');
      }
      arr.push('</tbody></table>');
      return arr.join('');
    },
    /**
     * excel表格序号转换成数字 下标为0
     * @param {String} value    A1,B1,AB12...
     */
    getExcelCharToNum: function (value) {
      var sum = 0;
      value = value.toString().toUpperCase();
      if (value.length > 1) {
        sum = (value.charCodeAt(value[0]) - 64) * 26 + value[1].charCodeAt(value[1]) - 64;
      } else {
        sum = value.charCodeAt(value) - 64;
      }
      return sum;
    },

    /**
     * excel数字转换成表格序号 下标为0
     * @param {Int} value    65,66,67...
     */
    getExcelNumToChar: function (value) {
      var str = '';
      value = parseInt(value);
      if (parseInt(value / 26) > 0) {
        str = String.fromCharCode(value / 26 + 64);
        if ((value + 1) % 26 == 1) {
          str += 'A';
        } else {
          str += String.fromCharCode(value % 26 + 64 + 1);
        }
      } else {
        value += 1;
        str += String.fromCharCode(value + 64);
      }
      return str;
    },

    /**
     * excel表格序号转换成坐标 下标为0
     * @param {String} value    A1,B1,AB12...
     * return [0, 0]   表格坐标  [行, 列]
     */
    getExcelCharToArray: function (value) {
      var str = value.match(/[A-Za-z]+/g).join('');
      var num = value.match(/\d+/g).join('');
      var sum = 0;
      str = str.toString().toUpperCase();
      if (str.length > 1) {
        sum = (str.charCodeAt(str[0]) - 64) * 26 + str[1].charCodeAt(str[1]) - 64;
      } else {
        sum = str.charCodeAt(str) - 64;
      }
      return [num - 1, sum - 1];
    },

    /**
     * excel数组下标转换成表格序号 下标为0
     * @param {Array} value    [0, 0]  [行, 列]
     * return A1  表格序号
     */
    getExcelArrayToChar: function (value) {
      var str = '';
      var col = value[1];
      //判断EXCEL列坐标是否出现两个及以上字母
      if (parseInt(col / 26) > 0) {
        var val = parseInt(col / 26);
        if (val > 26) {
          str = 'null';
        } else {
          str = String.fromCharCode(val + 64);
          if (col % 26 == 0) {
            str += 'A';
          } else {
            str += String.fromCharCode(col % 26 + 65)
          };
        }
      } else { //单个字母
        str = String.fromCharCode(col + 65);
      }
      return str + (value[0] + 1);
    },

    /**
     * 获取当前坐标，执行添加减少行列操作
     * @param {String} value    A1
     * @param {Number} row      添加减少行数
     * @param {Number} col      添加减少列数
     * return B1  表格序号
     */
    getExcelCharColumn: function (value, row, col) {
      var str = value.match(/[A-Za-z]+/g).join('');
      var num = value.match(/\d+/g).join('');
      var sum = 0;
      //字母转Unicode码
      str = str.toString().toUpperCase();
      if (str.length > 1) {
        sum = (str.charCodeAt(str[0]) - 64) * 26 + str[1].charCodeAt(str[1]) - 64;
      } else {
        sum = str.charCodeAt(str) - 64;
      }
      num = Number(num);
      num += (row || 0), str = '';
      sum = sum + (col || 0); //计算后再进行处理
      var he = sum + 64 - 90;
      if (he > 0) { //多位字母
        if (sum / 26 > 0) {
          var v = parseInt(sum / 26);
          var next = '';
          if (sum % 26 == 0) { //处理AZ、BZ、CZ....
            v = Math.max(--v, 1);
            next = 'Z';
          }
          str = String.fromCharCode(v + 64);
          str += (next || String.fromCharCode(sum % 26 + 64));
        }
      } else { //一位字母
        str = String.fromCharCode(sum + 64);
      }
      return str + num;
    },
    /**
     * 解析JSON中存储的style字段 返回文字说明
       索引0   只读       设置 0/1
       索引1   加粗       设置1加粗
       索引2   倾斜       设置1倾斜
       索引3   下划线     ......
       索引4   垂直对齐   设置为t=top,m=middle,b=bottom
       索引5   水平对齐   设置为l=left,c=center,r=right init
       索引6   字号       实际设置的值
       索引7   字体       ......
       索引8   文本颜色     ......
       索引9   背景色     ......
       索引10  边框       [border-width|border-style|border-color]
     * @param  {String} style
     * @return str
     */
    getStyleName: function (style) {
      var arr = [],
        str = '';
      if (style) {
        arr = style;
        if (arr[0]) {
          str += '只读&nbsp;';
        }
        if (arr[1]) {
          str += '加粗&nbsp;';
        }
        if (arr[2]) {
          str += '倾斜&nbsp;';
        }
        if (arr[3]) {
          str += '下划线&nbsp;';
        }
        if (arr[4] == 't') {
          str += '顶端对齐&nbsp;';
        }
        if (arr[4] == 'm') {
          str += '垂直居中&nbsp;';
        }
        if (arr[4] == 'b') {
          str += '底端对齐&nbsp;';
        }
        if (arr[5] == 'l') {
          str += '左对齐&nbsp;';
        }
        if (arr[5] == 'c') {
          str += '水平居中&nbsp;';
        }
        if (arr[5] == 'r') {
          str += '右对齐&nbsp;';
        }
        if (arr[6]) {
          str += '字号' + arr[6] + '&nbsp;';
        }
        if (arr[7]) {
          str += arr[7] + '&nbsp;';
        }
        if (arr[8] || arr[9]) {
          str += '<span style="color:' + arr[8] + ';background-color:' + arr[9] + '">颜色</span>&nbsp;';
        }
      }
      return str;
    },
    /**
     * 解析JSON中存储的format字段 返回文字说明
     * @param  {String} format
     * @return str
     */
    getFormatName: function (format) {
      var arr = [],
        str = '';
      var menus = HChtHelper.Config.menus;
      if (format) {
        arr = format.split(',');
        if (arr[0] == 'decimal') {
          str = menus[arr[0]] + '&nbsp;小数位' + arr[1];
        } else if (arr[0] == 'money') {
          str = menus[arr[0]] + '&nbsp;小数位' + arr[1];
        } else if (arr[0] == 'date') {
          str = menus[arr[0]] + '&nbsp;格式&nbsp;' + arr[2];
        } else if (arr[0] == 'abs') {
          str = menus[arr[0]];
        } else if (arr[0] == 'other2') {
          str = menus[arr[0]] + '&nbsp;' + (arr[2] == 1 ? '前缀' : '后缀') + '&nbsp;' + arr[1];
        } else if (arr[0] == 'tihuan') {
          str = arr[1] + menus[arr[0]] + '为' + arr[2];
        }
      }
      return str;
    },
    /**
     * 解析JSON中存储的vdata字段 返回文字说明 (数据有效性)
     * @param  {String} vdata
     * @return str
     */
    getVdataName: function (vdata) {
      var arr = [],
        str = '';
      var menus = HChtHelper.Config.menus;
      if (vdata && JSON.stringify(vdata) != '{}') {
        //"rule":{"vdata":{"vdata":"1,1,integer,all"  "vdata":{"vdata":"1,1,integer,between,1,111"
        arr = vdata.vdata.split(',');
        if (arr[0] == '1') {
          str += '忽略空值&nbsp;';
        }
        if (arr[1] == '1') {
          str += '必须审核&nbsp;';
        }
        str += (menus[arr[2]] || '') + '&nbsp;';
        str += (menus[arr[3]] || '') + '&nbsp;';
        if (arr[4]) {
          str += arr[4];
        }
        if (arr[5]) {
          str += '~' + arr[5];
        }
      }
      return str;
    },
    /**
     * 解析JSON中存储的func字段 返回文字说明 (数据有效性)
     * @param  {String} func
     * @return str
     */
    getFuncName: function (func) {
      var arr = [],
        str = '';
      var menus = HChtHelper.Config.menus;
      if (func && JSON.stringify(func) != '{}') {
        arr = func;
        for (var i = 0, len = arr.length; i < len; i++) {
          str += '函数:' + arr[i].func.replace('<', '&lt;') + '&nbsp;';
          str += (arr[i].examine ? '必审' : '') + '&nbsp;';
          if (arr[i].type == '1,1') {
            str += '审核&nbsp;验收&nbsp;';
          } else if (arr[i].type == '0,1') {
            str += '验收&nbsp;';
          } else {
            str += '审核&nbsp;';
          }
          str += (arr[i].note) ? '备注:' + arr[i].note + '<br/>' : '';
        }
      }
      return str;
    },
    /**
     * 解析JSON中存储的format字段 返回文字说明 (公式)
     * @param  {String} format
     * @return str
     */
    getFormulaName: function (formula) {
      var str = '';
      if (formula && JSON.stringify(formula) != '{}') {
        str = '公式:' + formula;
      }
      return str;
    },
    /**
     * 将表格选中坐标范围 A1:C3 解析成 单个单元格形式 以数组保存 [[0, 0],...,[2, 2]]
    	A1,A2,A3,B3	...
     * @param {String} str
     */
    setCoordRange: function (str) {
      var arr = [];
      str = str.toUpperCase();
      if (str.indexOf(':') > -1) {
        str = str.split(':');
        let coord = [];
        coord = coord.concat(this.getExcelCharToArray(str[0]), this.getExcelCharToArray(str[1]));
        for (var i = coord[0], len = coord[2]; i <= len; i++) {
          for (var j = coord[1], jLen = coord[3]; j <= jLen; j++) {
            arr.push([i, j]);
          }
        }
      } else if (str.indexOf(',') > -1) {
        str = str.split(',');
        for (var i = 0, len = str.length; i < len; i++) {
          arr.push(this.getExcelCharToArray(str[i]));
        }
      } else {
        arr.push(this.getExcelCharToArray(str));
      }
      return arr;
    },

    /**
     * JS计算出现长小数时 四舍五入
     * @param {Number} num 数值/数组
     * @param {Number} 小数位
     */
    setNumbertoFixed2: function (num, ind) {
      num = num.toString().replace(/ /g, '');
      var index = ind || 0;
      var numbers = [];
      //把num转换成数组
      if (num.toString().indexOf(',') > -1) {
        num = num.split(',');
      } else {
        num = [num]
      }
      //循环num数组
      for (var i = 0, len = num.length; i < len; i++) {
        var item = num[i];
        var str = '';
        //判断是否小数
        if (item.toString().indexOf('.') > -1) {
          var arr = item.toString().split('.')[1];
          arr = arr.match(/[0-9]+/g); //数组
          if (arr[0].length > 6) { //小数点后的数学字符串
            index = arr[0].length;
            for (var j = 0, jLen = arr[0].length; j < jLen; j++) {
              if (arr[0][j] == arr[0][j + 1] && arr[0][j + 1] == arr[0][j + 2]) {
                index = j;
                break;
              }
            }
            if (!isNaN(item)) {
              item = Number(item);
            }
            index = Math.min(index, 6);
            str = item.toFixed(index);
          } else {
            str = item;
          }
        } else {
          str = item;
        }
        numbers.push(str);
      }
      return numbers.toString();
    },
    /**
     * 解析函数
     * @param {String} 		formula
     * @param {Function} 	callback
     */
    setFormula: function (formulas, callback) {
      var newFormula = formulas;
      if (newFormula.indexOf('=') > -1) {
        newFormula = newFormula.substring(newFormula.indexOf('=') + 1);
        var reg = /[A-z]+[0-9]+/;
        var regx = /\$[A-z]+\$[0-9]+/g;
        var nfx = newFormula.match(regx);
        if (nfx && nfx.length > 0) {
          for (var i = 0, len = nfx.length; i < len; i++) {
            newFormula = newFormula.replace(nfx[i], nfx[i].replace(/\$/g, ''));
          }
        }
        while (reg.test(newFormula)) {
          var fname = '';
          var fexec = '';
          var arr = newFormula.match(/[A-z]+\(/g);
          if (arr) {
            var lastFormula = arr[arr.length - 1];
            var index = newFormula.lastIndexOf('(');
            var nextStr = newFormula.substring(index);
            var nextbrackets = nextStr.substring(0, nextStr.indexOf(')') + 1);
            //var nextFormula = newFormula.substr(index - (lastFormula.length - 1), lastFormula.length - 1);

            //获取函数名称
            fname = formulas.match(/=[A-z]+\(/);
            if (fname) {
              fname = fname[0].replace('=', '').replace('(', '');
            }
            fexec = nextbrackets;
            if (fname == 'RANK' || fname == 'IF') {
              fexec = formulas.match(/\(.*\)/).toString();

              var nfx = fexec.match(regx);
              if (nfx && nfx.length > 0) {
                for (var i = 0, len = nfx.length; i < len; i++) {
                  fexec = fexec.replace(nfx[i], nfx[i].replace(/\$/g, ''));
                }
              }
            }
          } else {
            fexec = newFormula;
          }

          var sum = this.switchFormula(fname, fexec, callback, formulas);
          while (newFormula.indexOf(fname + fexec) > -1) {
            newFormula = newFormula.replace(fname + fexec, sum);
          }

        }
      }
      return newFormula;
    },
    /**
     * [switchFormula ]
     * @param  {String}   funcname 函数名称
     * @param  {String}   fexec    公式
     * @param  {Function} callback 回调方法
     * @return {Number}
     */
    switchFormula: function (funcname, fexec, callback, formulas) {
      var sum = 0;
      var reg = /[A-z]+[0-9]+/;
      while (reg.test(fexec)) {
        var arrCoords = [];
        var r = /#[A-z0-9]+/g;
        if (fexec.indexOf(':') > -1) {
          arrCoords = fexec.match(/[A-z]+[0-9]+:[A-z]+[0-9]+/g);
        } else {
          arrCoords = fexec.match(/[A-z]+[0-9]+/g);
        }
        for (var i = 0, len = arrCoords.length; i < len; i++) {
          var arr = this.setCoordRange(arrCoords[i]); //[[1,1]]
          var numbers = [];
          for (var j = 0, jLen = arr.length; j < jLen; j++) {
            numbers.push(callback(arr[j]));
          }
          var number = this.setNumbertoFixed2(numbers.join(','), 5);
          fexec = fexec.replace(arrCoords[i], number);
          fexec = fexec.replace(/--/g, '+'); //处理减去负数
        }
      }
      //184.1+1536.6-1720.7
      switch (funcname) {
        case 'SUM':
          sum = eval(fexec.split(',').join('+'));
          break;
        case 'MIN':
          sum = eval('Math.min' + fexec);
          break;
        case 'MAX':
          sum = eval('Math.max' + fexec);
          break;
        case 'IF':
        case 'REP':
          fexec = fexec.replace(',', '?').replace(',', ':');
          sum = eval(fexec);
          break;
        case 'RANK':
          fexec = fexec.replace(/\(/g, '').replace(/\)/g, '').split(',');
          var current = fexec[0];
          formulas = formulas.substring(0, formulas.length - 1).split(',');
          var sort = 1;
          //当rank函数中 设置了排序(第三个字段0/1 1为正序 0为倒序) fexec的长度 - 1;
          if (!isNaN(formulas[formulas.length - 1])) {
            sort = Number(formulas[formulas.length - 1]);
            fexec.length = fexec.length - 1;
          }
          //数组去掉需要比较的单元格
          fexec.splice(0, 1);
          fexec.sort(function (a, b) {
            return Number(a) - Number(b);
          });
          if (sort == 0) {
            fexec.reverse();
          } //倒序
          sum = fexec.indexOf(current) + 1;
          break;
        case 'PRODUCT':
          sum = eval(fexec.split(',').join('*'));
          break;
        case 'AVERAGE':
          var arr = fexec.split(',');
          var len = arr.length;
          sum = (eval(fexec.split(',').join('+')) / len).toFixed(2);
          break;
        case 'COUNT':
          sum = fexec.split(',').length;
          break;
        case 'ABS':
          sum = Math.abs(eval(fexec));
          break;
        case '':
          sum = HChtHelper.CE.eval(fexec);
          break;
      }
      if (!isNaN(sum)) {
        sum = this.setNumbertoFixed2(sum, 2);
      }
      return sum;
    },
    /**
     * 替换特殊字符
     * @param {String} char
     * @param {String} old
     * @param {string} newVal
     * @return str
     */
    specialChar: function (char, old, newVal) {

    }
  }
  /**
   * 默认的配置文件
   *
   */
  HChtHelper.Config = {
    'menus': {
      'start': '开始',
      'save': '保存',
      'download': 'EXCEL下载',
      'print': '打印',
      'import48': '导入数据',

      'basics': '基础',
      'family': '字体',
      'size': '字号',
      'weight': '加粗',
      'tilt': '倾斜',
      'underlined': '下划线',
      'strike': '删除线',
      'bcolor': '背景色',
      'color': '文本颜色',
      'border': '边框',

      'top': '顶端对齐',
      'middle': '垂直居中对齐',
      'bottom': '底端对齐',
      'merge': '合并单元格',
      'left': '左对齐',
      'center': '水平居中对齐',
      'right': '右对齐',
      'unmerge': '拆分单元格',
      'zbgroup': '指标分组',
      // 'gongshi': '设置公式',
      'clearformat': '清除格式',
      'setformat': '设置格式',
      'checkformat': '查看格式',
      'allformat': '所有格式',
      'validitydata': '数据有效性',
      'autofetching': '自动取数',
      'otherfetching': '自定义取数',
      'import': '导入设置',
      'nf': '数字格式',
      'row': '行',
      'col': '列',
      'readonly': '设置只读',
      'clearreadonly': '取消只读',

      'chart': '图形',
      'bar': '柱形图',
      'line': '拆线图',
      'pie': '饼图',
      'bar2': '条形图',
      'area': '面积图',
      'scatter': '散点图',
      'other': '其它',

      'temp': '模版',
      'importdata': 'EXCEL导入',
      'fixed': '固定表头',
      'tableskin': '表格皮肤',
      'theight': '设置行高',

      'zb': '指标',
      'group': '分组',
      'qb': '期别',
      'area2': '区域',
      'contrast': '对比项',
      'datetime': '时间偏移量',
      'timecode': '期别',
      'indExplain': '指标解释',

      'number': '数字',

      'formatlist': '单元格格式',

      'aformatlist': '表格格式',

      'dformat': '比较函数',
      'func': '自定义函数',

      'autofzb': '指标值',
      'autoftq': '同期值',
      'autofother': '其它',
      'impcol': '导入模版对应列',

      'importdata2': '导入模版',
      'tableskin2': '表格皮肤',
      'theight2': '行高',


      'normal': '常规',
      'decimal': '数值',
      'money': '货币',
      'date': '日期',
      'other2': '自定义',
      'tihuan': '替换',

      'any': '任何值',
      'num': '数字',
      'integer': '整数',
      'decimal2': '小数',
      'date2': '日期',
      'length': '文本长度',
      'mobile': '手机号码',
      'phone': '电话号码',
      'email': '电子邮箱',
      'post': '邮政编码',
      'abs': '绝对值',

      'save2': '消息',

      'stretch': '拉伸',
      'hybrid': '混合',
      'stretch-all': '平铺',
      'last': '最后',
      'none': '还原',

      'columnnum': '表格序号',
      // 'randomtable'		: '不定长报表',
      'tablelist': '模板列表',
      'calculation'		: '手动计算',
      'rank': '排名',

      'copy': '复制',
      'paste': '粘贴',

      'align': '横向对齐',
      'vertical': '纵向对齐',
      'searchall': '搜索',

      'selector': '选择器',
      'checkbox': '多选框',
      'radio': '单选框',
      'calendar': '日历控件',
      'dropdown': '下拉框',
      'select2': 'select2',
      'commoncode': '常用代码',
      'industrycode': '行业代码',
      'registrationtype': '登记注册类型',
      'zoningcode_name': '行政区划代码(名称)',
      'commoncode_1': '行政区划代码(代码)',
      'countrycode': '国别码',
      'productcode': '产品代码(代码、名称、单位)',
      'dynamicdrop': '动态下拉框',
      'bzindustrycode': '标准行业代码',
      'ttindustrytype': '淘汰行业分类',
      'areaonlylower': '地区(只含下级)',
      'areaalllower': '地区(所有下级)',
      // 'webuploader' 		: '上传组件',

      'fulldate': 'yyyy/MM/dd',
      'cnfulldate': 'yyyy年MM月dd日',
      'cnyearmonth': 'yyyy年MM月',
      'minusfulldate': 'yyyy-MM-dd',
      'minusyearmonth': 'yyyy-MM',
      'minusyear': 'yyyy'


    },
    'icon': {
      'save': {
        'allowCell': 'none',
        istit: false
      },
      'download': {
        'allowCell': 'none',
        istit: false
      },
      'print': {
        'allowCell': 'none',
        istit: false
      },
      'import48': {
        'allowCell': 'none',
        istit: false
      },

      'weight': {
        'allowCell': 'none',
        istit: false
      },
      'tilt': {
        'allowCell': 'none',
        istit: false
      },
      'underlined': {
        'allowCell': 'none',
        istit: false
      },
      'strike': {
        'allowCell': 'none',
        istit: false
      },
      'bcolor': {
        'allowCell': 'none',
        'dropdown': true,
        istit: false
      },
      'color': {
        'allowCell': 'none',
        'dropdown': true,
        istit: false
      },
      'border': {
        'name': '边框',
        'allowCell': 'many',
        'dropdown': true,
        'istit': false
      },
      'bbottom': {
        'name': '下边框',
        'allowCell': 'many',
        'istit': false
      },
      'btop': {
        'name': '上边框',
        'allowCell': 'many',
        'istit': false
      },
      'bleft': {
        'name': '左边框',
        'allowCell': 'many',
        'istit': false
      },
      'bright': {
        'name': '右边框',
        'allowCell': 'many',
        'istit': false
      },
      'btopbottom': {
        'name': '上下边框',
        'allowCell': 'many',
        'istit': false
      },
      'bouter': {
        'name': '外边框',
        'allowCell': 'many',
        'istit': false
      },
      'bhouter': {
        'name': '水平和外边框',
        'allowCell': 'many',
        'istit': false
      },
      'ball': {
        'name': '全部边框',
        'allowCell': 'many',
        'istit': false
      },
      'bdoublebottom': {
        'name': '双下边框',
        'allowCell': 'many',
        'istit': false
      },
      'btopdoublebottom': {
        'name': '上边框和双下边框',
        'allowCell': 'many',
        'istit': false
      },
      'bweightbottom': {
        'name': '加粗下边框',
        'allowCell': 'many',
        'istit': false
      },
      'btopweightbottom': {
        'name': '上边框和加粗下边框',
        'allowCell': 'many',
        'istit': false
      },
      'bhorizontal': {
        'name': '水平边框',
        'allowCell': 'many',
        'istit': false
      },
      'bvertical': {
        'name': '垂直边框',
        'allowCell': 'many',
        'istit': false
      },
      'binside': {
        'name': '内边框',
        'allowCell': 'many',
        'istit': false
      },
      'bnone': {
        'name': '无边框',
        'allowCell': 'many',
        'istit': false
      },

      'zbgroup': {
        'allowCell': 'many',
        istit: false
      },
      // 'gongshi': {
      //   'allowCell': 'many',
      //   istit: false
      // },
      'clearformat': {
        'allowCell': 'many',
        'dropdown': true,
        istit: false
      },
      'setformat': {
        'allowCell': 'many',
        istit: false
      },
      'checkformat': {
        'allowCell': 'many',
        'align': 'bottom-center',
        istit: false
      },
      'allformat': {
        'allowCell': 'one',
        istit: false
      },
      'validitydata': {
        'allowCell': 'many',
        'align': 'bottom-right',
        istit: false
      },
      'autofetching': {
        'allowCell': 'one',
        'align': 'bottom-right',
        istit: false
      },
      'otherfetching': {
        'allowCell': 'many',
        'align': 'bottom-right',
        istit: false
      },
      'import': {
        'allowCell': 'one',
        'align': 'bottom-right',
        istit: false
      },
      'nf': {
        'allowCell': 'many',
        istit: false
      },
      'row': {
        'name': '行',
        'allowCell': 'many',
        'dropdown': true,
        'istit': false,
        'list': [{
          'target': 'insertprevrow'
        }, {
          'target': 'insertnextrow'
        }, {
          'target': 'insertlastrow'
        }, {
          'target': 'removerow'
        }]
      },
      'col': {
        'name': '列',
        'allowCell': 'many',
        'dropdown': true,
        'istit': false,
        'list': [{
          'target': 'insertleftcol'
        }, {
          'target': 'insertrightcol'
        }, {
          'target': 'removecol'
        }, {
          'target': 'colwidth'
        }]
      },
      'insertprevrow': {
        'name': '插入上一行',
        'allowCell': 'many'
      },
      'insertnextrow': {
        'name': '插入下一行',
        'allowCell': 'many'
      },
      'insertlastrow': {
        'name': '插入最后行',
        'allowCell': 'none'
      },
      'removerow': {
        'name': '删除行',
        'allowCell': 'many'
      },
      'insertleftcol': {
        'name': '插入左边列',
        'allowCell': 'many'
      },
      'insertrightcol': {
        'name': '插入右边列',
        'allowCell': 'many'
      },
      'removecol': {
        'name': '删除列',
        'allowCell': 'many'
      },
      'colwidth': {
        'name': '列宽',
        'allowCell': 'many'
      },
      'merge': {
        'allowCell': 'many',
        istit: false
      },
      'readonly': {
        'allowCell': 'many',
        istit: false
      },
      'clearreadonly': {
        'allowCell': 'many',
        istit: false
      },

      'bar': {
        'allowCell': 'many'
      },
      'line': {
        'allowCell': 'many'
      },
      'pie': {
        'allowCell': 'many'
      },
      'bar2': {
        'allowCell': 'many'
      },
      'area': {
        'allowCell': 'many'
      },
      'scatter': {
        'allowCell': 'many'
      },
      'other': {
        'allowCell': 'many'
      },

      'importdata': {
        'allowCell': 'none',
        istit: false
      },
      'fixed': {
        'allowCell': 'one',
        istit: false
      },
      'tableskin': {
        'allowCell': 'none',
        'align': 'bottom-right',
        istit: false
      },
      'theight': {
        'allowCell': 'none',
        'align': 'bottom-right',
        istit: false
      },

      'vertical': {
        'name': '纵向对齐',
        'allowCell': 'many',
        'dropdown': true,
        'istit': false,
        'list': [{
          'target': 'top'
        }, {
          'target': 'middle'
        }, {
          'target': 'bottom'
        }]
      },
      'top': {
        'name': '顶端对齐',
        'allowCell': 'many'
      },
      'middle': {
        'name': '垂直居中对齐',
        'allowCell': 'many'
      },
      'bottom': {
        'name': '底端对齐',
        'allowCell': 'many'
      },
      'align': {
        'name': '横向对齐',
        'allowCell': 'many',
        'dropdown': true,
        'istit': false,
        'list': [{
          'target': 'left'
        }, {
          'target': 'center'
        }, {
          'target': 'right'
        }]
      },
      'left': {
        'name': '左对齐',
        'allowCell': 'many'
      },
      'center': {
        'name': '水平居中对齐',
        'allowCell': 'many'
      },
      'right': {
        'name': '右对齐',
        'allowCell': 'many'
      },


      'stretch': {
        'allowCell': 'none',
        'iconFlag': false,
        'dropdown': true,
        istit: false
      },
      'hybrid': {
        'allowCell': 'none',
        'name': '混合',
        'target': 'hybrid'
      },
      'stretch-all': {
        'allowCell': 'none',
        'name': '平铺',
        'target': 'stretch-all'
      },
      'last': {
        'allowCell': 'none',
        'name': '最后',
        'target': 'last'
      },
      'none': {
        'allowCell': 'none',
        'name': '还原',
        'target': 'none'
      },

      'columnnum': {
        'allowCell': 'none',
        istit: false
      },
      // 'randomtable'      : {'allowCell':'none', istit:false},
      'tablelist': {
        'allowCell': 'none',
        istit: false
      },
      'calculation': {
        'allowCell': 'none',
        istit: false
      },
      'rank': {
        'allowCell': 'none',
        istit: false
      },

      'copy': {
        'allowCell': 'many',
        istit: false
      },
      'paste': {
        'allowCell': 'many',
        istit: false
      },

      'selector': {
        'allowCell': 'many',
        istit: false
      },
      'checkbox': {
        'name': '多选框',
        'allowCell': 'many'
      },
      'radio': {
        'name': '单选框',
        'allowCell': 'many'
      },
      'calendar': {
        'name': '日历控件',
        'allowCell': 'many',
        'list': [{
          'target': 'minusfulldate'
        }, {
          'target': 'minusyearmonth'
        }, {
          'target': 'minusyear'
        }]
      },
      'dropdown': {
        'name': '下拉框',
        'allowCell': 'many'
      },
      'select2': {
        'name': 'select2',
        'allowCell': 'many'
      },
      'commoncode': {
        'name': '常用代码',
        'allowCell': 'many',
        'list': [{
          'target': 'industrycode'
        }, {
          'target': 'registrationtype'
        }, {
          'target': 'zoningcode_name'
        }, {
          'target': 'commoncode_1'
        }, {
          'target': 'countrycode'
        }, {
          'target': 'productcode'
        }]
      },
      'industrycode': {
        'name': '行业代码',
        'allowCell': 'many'
      },
      'registrationtype': {
        'name': '登记注册类型',
        'allowCell': 'many'
      },
      'zoningcode_name': {
        'name': '行政区划代码(名称)',
        'allowCell': 'many'
      },
      'commoncode_1': {
        'name': '行政区划代码(代码)',
        'allowCell': 'many'
      },
      'countrycode': {
        'name': '国别码',
        'allowCell': 'many'
      },
      'productcode': {
        'name': '产品代码(代码、名称、单位)',
        'allowCell': 'many'
      },
      'dynamicdrop': {
        'name': '动态下拉框',
        'allowCell': 'many',
        'list': [{
          'target': 'bzindustrycode'
        }, {
          'target': 'ttindustrytype'
        }, {
          'target': 'areaonlylower'
        }, {
          'target': 'areaalllower'
        }]
      },
      'bzindustrycode': {
        'name': '标准行业代码',
        'allowCell': 'many'
      },
      'ttindustrytype': {
        'name': '淘汰行业分类',
        'allowCell': 'many'
      },
      'areaonlylower': {
        'name': '地区(只含下级)',
        'allowCell': 'many'
      },
      'areaalllower': {
        'name': '地区(所有下级)',
        'allowCell': 'many'
      },

      'searchall': {
        'allowCell': 'none',
        'align': 'bottom-center',
        istit: false
      },

      'date': {
        'name': '日期',
        'allowCell': 'many',
        'iconFlag': false,
        'dropdown': true,
        'list': [{
          'target': 'fulldate'
        }, {
          'target': 'cnfulldate'
        }, {
          'target': 'cnyearmonth'
        }]
      },
      'fulldate': {
        'name': 'yyyy/MM/dd',
        'allowCell': 'many',
        'icon': false
      },
      'cnfulldate': {
        'name': 'yyyy年MM月dd日',
        'allowCell': 'many',
        'icon': false
      },
      'cnyearmonth': {
        'name': 'yyyy年MM月',
        'allowCell': 'many',
        'icon': false
      },
      'minusfulldate': {
        'name': 'yyyy-MM-dd',
        'allowCell': 'many',
        'icon': false
      },
      'minusyearmonth': {
        'name': 'yyyy-MM',
        'allowCell': 'many',
        'icon': false
      },
      'minusyear': {
        'name': 'yyyy',
        'allowCell': 'many',
        'icon': false
      },
    },
    'list': {
      'family': ['宋体', '黑体', '微软雅黑', 'arial', 'Verdana', 'sans-serif'],
      'size': [12, 14, 16, 18, 20, 22, 24, 28, 32, 48, 72],
      'colors': ['#fff', '#000', '#1f497d', '#4f81bd', '#c0504d', '#9bbb59', '#8064a2', '#4bacc6', '#f79646', '#f2f2f2', '#f7f7f7', '#c6d9f0', '#dbe5f1', '#f2dcdb', '#ebf1dd', '#e5e0ec', '#fdeada', '#d8d8d8', '#595959', '#c4bd97', '#8db3e2', '#e5b9b7', '#d7e3bc', '#ccc1d9', '#b7dde8', '#fbd5b5', '#bfbfbf', '#3f3f3f', '#938953', '#548dd4', '#95b3d7', '#d99694', '#c3d69b', '#b2a2c7', '#92cddc', '#fac08f', '#a5a5a5', '#262626', '#494429', '#17365d', '#366092', '#953734', '#76923c', '#5f497a', '#31859b', '#e36c09', '#7f7f7f', '#0c0c0c', '#1d1b10', '#0f243e', '#244061', '#632423', '#4f6128', '#3f3151', '#205867', '#974806'],
      'standardColor': ['#c00000', '#ff0000', '#ffc000', '#ffff00', '#92d050', '#00b050', '#00b0f0', '#0070c0', '#002060', '#7030a0'],
      'borderStyle': ['solid', 'dotted', 'dashed', 'double'],
      'clearformat': [{
          'title': '清除指标分组',
          'target': 'ZBG'
        },
        {
          'title': '清除单元格格式',
          'target': 'S'
        },
        //{'title':'清除计算公式','target':'C'},
        {
          'title': '清除内容',
          'target': 'V'
        },
        //{'title':'清除自动取数','target':'AUTO'},
        //{'title':'清除数据格式','target':'FORMAT'},
        //{'title':'清除数据有效性','target':'VALIDITY'},
        //{'title':'清除单元格比较','target':'COMPARE'},
        //{'title':'清除自定义公式','target':'OTHER'},
        {
          'title': '清除单元格规则',
          'target': 'RULE'
        },
        {
          'title': '清除自定义取数',
          'target': 'unOTHERFETCHING'
        },
        {
          'title': '清除全部格式',
          'target': 'ALL'
        }
      ],
      'stretch': [ //hybrid, all, last, none
        //{'title':'混合','target':'hybrid'},
        {
          'title': '平铺',
          'target': 'stretch-all'
        },
        //{'title':'最后','target':'last'},
        {
          'title': '还原',
          'target': 'none'
        }
      ],
      'subclearformat': ['zb', 'group', 'area', 'contrast', 'datetime', 'timecode', 'indExplain'],
      'row': [{
          'title': '插入上一行',
          'target': 'insertprevrow'
        },
        {
          'title': '插入下一行',
          'target': 'insertnextrow'
        },
        {
          'title': '插入最后行',
          'target': 'insertlastrow'
        },
        {
          'title': '删除行',
          'target': 'removerow'
        }
      ],
      'col': [{
          'title': '添加左边列',
          'target': 'insertleftcol'
        },
        {
          'title': '添加右边列',
          'target': 'insertrightcol'
        },
        {
          'title': '删除列',
          'target': 'removecol'
        }
      ],
      'validity': [{
          'title': '不限',
          'target': 'all'
        },
        {
          'title': '介于',
          'target': 'between'
        },
        {
          'title': '未介于',
          'target': 'notbetween'
        },
        {
          'title': '等于',
          'target': 'equal'
        },
        {
          'title': '不等于',
          'target': 'notequal'
        },
        {
          'title': '大于',
          'target': 'gt'
        },
        {
          'title': '小于',
          'target': 'lt'
        },
        {
          'title': '大于或等于',
          'target': 'gtorequal'
        },
        {
          'title': '小于或等于',
          'target': 'ltorequal'
        }
      ],
      'nf': [{
          'title': '常规',
          'target': 'nf-normal',
          'value': ''
        },
        {
          'title': '数值',
          'target': 'nf-decimal',
          'value': 'decimal,2,'
        },
        {
          'title': '货币',
          'target': 'nf-money',
          'value': 'money,2,'
        },
        {
          'title': '日期',
          'target': 'nf-date',
          'value': 'date,,Default'
        }
      ],
      'theight': [20, 24, 28, 32, 36, 40, 44, 48, 72, 102],
      'border': [{
          'target': 'bbottom'
        },
        {
          'target': 'btop'
        },
        {
          'target': 'bleft'
        },
        {
          'target': 'bright'
        },
        {
          'target': 'btopbottom'
        },
        {
          'target': 'bouter'
        },
        {
          'target': 'bhouter'
        },
        {
          'target': 'ball'
        },
        {
          'target': 'bdoublebottom'
        },
        {
          'target': 'btopdoublebottom'
        },
        {
          'target': 'bweightbottom'
        },
        {
          'target': 'btopweightbottom'
        },
        {
          'target': 'bhorizontal'
        },
        {
          'target': 'bvertical'
        },
        {
          'target': 'binside'
        },
        {
          'target': 'bnone'
        }
      ]
    },
    'reg': {
      'any': /\s\S/,
      'num': /^\-?([\d]+|\-?([\d]+[.][\d]+))$/,
      'integer': /^(0|\-?[1-9][0-9]*)$/,
      'decimal2': /^\-?([\d]+[.][\d]+)$/,
      'date2': /^(\d{4})-(\d{1,2})-(\d{1,2})$/,
      'length': /^(\W||\w)*$/,
      'mobile': /^(13|15|17|18)\d{9}$/,
      'phone': /^((\(\d{2,3}\))|(\d{3}\-))?(\(0\d{2,3}\)|0\d{2,3}-)?[1-9]\d{6,7}(\-\d{1,4})?$/,
      'email': /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/,
      'post': /^[0-9]{6}$/
    }
  }

  $.fn.HChtHelper = function (action, excelFlag) {
    var i, ilen, args, output, userSettings, $this = this.first() // Use only first element from list
      ,
      instance = $this.data('hchthelper');
    // Init case
    if (typeof action !== 'string') {
      userSettings = action || {};
      if (instance) {
        $this.data('hchthelper', null);
        $this.siblings('[data-type="tabs"]').remove();
        $this.html('');
        instance = new HChtHelper.Core($this, userSettings);
        $this.data('hchthelper', instance);
        instance.init();
        //instance.updateSettings(userSettings, excelFlag);
      } else {
        instance = new HChtHelper.Core($this, userSettings);
        $this.data('hchthelper', instance);
        instance.init();
      }
      return $this;
    }
    // Action case
    else {
      args = [];
      if (arguments.length > 1) {
        for (i = 1, ilen = arguments.length; i < ilen; i++) {
          args.push(arguments[i]);
        }
      }

      if (instance) {
        if (typeof instance[action] !== 'undefined') {
          output = instance[action].apply(instance, args);
        } else {
          throw new Error('hchthelper do not provide action: ' + action);
        }
      }
      return output;
    }
  }
})(HChtHelper);

export {
  HChtHelper,sendGdpThistoHelper,sendDesignThistoHelper
}



//////////////////
// WEBPACK FOOTER
// ./static/handsontable/js/hc.handsontables.helper.js
// module id = Rg9g
// module chunks = 1